//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(null as any);
    }
}

@Injectable()
export class BillDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param billDetailId (optional) 
     * @param employeeId (optional) 
     * @return Success
     */
    assignSupervisorToService(billDetailId: number | undefined, employeeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/AssignSupervisorToService?";
        if (billDetailId === null)
            throw new Error("The parameter 'billDetailId' cannot be null.");
        else if (billDetailId !== undefined)
            url_ += "billDetailId=" + encodeURIComponent("" + billDetailId) + "&";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignSupervisorToService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignSupervisorToService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignSupervisorToService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    getExecutesBills(groupId: number | undefined): Observable<ExecutBillsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/GetExecutesBills?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExecutesBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExecutesBills(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExecutBillsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExecutBillsDto[]>;
        }));
    }

    protected processGetExecutesBills(response: HttpResponseBase): Observable<ExecutBillsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExecutBillsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExecutBillsDto[]>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return Success
     */
    startStep(stepId: number | undefined): Observable<OrderServiceStepsEntity> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/StartStep?";
        if (stepId === null)
            throw new Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderServiceStepsEntity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderServiceStepsEntity>;
        }));
    }

    protected processStartStep(response: HttpResponseBase): Observable<OrderServiceStepsEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderServiceStepsEntity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderServiceStepsEntity>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return Success
     */
    completeStep(stepId: number | undefined): Observable<OrderServiceStepsEntity> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/CompleteStep?";
        if (stepId === null)
            throw new Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderServiceStepsEntity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderServiceStepsEntity>;
        }));
    }

    protected processCompleteStep(response: HttpResponseBase): Observable<OrderServiceStepsEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderServiceStepsEntity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderServiceStepsEntity>(null as any);
    }

    /**
     * @param stepId (optional) 
     * @return Success
     */
    replayStep(stepId: number | undefined): Observable<OrderServiceStepsEntity> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/ReplayStep?";
        if (stepId === null)
            throw new Error("The parameter 'stepId' cannot be null.");
        else if (stepId !== undefined)
            url_ += "stepId=" + encodeURIComponent("" + stepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplayStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplayStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderServiceStepsEntity>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderServiceStepsEntity>;
        }));
    }

    protected processReplayStep(response: HttpResponseBase): Observable<OrderServiceStepsEntity> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderServiceStepsEntity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderServiceStepsEntity>(null as any);
    }

    /**
     * @param billDetailsId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getOrderServicesChecklistEntity(billDetailsId: number | undefined, serviceId: number | undefined): Observable<OrderServicesChecklistDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/GetOrderServicesChecklistEntity?";
        if (billDetailsId === null)
            throw new Error("The parameter 'billDetailsId' cannot be null.");
        else if (billDetailsId !== undefined)
            url_ += "billDetailsId=" + encodeURIComponent("" + billDetailsId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderServicesChecklistEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderServicesChecklistEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrderServicesChecklistDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrderServicesChecklistDto[]>;
        }));
    }

    protected processGetOrderServicesChecklistEntity(response: HttpResponseBase): Observable<OrderServicesChecklistDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OrderServicesChecklistDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderServicesChecklistDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrderServicesChecklistEntity(body: OrderServicesChecklistDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/UpdateOrderServicesChecklistEntity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrderServicesChecklistEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderServicesChecklistEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrderServicesChecklistEntity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param billDetailsId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    finishBillDetais(billDetailsId: number | undefined, serviceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/FinishBillDetais?";
        if (billDetailsId === null)
            throw new Error("The parameter 'billDetailsId' cannot be null.");
        else if (billDetailsId !== undefined)
            url_ += "billDetailsId=" + encodeURIComponent("" + billDetailsId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishBillDetais(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishBillDetais(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishBillDetais(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param orderServiceStepId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignEmployeesToStep(orderServiceStepId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/AssignEmployeesToStep?";
        if (orderServiceStepId === null)
            throw new Error("The parameter 'orderServiceStepId' cannot be null.");
        else if (orderServiceStepId !== undefined)
            url_ += "orderServiceStepId=" + encodeURIComponent("" + orderServiceStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignEmployeesToStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignEmployeesToStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignEmployeesToStep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param billDetailId (optional) 
     * @param serviceId (optional) 
     * @param body (optional) 
     * @return Success
     */
    assignEmployeesToService(billDetailId: number | undefined, serviceId: number | undefined, body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/AssignEmployeesToService?";
        if (billDetailId === null)
            throw new Error("The parameter 'billDetailId' cannot be null.");
        else if (billDetailId !== undefined)
            url_ += "billDetailId=" + encodeURIComponent("" + billDetailId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignEmployeesToService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignEmployeesToService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignEmployeesToService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param billDetailsId (optional) 
     * @return Success
     */
    getAssignedEmployeesToService(serviceId: number | undefined, billDetailsId: number | undefined): Observable<EmployeeNameDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/GetAssignedEmployeesToService?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        if (billDetailsId === null)
            throw new Error("The parameter 'billDetailsId' cannot be null.");
        else if (billDetailsId !== undefined)
            url_ += "billDetailsId=" + encodeURIComponent("" + billDetailsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedEmployeesToService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedEmployeesToService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeNameDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeNameDto[]>;
        }));
    }

    protected processGetAssignedEmployeesToService(response: HttpResponseBase): Observable<EmployeeNameDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeNameDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeNameDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BillDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDetailsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BillDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDetailsDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param billId (optional) 
     * @param serviceId (optional) 
     * @param executedBy (optional) 
     * @param revised (optional) 
     * @param finished (optional) 
     * @param startTime (optional) 
     * @param endTime (optional) 
     * @param note (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, billId: number | undefined, serviceId: number | undefined, executedBy: number | undefined, revised: boolean | undefined, finished: boolean | undefined, startTime: moment.Moment | undefined, endTime: moment.Moment | undefined, note: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BillDetailsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "BillId=" + encodeURIComponent("" + billId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (executedBy === null)
            throw new Error("The parameter 'executedBy' cannot be null.");
        else if (executedBy !== undefined)
            url_ += "ExecutedBy=" + encodeURIComponent("" + executedBy) + "&";
        if (revised === null)
            throw new Error("The parameter 'revised' cannot be null.");
        else if (revised !== undefined)
            url_ += "Revised=" + encodeURIComponent("" + revised) + "&";
        if (finished === null)
            throw new Error("The parameter 'finished' cannot be null.");
        else if (finished !== undefined)
            url_ += "Finished=" + encodeURIComponent("" + finished) + "&";
        if (startTime === null)
            throw new Error("The parameter 'startTime' cannot be null.");
        else if (startTime !== undefined)
            url_ += "StartTime=" + encodeURIComponent(startTime ? "" + startTime.toISOString() : "") + "&";
        if (endTime === null)
            throw new Error("The parameter 'endTime' cannot be null.");
        else if (endTime !== undefined)
            url_ += "EndTime=" + encodeURIComponent(endTime ? "" + endTime.toISOString() : "") + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDetailsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDetailsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BillDetailsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDetailsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDetailsDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBillDetailsDto | undefined): Observable<BillDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDetailsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BillDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDetailsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BillDetailsDto | undefined): Observable<BillDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDetailsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BillDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDetailsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillDetailsService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BillServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBill(body: CreateBillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/CreateBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processCreateBill(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFreeBill(body: CreateBillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/CreateFreeBill";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFreeBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFreeBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processCreateFreeBill(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @return Success
     */
    getBills(): Observable<BillDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetBills";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBills(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto[]>;
        }));
    }

    protected processGetBills(response: HttpResponseBase): Observable<BillDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BillDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param shiftId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFilteredBills(keyword: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, shiftId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetFilteredBills?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredBills(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetFilteredBills(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param shiftId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFilteredBills(keyword: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, shiftId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetAllFilteredBills?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFilteredBills(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFilteredBills(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetAllFilteredBills(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getBillDetails(billId: number | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetBillDetails?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processGetBillDetails(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getBillById(billId: number | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetBillById?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processGetBillById(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getBillDetailsWithStepsByBillId(billId: number | undefined): Observable<BillDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetBillDetailsWithStepsByBillId?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillDetailsWithStepsByBillId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillDetailsWithStepsByBillId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDetailsDto[]>;
        }));
    }

    protected processGetBillDetailsWithStepsByBillId(response: HttpResponseBase): Observable<BillDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(BillDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDetailsDto[]>(null as any);
    }

    /**
     * @param licencePlate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBillsByCustomerId(licencePlate: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetBillsByCustomerId?";
        if (licencePlate === null)
            throw new Error("The parameter 'licencePlate' cannot be null.");
        else if (licencePlate !== undefined)
            url_ += "licencePlate=" + encodeURIComponent("" + licencePlate) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBillsByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBillsByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetBillsByCustomerId(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param subscriptionId (optional) 
     * @param packageName (optional) 
     * @param packagePrice (optional) 
     * @param paymentMethodId (optional) 
     * @return Success
     */
    createSubscriptionBill(customerId: number | undefined, subscriptionId: number | undefined, packageName: string | undefined, packagePrice: number | undefined, paymentMethodId: number | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/CreateSubscriptionBill?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (packageName === null)
            throw new Error("The parameter 'packageName' cannot be null.");
        else if (packageName !== undefined)
            url_ += "packageName=" + encodeURIComponent("" + packageName) + "&";
        if (packagePrice === null)
            throw new Error("The parameter 'packagePrice' cannot be null.");
        else if (packagePrice !== undefined)
            url_ += "packagePrice=" + encodeURIComponent("" + packagePrice) + "&";
        if (paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' cannot be null.");
        else if (paymentMethodId !== undefined)
            url_ += "paymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubscriptionBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubscriptionBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processCreateSubscriptionBill(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    finishSubscriptionBill(billId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillService/FinishSubscriptionBill?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishSubscriptionBill(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishSubscriptionBill(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishSubscriptionBill(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param shiftId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, shiftId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BillDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BillDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: BillDto | undefined): Observable<BillDto> {
        let url_ = this.baseUrl + "/api/services/app/BillService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BillDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BillDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BillDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BillDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BillService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CarBrandServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCarBrandDto | undefined): Observable<CarBrandDto> {
        let url_ = this.baseUrl + "/api/services/app/CarBrandService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarBrandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarBrandDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CarBrandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarBrandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBrandDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CarBrandDto | undefined): Observable<CarBrandDto> {
        let url_ = this.baseUrl + "/api/services/app/CarBrandService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarBrandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarBrandDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CarBrandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarBrandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBrandDto>(null as any);
    }

    /**
     * @return Success
     */
    getCarBrands(): Observable<CarBrandDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CarBrandService/GetCarBrands";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarBrands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarBrandDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarBrandDto[]>;
        }));
    }

    protected processGetCarBrands(response: HttpResponseBase): Observable<CarBrandDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CarBrandDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBrandDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CarBrandDto> {
        let url_ = this.baseUrl + "/api/services/app/CarBrandService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarBrandDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarBrandDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CarBrandDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarBrandDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBrandDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CarBrandDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CarBrandService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarBrandDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarBrandDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CarBrandDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarBrandDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBrandDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CarBrandService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CarModelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCarModelDto | undefined): Observable<CarModelDto> {
        let url_ = this.baseUrl + "/api/services/app/CarModelService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CarModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CarModelDto | undefined): Observable<CarModelDto> {
        let url_ = this.baseUrl + "/api/services/app/CarModelService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CarModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelDto>(null as any);
    }

    /**
     * @return Success
     */
    getCarModels(): Observable<CarModelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CarModelService/GetCarModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarModels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarModels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelDto[]>;
        }));
    }

    protected processGetCarModels(response: HttpResponseBase): Observable<CarModelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CarModelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CarModelDto> {
        let url_ = this.baseUrl + "/api/services/app/CarModelService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CarModelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CarModelDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CarModelService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarModelDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarModelDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CarModelDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarModelDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarModelDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CarModelService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CommissionCalculationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param employeeIds (optional) 
     * @param commissionType (optional) 
     * @return Success
     */
    getAll(from: string | undefined, to: string | undefined, employeeIds: number[] | undefined, commissionType: number | undefined): Observable<CommissionCalculationDto> {
        let url_ = this.baseUrl + "/api/services/app/CommissionCalculationService/GetAll?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        if (employeeIds === null)
            throw new Error("The parameter 'employeeIds' cannot be null.");
        else if (employeeIds !== undefined)
            employeeIds && employeeIds.forEach(item => { url_ += "employeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (commissionType === null)
            throw new Error("The parameter 'commissionType' cannot be null.");
        else if (commissionType !== undefined)
            url_ += "commissionType=" + encodeURIComponent("" + commissionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommissionCalculationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommissionCalculationDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommissionCalculationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommissionCalculationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommissionCalculationDto>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @return Success
     */
    getEmployeeCommissionDetails(employeeId: number | undefined, from: string | undefined, to: string | undefined): Observable<EmployeeCommissionDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/CommissionCalculationService/GetEmployeeCommissionDetails?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent("" + from) + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent("" + to) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeCommissionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeCommissionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeCommissionDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeCommissionDetailDto>;
        }));
    }

    protected processGetEmployeeCommissionDetails(response: HttpResponseBase): Observable<EmployeeCommissionDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeCommissionDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeCommissionDetailDto>(null as any);
    }
}

@Injectable()
export class ConfigurationProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CurrencyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDto>(null as any);
    }

    /**
     * @param symbol (optional) 
     * @return Success
     */
    getAll(name: string, symbol: string | undefined): Observable<CurrencyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyService/GetAll?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (symbol === null)
            throw new Error("The parameter 'symbol' cannot be null.");
        else if (symbol !== undefined)
            url_ += "Symbol=" + encodeURIComponent("" + symbol) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CurrencyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CurrencyDto | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CurrencyDto | undefined): Observable<CurrencyDto> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CurrencyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrencyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CurrencyService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CustomerPhonesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getPhonesByCustomerId(customerId: number | undefined): Observable<CustomerPhonesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPhonesService/GetPhonesByCustomerId?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhonesByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhonesByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPhonesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPhonesDto[]>;
        }));
    }

    protected processGetPhonesByCustomerId(response: HttpResponseBase): Observable<CustomerPhonesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerPhonesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPhonesDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomerPhonesDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPhonesService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPhonesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPhonesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerPhonesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPhonesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPhonesDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param items (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, items: CustomerPhonesDto[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomerPhonesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPhonesService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (items === null)
            throw new Error("The parameter 'items' cannot be null.");
        else if (items !== undefined)
            items && items.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "Items[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPhonesDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPhonesDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerPhonesDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPhonesDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPhonesDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomerPhonesDto | undefined): Observable<CustomerPhonesDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPhonesService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPhonesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPhonesDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerPhonesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPhonesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPhonesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CustomerPhonesDto | undefined): Observable<CustomerPhonesDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPhonesService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerPhonesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerPhonesDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerPhonesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerPhonesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerPhonesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerPhonesService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomerDto | undefined): Observable<CustomerStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateCustomer(customerId: number | undefined, body: CustomerStatsDto | undefined): Observable<CustomerStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/UpdateCustomer?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto>;
        }));
    }

    protected processUpdateCustomer(response: HttpResponseBase): Observable<CustomerStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomerStatsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerStatsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerStatsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDtoPagedResultDto>(null as any);
    }

    /**
     * @param term (optional) 
     * @return Success
     */
    searchCustomers(term: string | undefined): Observable<CustomerStatsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/SearchCustomers?";
        if (term === null)
            throw new Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto[]>;
        }));
    }

    protected processSearchCustomers(response: HttpResponseBase): Observable<CustomerStatsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerStatsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCustomerById(id: number | undefined): Observable<CustomerStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/GetCustomerById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto>;
        }));
    }

    protected processGetCustomerById(response: HttpResponseBase): Observable<CustomerStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllCustomersForDropdownList(): Observable<CustomerStatsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/GetAllCustomersForDropdownList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomersForDropdownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomersForDropdownList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto[]>;
        }));
    }

    protected processGetAllCustomersForDropdownList(response: HttpResponseBase): Observable<CustomerStatsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerStatsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto[]>(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @return Success
     */
    getCustomerReport(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined): Observable<CustomerStatsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/GetCustomerReport?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto[]>;
        }));
    }

    protected processGetCustomerReport(response: HttpResponseBase): Observable<CustomerStatsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(CustomerStatsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto[]>(null as any);
    }

    /**
     * @param customerid (optional) 
     * @return Success
     */
    getCustomerDetailsReport(customerid: number | undefined): Observable<CustomerDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/GetCustomerDetailsReport?";
        if (customerid === null)
            throw new Error("The parameter 'customerid' cannot be null.");
        else if (customerid !== undefined)
            url_ += "Customerid=" + encodeURIComponent("" + customerid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerDetailsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerDetailsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDetailsDto>;
        }));
    }

    protected processGetCustomerDetailsReport(response: HttpResponseBase): Observable<CustomerDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDetailsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomerStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CustomerStatsDto | undefined): Observable<CustomerStatsDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerStatsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerStatsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerStatsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerStatsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerStatsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomerService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param customersStartDate (optional) 
     * @param customersEndDate (optional) 
     * @param employeesStartDate (optional) 
     * @param employeesEndDate (optional) 
     * @param salesYear (optional) 
     * @param serviceSalesStartDate (optional) 
     * @param serviceSalesEndDate (optional) 
     * @param serviceGroupId (optional) 
     * @param billsInfoStartDate (optional) 
     * @param billsInfoEndDate (optional) 
     * @param vehicleCreationStartTime (optional) 
     * @param vehicleCreationEndTime (optional) 
     * @param vehicleBrandSalesStartDate (optional) 
     * @param vehicleBrandSalesEndDate (optional) 
     * @param targetYear (optional) 
     * @param groupId (optional) 
     * @return Success
     */
    getDashboardData(customersStartDate: moment.Moment | undefined, customersEndDate: moment.Moment | undefined, employeesStartDate: moment.Moment | undefined, employeesEndDate: moment.Moment | undefined, salesYear: number | undefined, serviceSalesStartDate: moment.Moment | undefined, serviceSalesEndDate: moment.Moment | undefined, serviceGroupId: number | undefined, billsInfoStartDate: moment.Moment | undefined, billsInfoEndDate: moment.Moment | undefined, vehicleCreationStartTime: moment.Moment | undefined, vehicleCreationEndTime: moment.Moment | undefined, vehicleBrandSalesStartDate: moment.Moment | undefined, vehicleBrandSalesEndDate: moment.Moment | undefined, targetYear: number | undefined, groupId: number | undefined): Observable<DashboardDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetDashboardData?";
        if (customersStartDate === null)
            throw new Error("The parameter 'customersStartDate' cannot be null.");
        else if (customersStartDate !== undefined)
            url_ += "CustomersStartDate=" + encodeURIComponent(customersStartDate ? "" + customersStartDate.toISOString() : "") + "&";
        if (customersEndDate === null)
            throw new Error("The parameter 'customersEndDate' cannot be null.");
        else if (customersEndDate !== undefined)
            url_ += "CustomersEndDate=" + encodeURIComponent(customersEndDate ? "" + customersEndDate.toISOString() : "") + "&";
        if (employeesStartDate === null)
            throw new Error("The parameter 'employeesStartDate' cannot be null.");
        else if (employeesStartDate !== undefined)
            url_ += "EmployeesStartDate=" + encodeURIComponent(employeesStartDate ? "" + employeesStartDate.toISOString() : "") + "&";
        if (employeesEndDate === null)
            throw new Error("The parameter 'employeesEndDate' cannot be null.");
        else if (employeesEndDate !== undefined)
            url_ += "EmployeesEndDate=" + encodeURIComponent(employeesEndDate ? "" + employeesEndDate.toISOString() : "") + "&";
        if (salesYear === null)
            throw new Error("The parameter 'salesYear' cannot be null.");
        else if (salesYear !== undefined)
            url_ += "SalesYear=" + encodeURIComponent("" + salesYear) + "&";
        if (serviceSalesStartDate === null)
            throw new Error("The parameter 'serviceSalesStartDate' cannot be null.");
        else if (serviceSalesStartDate !== undefined)
            url_ += "ServiceSalesStartDate=" + encodeURIComponent(serviceSalesStartDate ? "" + serviceSalesStartDate.toISOString() : "") + "&";
        if (serviceSalesEndDate === null)
            throw new Error("The parameter 'serviceSalesEndDate' cannot be null.");
        else if (serviceSalesEndDate !== undefined)
            url_ += "ServiceSalesEndDate=" + encodeURIComponent(serviceSalesEndDate ? "" + serviceSalesEndDate.toISOString() : "") + "&";
        if (serviceGroupId === null)
            throw new Error("The parameter 'serviceGroupId' cannot be null.");
        else if (serviceGroupId !== undefined)
            url_ += "ServiceGroupId=" + encodeURIComponent("" + serviceGroupId) + "&";
        if (billsInfoStartDate === null)
            throw new Error("The parameter 'billsInfoStartDate' cannot be null.");
        else if (billsInfoStartDate !== undefined)
            url_ += "BillsInfoStartDate=" + encodeURIComponent(billsInfoStartDate ? "" + billsInfoStartDate.toISOString() : "") + "&";
        if (billsInfoEndDate === null)
            throw new Error("The parameter 'billsInfoEndDate' cannot be null.");
        else if (billsInfoEndDate !== undefined)
            url_ += "BillsInfoEndDate=" + encodeURIComponent(billsInfoEndDate ? "" + billsInfoEndDate.toISOString() : "") + "&";
        if (vehicleCreationStartTime === null)
            throw new Error("The parameter 'vehicleCreationStartTime' cannot be null.");
        else if (vehicleCreationStartTime !== undefined)
            url_ += "VehicleCreationStartTime=" + encodeURIComponent(vehicleCreationStartTime ? "" + vehicleCreationStartTime.toISOString() : "") + "&";
        if (vehicleCreationEndTime === null)
            throw new Error("The parameter 'vehicleCreationEndTime' cannot be null.");
        else if (vehicleCreationEndTime !== undefined)
            url_ += "VehicleCreationEndTime=" + encodeURIComponent(vehicleCreationEndTime ? "" + vehicleCreationEndTime.toISOString() : "") + "&";
        if (vehicleBrandSalesStartDate === null)
            throw new Error("The parameter 'vehicleBrandSalesStartDate' cannot be null.");
        else if (vehicleBrandSalesStartDate !== undefined)
            url_ += "VehicleBrandSalesStartDate=" + encodeURIComponent(vehicleBrandSalesStartDate ? "" + vehicleBrandSalesStartDate.toISOString() : "") + "&";
        if (vehicleBrandSalesEndDate === null)
            throw new Error("The parameter 'vehicleBrandSalesEndDate' cannot be null.");
        else if (vehicleBrandSalesEndDate !== undefined)
            url_ += "VehicleBrandSalesEndDate=" + encodeURIComponent(vehicleBrandSalesEndDate ? "" + vehicleBrandSalesEndDate.toISOString() : "") + "&";
        if (targetYear === null)
            throw new Error("The parameter 'targetYear' cannot be null.");
        else if (targetYear !== undefined)
            url_ += "TargetYear=" + encodeURIComponent("" + targetYear) + "&";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardDto>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<DashboardDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DashboardDto>(null as any);
    }
}

@Injectable()
export class EmployeeJobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createEmployeeJobsList(employeeId: number | undefined, body: EmployeeDto | undefined): Observable<EmployeeJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/CreateEmployeeJobsList?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployeeJobsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployeeJobsList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeJobDto[]>;
        }));
    }

    protected processCreateEmployeeJobsList(response: HttpResponseBase): Observable<EmployeeJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeJobDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeJobDto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createEmployeeJobList(employeeId: number | undefined, body: CreateEmployeeDto | undefined): Observable<EmployeeJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/CreateEmployeeJobList?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployeeJobList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployeeJobList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeJobDto[]>;
        }));
    }

    protected processCreateEmployeeJobList(response: HttpResponseBase): Observable<EmployeeJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeJobDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeJobDto[]>(null as any);
    }

    /**
     * @param employeeId (optional) 
     * @return Success
     */
    getEmployeeJobDtosByEmployeeId(employeeId: number | undefined): Observable<EmployeeJobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/GetEmployeeJobDtosByEmployeeId?";
        if (employeeId === null)
            throw new Error("The parameter 'employeeId' cannot be null.");
        else if (employeeId !== undefined)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeJobDtosByEmployeeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeJobDtosByEmployeeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeJobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeJobDto[]>;
        }));
    }

    protected processGetEmployeeJobDtosByEmployeeId(response: HttpResponseBase): Observable<EmployeeJobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeJobDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeJobDto[]>(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    removeRange(ids: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/RemoveRange?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param jobIds (optional) 
     * @return Success
     */
    getEmployeeIdsByJobIds(jobIds: number[] | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/GetEmployeeIdsByJobIds?";
        if (jobIds === null)
            throw new Error("The parameter 'jobIds' cannot be null.");
        else if (jobIds !== undefined)
            jobIds && jobIds.forEach(item => { url_ += "jobIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployeeIdsByJobIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployeeIdsByJobIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetEmployeeIdsByJobIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EmployeeJobDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeJobDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmployeeJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeJobDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeJobDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeJobDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeJobDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmployeeJobDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeJobDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeJobDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEmployeeJobDto | undefined): Observable<EmployeeJobDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeJobDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EmployeeJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeJobDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: EmployeeJobDto | undefined): Observable<EmployeeJobDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeJobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeJobDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EmployeeJobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeJobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeJobDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeJobService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EmployeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEmployee(body: CreateEmployeeDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/CreateEmployee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateEmployee(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @return Success
     */
    getAllEmployee(): Observable<EmployeeEntity[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/GetAllEmployee";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEmployee(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEmployee(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeEntity[]>;
        }));
    }

    protected processGetAllEmployee(response: HttpResponseBase): Observable<EmployeeEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeEntity[]>(null as any);
    }

    /**
     * @return Success
     */
    getSupervisorEmployees(): Observable<EmployeeEntity[]> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/GetSupervisorEmployees";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupervisorEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupervisorEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeEntity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeEntity[]>;
        }));
    }

    protected processGetSupervisorEmployees(response: HttpResponseBase): Observable<EmployeeEntity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EmployeeEntity.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeEntity[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: EmployeeDto | undefined): Observable<EmployeeDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EmployeeDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EmployeeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EmployeeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEmployeeDto | undefined): Observable<EmployeeDto> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmployeeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmployeeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EmployeeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EmployeeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmployeeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EmployeeService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateGroupDto | undefined): Observable<GroupDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<GroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: GroupDto | undefined): Observable<GroupDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto>(null as any);
    }

    /**
     * @return Success
     */
    getGroupsLookup(): Observable<GroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GroupService/GetGroupsLookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupsLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupsLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto[]>;
        }));
    }

    protected processGetGroupsLookup(response: HttpResponseBase): Observable<GroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getGroupsForReception(): Observable<GroupDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GroupService/GetGroupsForReception";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupsForReception(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupsForReception(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto[]>;
        }));
    }

    protected processGetGroupsForReception(response: HttpResponseBase): Observable<GroupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GroupDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/GroupService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/GroupService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class JobServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateJobDto | undefined): Observable<JobDto> {
        let url_ = this.baseUrl + "/api/services/app/JobService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<JobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: JobDto | undefined): Observable<JobDto> {
        let url_ = this.baseUrl + "/api/services/app/JobService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<JobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobDto>(null as any);
    }

    /**
     * @return Success
     */
    getJobLookup(): Observable<JobDto[]> {
        let url_ = this.baseUrl + "/api/services/app/JobService/GetJobLookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDto[]>;
        }));
    }

    protected processGetJobLookup(response: HttpResponseBase): Observable<JobDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(JobDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<JobDto> {
        let url_ = this.baseUrl + "/api/services/app/JobService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<JobDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined): Observable<JobDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/JobService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<JobDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<JobDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/JobService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NationalityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getNationalitysLookup(): Observable<NationalityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NationalityService/GetNationalitysLookup";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNationalitysLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNationalitysLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDto[]>;
        }));
    }

    protected processGetNationalitysLookup(response: HttpResponseBase): Observable<NationalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NationalityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NationalityDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<NationalityDto> {
        let url_ = this.baseUrl + "/api/services/app/NationalityService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NationalityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NationalityDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NationalityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NationalityService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NationalityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NationalityDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateNationalityDto | undefined): Observable<NationalityDto> {
        let url_ = this.baseUrl + "/api/services/app/NationalityService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NationalityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NationalityDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: NationalityDto | undefined): Observable<NationalityDto> {
        let url_ = this.baseUrl + "/api/services/app/NationalityService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NationalityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NationalityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NationalityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NationalityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NationalityDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NationalityService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OfferServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOfferDto | undefined): Observable<OfferDto> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfferDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OfferDto | undefined): Observable<OfferDto> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfferDto>(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    getOfferPrice(serviceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/GetOfferPrice?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfferPrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfferPrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetOfferPrice(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getOffers(keyword: string | undefined): Observable<OfferDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/GetOffers?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOffers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOffers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDto[]>;
        }));
    }

    protected processGetOffers(response: HttpResponseBase): Observable<OfferDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(OfferDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfferDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getOfferTypes(): Observable<Int32StringKeyValuePair[]> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/GetOfferTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOfferTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOfferTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32StringKeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32StringKeyValuePair[]>;
        }));
    }

    protected processGetOfferTypes(response: HttpResponseBase): Observable<Int32StringKeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Int32StringKeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32StringKeyValuePair[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OfferDto> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfferDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OfferDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfferDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfferDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OfferDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfferDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OfferDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OfferService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OffersReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param offerId (optional) 
     * @return Success
     */
    getOffersReport(from: moment.Moment | undefined, to: moment.Moment | undefined, offerId: number | undefined): Observable<OffersReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OffersReportService/GetOffersReport?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (offerId === null)
            throw new Error("The parameter 'offerId' cannot be null.");
        else if (offerId !== undefined)
            url_ += "offerId=" + encodeURIComponent("" + offerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOffersReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOffersReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OffersReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OffersReportResultDto>;
        }));
    }

    protected processGetOffersReport(response: HttpResponseBase): Observable<OffersReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OffersReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OffersReportResultDto>(null as any);
    }
}

@Injectable()
export class PackageDetailsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PackageDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageDetailsService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDetailsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PackageDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDetailsDto>(null as any);
    }

    /**
     * @return Success
     */
    getAll(packageId: number, serviceId: number, serviceCount: number): Observable<PackageDetailsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageDetailsService/GetAll?";
        if (packageId === undefined || packageId === null)
            throw new Error("The parameter 'packageId' must be defined and cannot be null.");
        else
            url_ += "PackageId=" + encodeURIComponent("" + packageId) + "&";
        if (serviceId === undefined || serviceId === null)
            throw new Error("The parameter 'serviceId' must be defined and cannot be null.");
        else
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (serviceCount === undefined || serviceCount === null)
            throw new Error("The parameter 'serviceCount' must be defined and cannot be null.");
        else
            url_ += "ServiceCount=" + encodeURIComponent("" + serviceCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDetailsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDetailsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PackageDetailsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDetailsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDetailsDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PackageDetailsDto | undefined): Observable<PackageDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageDetailsService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDetailsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PackageDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDetailsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PackageDetailsDto | undefined): Observable<PackageDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageDetailsService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDetailsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PackageDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDetailsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PackageDetailsService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PackageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPackage(body: CreatePackageDto | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/CreatePackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processCreatePackage(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPackages(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/GetAllPackages?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPackages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDtoPagedResultDto>;
        }));
    }

    protected processGetAllPackages(response: HttpResponseBase): Observable<PackageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getPackageById(id: number | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/GetPackageById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processGetPackageById(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @param body (optional) 
     * @return Success
     */
    updatePackage(id: number | undefined, body: PackageDto | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/UpdatePackage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processUpdatePackage(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllPackagesForDropdownList(): Observable<PackageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/GetAllPackagesForDropdownList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPackagesForDropdownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackagesForDropdownList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto[]>;
        }));
    }

    protected processGetAllPackagesForDropdownList(response: HttpResponseBase): Observable<PackageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDto[]>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param filter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPackagesWithSubscribers(sorting: string | undefined, filter: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageWithSubscribersDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/GetAllPackagesWithSubscribers?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "sorting=" + encodeURIComponent("" + sorting) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPackagesWithSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackagesWithSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageWithSubscribersDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageWithSubscribersDtoPagedResultDto>;
        }));
    }

    protected processGetAllPackagesWithSubscribers(response: HttpResponseBase): Observable<PackageWithSubscribersDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageWithSubscribersDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageWithSubscribersDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getPackageDurations(): Observable<Int32StringKeyValuePair[]> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/GetPackageDurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageDurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageDurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Int32StringKeyValuePair[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Int32StringKeyValuePair[]>;
        }));
    }

    protected processGetPackageDurations(response: HttpResponseBase): Observable<Int32StringKeyValuePair[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(Int32StringKeyValuePair.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Int32StringKeyValuePair[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PackageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePackageDto | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PackageDto | undefined): Observable<PackageDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PackageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PackageService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PackageSubscribersReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param packageId (optional) 
     * @return Success
     */
    getPackageSubscribers(packageId: number | undefined): Observable<PackageSubscribersReportDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscribersReportService/GetPackageSubscribers?";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscribersReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscribersReportDto>;
        }));
    }

    protected processGetPackageSubscribers(response: HttpResponseBase): Observable<PackageSubscribersReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageSubscribersReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscribersReportDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllSubscribers(): Observable<AllPackageSubscriberDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscribersReportService/GetAllSubscribers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSubscribers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSubscribers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AllPackageSubscriberDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AllPackageSubscriberDto[]>;
        }));
    }

    protected processGetAllSubscribers(response: HttpResponseBase): Observable<AllPackageSubscriberDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AllPackageSubscriberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AllPackageSubscriberDto[]>(null as any);
    }
}

@Injectable()
export class PackageSubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param customerId (optional) 
     * @param packageId (optional) 
     * @param salesEmployeeId (optional) 
     * @param paymentMethodId (optional) 
     * @return Success
     */
    createPackageSubscription(customerId: number | undefined, packageId: number | undefined, salesEmployeeId: number | undefined, paymentMethodId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/CreatePackageSubscription?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        if (salesEmployeeId === null)
            throw new Error("The parameter 'salesEmployeeId' cannot be null.");
        else if (salesEmployeeId !== undefined)
            url_ += "salesEmployeeId=" + encodeURIComponent("" + salesEmployeeId) + "&";
        if (paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' cannot be null.");
        else if (paymentMethodId !== undefined)
            url_ += "paymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePackageSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePackageSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePackageSubscription(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    getByCustomerId(customerId: number | undefined): Observable<PackageSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/GetByCustomerId?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCustomerId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCustomerId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscriptionDto[]>;
        }));
    }

    protected processGetByCustomerId(response: HttpResponseBase): Observable<PackageSubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageSubscriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscriptionDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    pauseSubscription(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/PauseSubscription?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPauseSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPauseSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPauseSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    resumeSubscription(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/ResumeSubscription?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResumeSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResumeSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResumeSubscription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    unsubscribe(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/Unsubscribe?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnsubscribe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnsubscribe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnsubscribe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PackageSubscriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscriptionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PackageSubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageSubscriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscriptionDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageSubscriptionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscriptionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscriptionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PackageSubscriptionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageSubscriptionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscriptionDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePackageSubscriptionDto | undefined): Observable<PackageSubscriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscriptionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PackageSubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageSubscriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscriptionDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PackageSubscriptionDto | undefined): Observable<PackageSubscriptionDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscriptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscriptionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PackageSubscriptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageSubscriptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscriptionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PackageSubscriptionsReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param packageId (optional) 
     * @return Success
     */
    getPackageSubscriptionsReport(from: moment.Moment | undefined, to: moment.Moment | undefined, packageId: number | undefined): Observable<PackageSubscriptionsReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageSubscriptionsReportService/GetPackageSubscriptionsReport?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageSubscriptionsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageSubscriptionsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscriptionsReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscriptionsReportResultDto>;
        }));
    }

    protected processGetPackageSubscriptionsReport(response: HttpResponseBase): Observable<PackageSubscriptionsReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageSubscriptionsReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscriptionsReportResultDto>(null as any);
    }
}

@Injectable()
export class PackageTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePackageTypeDto | undefined): Observable<PackageTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTypeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PackageTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PackageTypeDto | undefined): Observable<PackageTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTypeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PackageTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageTypeDto>(null as any);
    }

    /**
     * @return Success
     */
    getPackageTypesForDropdown(): Observable<PackageTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/GetPackageTypesForDropdown";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageTypesForDropdown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageTypesForDropdown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTypeDto[]>;
        }));
    }

    protected processGetPackageTypesForDropdown(response: HttpResponseBase): Observable<PackageTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageTypeDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getPackageTypes(keyword: string | undefined): Observable<PackageTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/GetPackageTypes?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTypeDto[]>;
        }));
    }

    protected processGetPackageTypes(response: HttpResponseBase): Observable<PackageTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageTypeDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPackageTypes(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/GetAllPackageTypes?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPackageTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackageTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAllPackageTypes(response: HttpResponseBase): Observable<PackageTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageTypeDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PackageTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTypeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PackageTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageTypeDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PackageTypeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageTypeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageTypeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PackageTypeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PackageTypeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageTypeDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PackageTypeService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PaymentMethodServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPaymentMethods(): Observable<PaymentMethodDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethodService/GetAllPaymentMethods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPaymentMethods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPaymentMethods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethodDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethodDto[]>;
        }));
    }

    protected processGetAllPaymentMethods(response: HttpResponseBase): Observable<PaymentMethodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PaymentMethodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethodService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethodDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto>(null as any);
    }

    /**
     * @return Success
     */
    getAll(name: string): Observable<PaymentMethodDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethodService/GetAll?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethodDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethodDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PaymentMethodDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: PaymentMethodDto | undefined): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethodService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethodDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: PaymentMethodDto | undefined): Observable<PaymentMethodDto> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethodService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentMethodDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentMethodDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PaymentMethodDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentMethodDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentMethodDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PaymentMethodService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProfileSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProfileSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfileSettingsService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileSettingsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfileSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfileSettings(body: ProfileSettingsDto | undefined): Observable<ProfileSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfileSettingsService/UpdateProfileSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileSettingsDto>;
        }));
    }

    protected processUpdateProfileSettings(response: HttpResponseBase): Observable<ProfileSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileSettingsDto>(null as any);
    }

    /**
     * @param profileImageBase64 (optional) 
     * @param originalFileName (optional) 
     * @return Success
     */
    getAll(profileImageBase64: string | undefined, originalFileName: string | undefined): Observable<ProfileSettingsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfileSettingsService/GetAll?";
        if (profileImageBase64 === null)
            throw new Error("The parameter 'profileImageBase64' cannot be null.");
        else if (profileImageBase64 !== undefined)
            url_ += "ProfileImageBase64=" + encodeURIComponent("" + profileImageBase64) + "&";
        if (originalFileName === null)
            throw new Error("The parameter 'originalFileName' cannot be null.");
        else if (originalFileName !== undefined)
            url_ += "OriginalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileSettingsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileSettingsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProfileSettingsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSettingsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileSettingsDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProfileSettingsDto | undefined): Observable<ProfileSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfileSettingsService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileSettingsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProfileSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProfileSettingsDto | undefined): Observable<ProfileSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfileSettingsService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileSettingsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProfileSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfileSettingsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfileSettingsService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReceiptSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReceiptSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptSettingsService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptSettingsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReceiptSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSettings(body: ReceiptSettingsDto | undefined): Observable<ReceiptSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptSettingsService/UpdateSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptSettingsDto>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<ReceiptSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptSettingsDto>(null as any);
    }

    /**
     * @param logo (optional) 
     * @param originalFileName (optional) 
     * @param address (optional) 
     * @param phoneNumber (optional) 
     * @param policies (optional) 
     * @return Success
     */
    getAll(logo: string | undefined, originalFileName: string | undefined, address: string | undefined, phoneNumber: string | undefined, policies: string | undefined): Observable<ReceiptSettingsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptSettingsService/GetAll?";
        if (logo === null)
            throw new Error("The parameter 'logo' cannot be null.");
        else if (logo !== undefined)
            url_ += "Logo=" + encodeURIComponent("" + logo) + "&";
        if (originalFileName === null)
            throw new Error("The parameter 'originalFileName' cannot be null.");
        else if (originalFileName !== undefined)
            url_ += "OriginalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        if (address === null)
            throw new Error("The parameter 'address' cannot be null.");
        else if (address !== undefined)
            url_ += "Address=" + encodeURIComponent("" + address) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (policies === null)
            throw new Error("The parameter 'policies' cannot be null.");
        else if (policies !== undefined)
            url_ += "Policies=" + encodeURIComponent("" + policies) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptSettingsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptSettingsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReceiptSettingsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSettingsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptSettingsDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ReceiptSettingsDto | undefined): Observable<ReceiptSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptSettingsService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptSettingsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReceiptSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ReceiptSettingsDto | undefined): Observable<ReceiptSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptSettingsService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptSettingsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReceiptSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptSettingsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptSettingsService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReferralProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReferralDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Referral/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReferralDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferralDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllReferralsForDropdownList(): Observable<ReferralDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Referral/GetAllReferralsForDropdownList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReferralsForDropdownList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReferralsForDropdownList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralDto[]>;
        }));
    }

    protected processGetAllReferralsForDropdownList(response: HttpResponseBase): Observable<ReferralDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReferralDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getReferralsWithActiveSubscriptions(): Observable<ReferralDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Referral/GetReferralsWithActiveSubscriptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferralsWithActiveSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralsWithActiveSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralDto[]>;
        }));
    }

    protected processGetReferralsWithActiveSubscriptions(response: HttpResponseBase): Observable<ReferralDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReferralDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralDto[]>(null as any);
    }

    /**
     * @param referralId (optional) 
     * @param packageId (optional) 
     * @return Success
     */
    subscribeReferralToPackage(referralId: number | undefined, packageId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Referral/SubscribeReferralToPackage?";
        if (referralId === null)
            throw new Error("The parameter 'referralId' cannot be null.");
        else if (referralId !== undefined)
            url_ += "referralId=" + encodeURIComponent("" + referralId) + "&";
        if (packageId === null)
            throw new Error("The parameter 'packageId' cannot be null.");
        else if (packageId !== undefined)
            url_ += "packageId=" + encodeURIComponent("" + packageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscribeReferralToPackage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscribeReferralToPackage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubscribeReferralToPackage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param referralId (optional) 
     * @return Success
     */
    getReferralSubscriptions(referralId: number | undefined): Observable<PackageSubscriptionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Referral/GetReferralSubscriptions?";
        if (referralId === null)
            throw new Error("The parameter 'referralId' cannot be null.");
        else if (referralId !== undefined)
            url_ += "referralId=" + encodeURIComponent("" + referralId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferralSubscriptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralSubscriptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageSubscriptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageSubscriptionDto[]>;
        }));
    }

    protected processGetReferralSubscriptions(response: HttpResponseBase): Observable<PackageSubscriptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(PackageSubscriptionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PackageSubscriptionDto[]>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param referralId (optional) 
     * @return Success
     */
    checkCustomerReferralEligibility(customerId: number | undefined, referralId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Referral/CheckCustomerReferralEligibility?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (referralId === null)
            throw new Error("The parameter 'referralId' cannot be null.");
        else if (referralId !== undefined)
            url_ += "referralId=" + encodeURIComponent("" + referralId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCustomerReferralEligibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCustomerReferralEligibility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCustomerReferralEligibility(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param referralId (optional) 
     * @return Success
     */
    getReferralCustomers(referralId: number | undefined): Observable<ReferralCustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Referral/GetReferralCustomers?";
        if (referralId === null)
            throw new Error("The parameter 'referralId' cannot be null.");
        else if (referralId !== undefined)
            url_ += "referralId=" + encodeURIComponent("" + referralId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferralCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralCustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralCustomerDto[]>;
        }));
    }

    protected processGetReferralCustomers(response: HttpResponseBase): Observable<ReferralCustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ReferralCustomerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralCustomerDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReferralDto> {
        let url_ = this.baseUrl + "/api/services/app/Referral/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReferralDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferralDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateReferralDto | undefined): Observable<ReferralDto> {
        let url_ = this.baseUrl + "/api/services/app/Referral/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReferralDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferralDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ReferralDto | undefined): Observable<ReferralDto> {
        let url_ = this.baseUrl + "/api/services/app/Referral/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReferralDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferralDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Referral/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReferralsReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param specialPackageTypeId (optional) 
     * @param referralId (optional) 
     * @return Success
     */
    getReferralsReport(from: moment.Moment | undefined, to: moment.Moment | undefined, specialPackageTypeId: number | undefined, referralId: number | undefined): Observable<ReferralsReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReferralsReportService/GetReferralsReport?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (specialPackageTypeId === null)
            throw new Error("The parameter 'specialPackageTypeId' cannot be null.");
        else if (specialPackageTypeId !== undefined)
            url_ += "specialPackageTypeId=" + encodeURIComponent("" + specialPackageTypeId) + "&";
        if (referralId === null)
            throw new Error("The parameter 'referralId' cannot be null.");
        else if (referralId !== undefined)
            url_ += "referralId=" + encodeURIComponent("" + referralId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReferralsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReferralsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReferralsReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReferralsReportResultDto>;
        }));
    }

    protected processGetReferralsReport(response: HttpResponseBase): Observable<ReferralsReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReferralsReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReferralsReportResultDto>(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param serviceId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getServicesByVehicleTypeReport(serviceId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<ServiceReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/GetServicesByVehicleTypeReport?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicesByVehicleTypeReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicesByVehicleTypeReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportResultDto>;
        }));
    }

    protected processGetServicesByVehicleTypeReport(response: HttpResponseBase): Observable<ServiceReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceReportResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getCarBrandReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<CarBrandReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/GetCarBrandReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCarBrandReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCarBrandReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CarBrandReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CarBrandReportResultDto>;
        }));
    }

    protected processGetCarBrandReport(response: HttpResponseBase): Observable<CarBrandReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CarBrandReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CarBrandReportResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param billCount (optional) 
     * @return Success
     */
    getCustomerBillsReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, billCount: number | undefined): Observable<CustomerBillsReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/GetCustomerBillsReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (billCount === null)
            throw new Error("The parameter 'billCount' cannot be null.");
        else if (billCount !== undefined)
            url_ += "BillCount=" + encodeURIComponent("" + billCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerBillsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerBillsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerBillsReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerBillsReportResultDto>;
        }));
    }

    protected processGetCustomerBillsReport(response: HttpResponseBase): Observable<CustomerBillsReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerBillsReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerBillsReportResultDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getServiceUsageReport(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, serviceId: number | undefined): Observable<ServiceUsageReportResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReportService/GetServiceUsageReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceUsageReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceUsageReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUsageReportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUsageReportResultDto>;
        }));
    }

    protected processGetServiceUsageReport(response: HttpResponseBase): Observable<ServiceUsageReportResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUsageReportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceUsageReportResultDto>(null as any);
    }
}

@Injectable()
export class RoleProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ServiceCheckListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceCheckListDto | undefined): Observable<ServiceCheckListDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckListService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckListDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceCheckListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceCheckListDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ServiceCheckListDto | undefined): Observable<ServiceCheckListDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckListService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckListDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceCheckListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceCheckListDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceCheckListDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckListService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckListDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckListDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceCheckListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckListDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceCheckListDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getServiceCheckListWithServiceName(): Observable<ServiceCheckListListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckListService/GetServiceCheckListWithServiceName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceCheckListWithServiceName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceCheckListWithServiceName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckListListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckListListResultDto>;
        }));
    }

    protected processGetServiceCheckListWithServiceName(response: HttpResponseBase): Observable<ServiceCheckListListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckListListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceCheckListListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceCheckListDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckListService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckListDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceCheckListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceCheckListDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckListService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ServicePriceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServicePriceDto | undefined): Observable<ServicePriceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePriceService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePriceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServicePriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServicePriceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ServicePriceDto | undefined): Observable<ServicePriceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePriceService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePriceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServicePriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServicePriceDto>(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    getServicePrice(serviceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ServicePriceService/GetServicePrice?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicePrice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicePrice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetServicePrice(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getServicePrices(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServicePriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePriceService/GetServicePrices?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicePrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicePrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePriceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePriceDtoPagedResultDto>;
        }));
    }

    protected processGetServicePrices(response: HttpResponseBase): Observable<ServicePriceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePriceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServicePriceDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServicePriceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePriceService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePriceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePriceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServicePriceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePriceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServicePriceDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServicePriceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePriceService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePriceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePriceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServicePriceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePriceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServicePriceDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServicePriceService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getFilteredServices(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/GetFilteredServices?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDtoPagedResultDto>;
        }));
    }

    protected processGetFilteredServices(response: HttpResponseBase): Observable<ServiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getServices(): Observable<ServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/GetServices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto[]>;
        }));
    }

    protected processGetServices(response: HttpResponseBase): Observable<ServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ServiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getServiceById(id: number | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/GetServiceById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processGetServiceById(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    getServicesByGroupId(groupId: number | undefined): Observable<ServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/GetServicesByGroupId?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicesByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicesByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto[]>;
        }));
    }

    protected processGetServicesByGroupId(response: HttpResponseBase): Observable<ServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ServiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto[]>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param vehicleId (optional) 
     * @param groupId (optional) 
     * @param vehicleIdsAlreadyUsingPackageInThisBill (optional) 
     * @param serviceIdsAlreadyUsedWithPackageInThisBill (optional) 
     * @return Success
     */
    getServicesWithPrices(customerId: number | undefined, vehicleId: number | undefined, groupId: number | undefined, vehicleIdsAlreadyUsingPackageInThisBill: number[] | undefined, serviceIdsAlreadyUsedWithPackageInThisBill: number[] | undefined): Observable<ServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/GetServicesWithPrices?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (vehicleIdsAlreadyUsingPackageInThisBill === null)
            throw new Error("The parameter 'vehicleIdsAlreadyUsingPackageInThisBill' cannot be null.");
        else if (vehicleIdsAlreadyUsingPackageInThisBill !== undefined)
            vehicleIdsAlreadyUsingPackageInThisBill && vehicleIdsAlreadyUsingPackageInThisBill.forEach(item => { url_ += "vehicleIdsAlreadyUsingPackageInThisBill=" + encodeURIComponent("" + item) + "&"; });
        if (serviceIdsAlreadyUsedWithPackageInThisBill === null)
            throw new Error("The parameter 'serviceIdsAlreadyUsedWithPackageInThisBill' cannot be null.");
        else if (serviceIdsAlreadyUsedWithPackageInThisBill !== undefined)
            serviceIdsAlreadyUsedWithPackageInThisBill && serviceIdsAlreadyUsedWithPackageInThisBill.forEach(item => { url_ += "serviceIdsAlreadyUsedWithPackageInThisBill=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicesWithPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicesWithPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto[]>;
        }));
    }

    protected processGetServicesWithPrices(response: HttpResponseBase): Observable<ServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ServiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceDto | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ServiceDto | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ServiceStepServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    getServiceStepsByServiceId(serviceId: number | undefined): Observable<ServiceStepDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStepService/GetServiceStepsByServiceId?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceStepsByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceStepsByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStepDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStepDto[]>;
        }));
    }

    protected processGetServiceStepsByServiceId(response: HttpResponseBase): Observable<ServiceStepDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ServiceStepDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceStepDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceStepDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStepService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStepDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceStepDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceStepDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStepService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStepDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStepDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceStepDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceStepDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceStepDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceStepDto | undefined): Observable<ServiceStepDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStepService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStepDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceStepDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ServiceStepDto | undefined): Observable<ServiceStepDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStepService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStepDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStepDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceStepDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceStepDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceStepDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStepService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SessionProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class SharedServicesProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param billDetailId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    processServiceStepsAndChecklists(billDetailId: number | undefined, serviceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SharedServices/ProcessServiceStepsAndChecklists?";
        if (billDetailId === null)
            throw new Error("The parameter 'billDetailId' cannot be null.");
        else if (billDetailId !== undefined)
            url_ += "billDetailId=" + encodeURIComponent("" + billDetailId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessServiceStepsAndChecklists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessServiceStepsAndChecklists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessServiceStepsAndChecklists(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendWhatsAppReceptionMsg(body: BillEntity | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SharedServices/SendWhatsAppReceptionMsg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWhatsAppReceptionMsg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWhatsAppReceptionMsg(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendWhatsAppReceptionMsg(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ShiftServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    beginShift(): Observable<ShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftService/BeginShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDto>;
        }));
    }

    protected processBeginShift(response: HttpResponseBase): Observable<ShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShiftDto>(null as any);
    }

    /**
     * @return Success
     */
    endShift(): Observable<EndShiftResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftService/EndShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEndShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEndShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndShiftResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndShiftResultDto>;
        }));
    }

    protected processEndShift(response: HttpResponseBase): Observable<EndShiftResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndShiftResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EndShiftResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getActiveShift(): Observable<ShiftDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftService/GetActiveShift";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveShift(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveShift(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDto>;
        }));
    }

    protected processGetActiveShift(response: HttpResponseBase): Observable<ShiftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShiftDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getShiftHistory(userId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ShiftDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftService/GetShiftHistory?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShiftDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShiftDtoPagedResultDto>;
        }));
    }

    protected processGetShiftHistory(response: HttpResponseBase): Observable<ShiftDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShiftDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShiftDtoPagedResultDto>(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @return Success
     */
    getShiftSummary(shiftId: number | undefined): Observable<EndShiftResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ShiftService/GetShiftSummary?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EndShiftResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EndShiftResultDto>;
        }));
    }

    protected processGetShiftSummary(response: HttpResponseBase): Observable<EndShiftResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndShiftResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EndShiftResultDto>(null as any);
    }
}

@Injectable()
export class SpecialPackageTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<SpecialPackageTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SpecialPackageTypeService/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialPackageTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialPackageTypeDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SpecialPackageTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SpecialPackageTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SpecialPackageTypeDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: SpecialPackageTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpecialPackageTypeService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateUpdateSpecialPackageTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpecialPackageTypeService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpecialPackageTypeService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SubscriptionCustomersReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param reportType (optional) 
     * @return Success
     */
    getSubscriptionReport(from: moment.Moment | undefined, to: moment.Moment | undefined, reportType: number | undefined): Observable<SubscriptionCustomersReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SubscriptionCustomersReportService/GetSubscriptionReport?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionCustomersReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionCustomersReportDto[]>;
        }));
    }

    protected processGetSubscriptionReport(response: HttpResponseBase): Observable<SubscriptionCustomersReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SubscriptionCustomersReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubscriptionCustomersReportDto[]>(null as any);
    }
}

@Injectable()
export class TargetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param groupId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getActualValuesForGroup(groupId: number | undefined, year: number | undefined): Observable<TargetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/GetActualValuesForGroup?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActualValuesForGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActualValuesForGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetDtoPagedResultDto>;
        }));
    }

    protected processGetActualValuesForGroup(response: HttpResponseBase): Observable<TargetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetDtoPagedResultDto>(null as any);
    }

    /**
     * @param year (optional) 
     * @return Success
     */
    calculateMonthlyTargets(year: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/CalculateMonthlyTargets?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateMonthlyTargets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateMonthlyTargets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCalculateMonthlyTargets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param billDate (optional) 
     * @param groupId (optional) 
     * @param billTotal (optional) 
     * @return Success
     */
    updateTarget(billDate: moment.Moment | undefined, groupId: number | undefined, billTotal: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/UpdateTarget?";
        if (billDate === null)
            throw new Error("The parameter 'billDate' cannot be null.");
        else if (billDate !== undefined)
            url_ += "billDate=" + encodeURIComponent(billDate ? "" + billDate.toISOString() : "") + "&";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (billTotal === null)
            throw new Error("The parameter 'billTotal' cannot be null.");
        else if (billTotal !== undefined)
            url_ += "billTotal=" + encodeURIComponent("" + billTotal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTarget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTarget(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TargetDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TargetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetDto>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param year (optional) 
     * @param january (optional) 
     * @param february (optional) 
     * @param march (optional) 
     * @param april (optional) 
     * @param may (optional) 
     * @param june (optional) 
     * @param july (optional) 
     * @param august (optional) 
     * @param september (optional) 
     * @param october (optional) 
     * @param november (optional) 
     * @param december (optional) 
     * @param total (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAll(groupId: number | undefined, year: number | undefined, january: number | undefined, february: number | undefined, march: number | undefined, april: number | undefined, may: number | undefined, june: number | undefined, july: number | undefined, august: number | undefined, september: number | undefined, october: number | undefined, november: number | undefined, december: number | undefined, total: number | undefined, id: number | undefined): Observable<TargetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/GetAll?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (january === null)
            throw new Error("The parameter 'january' cannot be null.");
        else if (january !== undefined)
            url_ += "January=" + encodeURIComponent("" + january) + "&";
        if (february === null)
            throw new Error("The parameter 'february' cannot be null.");
        else if (february !== undefined)
            url_ += "February=" + encodeURIComponent("" + february) + "&";
        if (march === null)
            throw new Error("The parameter 'march' cannot be null.");
        else if (march !== undefined)
            url_ += "March=" + encodeURIComponent("" + march) + "&";
        if (april === null)
            throw new Error("The parameter 'april' cannot be null.");
        else if (april !== undefined)
            url_ += "April=" + encodeURIComponent("" + april) + "&";
        if (may === null)
            throw new Error("The parameter 'may' cannot be null.");
        else if (may !== undefined)
            url_ += "May=" + encodeURIComponent("" + may) + "&";
        if (june === null)
            throw new Error("The parameter 'june' cannot be null.");
        else if (june !== undefined)
            url_ += "June=" + encodeURIComponent("" + june) + "&";
        if (july === null)
            throw new Error("The parameter 'july' cannot be null.");
        else if (july !== undefined)
            url_ += "July=" + encodeURIComponent("" + july) + "&";
        if (august === null)
            throw new Error("The parameter 'august' cannot be null.");
        else if (august !== undefined)
            url_ += "August=" + encodeURIComponent("" + august) + "&";
        if (september === null)
            throw new Error("The parameter 'september' cannot be null.");
        else if (september !== undefined)
            url_ += "September=" + encodeURIComponent("" + september) + "&";
        if (october === null)
            throw new Error("The parameter 'october' cannot be null.");
        else if (october !== undefined)
            url_ += "October=" + encodeURIComponent("" + october) + "&";
        if (november === null)
            throw new Error("The parameter 'november' cannot be null.");
        else if (november !== undefined)
            url_ += "November=" + encodeURIComponent("" + november) + "&";
        if (december === null)
            throw new Error("The parameter 'december' cannot be null.");
        else if (december !== undefined)
            url_ += "December=" + encodeURIComponent("" + december) + "&";
        if (total === null)
            throw new Error("The parameter 'total' cannot be null.");
        else if (total !== undefined)
            url_ += "Total=" + encodeURIComponent("" + total) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TargetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TargetDto | undefined): Observable<TargetDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TargetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TargetDto | undefined): Observable<TargetDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TargetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TargetSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param groupId (optional) 
     * @param year (optional) 
     * @return Success
     */
    getAllTargetsForGroup(groupId: number | undefined, year: number | undefined): Observable<TargetSettingsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetSettingsService/GetAllTargetsForGroup?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTargetsForGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTargetsForGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetSettingsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetSettingsDtoPagedResultDto>;
        }));
    }

    protected processGetAllTargetsForGroup(response: HttpResponseBase): Observable<TargetSettingsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetSettingsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetSettingsDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TargetSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetSettingsService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetSettingsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TargetSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetSettingsDto>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param year (optional) 
     * @param january (optional) 
     * @param february (optional) 
     * @param march (optional) 
     * @param april (optional) 
     * @param may (optional) 
     * @param june (optional) 
     * @param july (optional) 
     * @param august (optional) 
     * @param september (optional) 
     * @param october (optional) 
     * @param november (optional) 
     * @param december (optional) 
     * @param total (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAll(groupId: number | undefined, year: number | undefined, january: number | undefined, february: number | undefined, march: number | undefined, april: number | undefined, may: number | undefined, june: number | undefined, july: number | undefined, august: number | undefined, september: number | undefined, october: number | undefined, november: number | undefined, december: number | undefined, total: number | undefined, id: number | undefined): Observable<TargetSettingsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetSettingsService/GetAll?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (january === null)
            throw new Error("The parameter 'january' cannot be null.");
        else if (january !== undefined)
            url_ += "January=" + encodeURIComponent("" + january) + "&";
        if (february === null)
            throw new Error("The parameter 'february' cannot be null.");
        else if (february !== undefined)
            url_ += "February=" + encodeURIComponent("" + february) + "&";
        if (march === null)
            throw new Error("The parameter 'march' cannot be null.");
        else if (march !== undefined)
            url_ += "March=" + encodeURIComponent("" + march) + "&";
        if (april === null)
            throw new Error("The parameter 'april' cannot be null.");
        else if (april !== undefined)
            url_ += "April=" + encodeURIComponent("" + april) + "&";
        if (may === null)
            throw new Error("The parameter 'may' cannot be null.");
        else if (may !== undefined)
            url_ += "May=" + encodeURIComponent("" + may) + "&";
        if (june === null)
            throw new Error("The parameter 'june' cannot be null.");
        else if (june !== undefined)
            url_ += "June=" + encodeURIComponent("" + june) + "&";
        if (july === null)
            throw new Error("The parameter 'july' cannot be null.");
        else if (july !== undefined)
            url_ += "July=" + encodeURIComponent("" + july) + "&";
        if (august === null)
            throw new Error("The parameter 'august' cannot be null.");
        else if (august !== undefined)
            url_ += "August=" + encodeURIComponent("" + august) + "&";
        if (september === null)
            throw new Error("The parameter 'september' cannot be null.");
        else if (september !== undefined)
            url_ += "September=" + encodeURIComponent("" + september) + "&";
        if (october === null)
            throw new Error("The parameter 'october' cannot be null.");
        else if (october !== undefined)
            url_ += "October=" + encodeURIComponent("" + october) + "&";
        if (november === null)
            throw new Error("The parameter 'november' cannot be null.");
        else if (november !== undefined)
            url_ += "November=" + encodeURIComponent("" + november) + "&";
        if (december === null)
            throw new Error("The parameter 'december' cannot be null.");
        else if (december !== undefined)
            url_ += "December=" + encodeURIComponent("" + december) + "&";
        if (total === null)
            throw new Error("The parameter 'total' cannot be null.");
        else if (total !== undefined)
            url_ += "Total=" + encodeURIComponent("" + total) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetSettingsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetSettingsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TargetSettingsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetSettingsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetSettingsDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TargetSettingsDto | undefined): Observable<TargetSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetSettingsService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetSettingsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TargetSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetSettingsDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TargetSettingsDto | undefined): Observable<TargetSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TargetSettingsService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TargetSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TargetSettingsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TargetSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TargetSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TargetSettingsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TargetSettingsService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TenantProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }
}

@Injectable()
export class TokenAuthProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class TransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: TransactionDto | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto>(null as any);
    }

    /**
     * @param taxValue (optional) 
     * @param discount (optional) 
     * @param body (optional) 
     * @return Success
     */
    createTransaction(taxValue: number | undefined, discount: number | undefined, body: TransactionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/CreateTransaction?";
        if (taxValue === null)
            throw new Error("The parameter 'taxValue' cannot be null.");
        else if (taxValue !== undefined)
            url_ += "taxValue=" + encodeURIComponent("" + taxValue) + "&";
        if (discount === null)
            throw new Error("The parameter 'discount' cannot be null.");
        else if (discount !== undefined)
            url_ += "discount=" + encodeURIComponent("" + discount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTransaction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param billId (optional) 
     * @return Success
     */
    getTransactionsByBillId(billId: number | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/GetTransactionsByBillId?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "billId=" + encodeURIComponent("" + billId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionsByBillId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionsByBillId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetTransactionsByBillId(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createExpense(body: CreateExpenseTransactionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/CreateExpense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExpense(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExpense(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateExpense(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getExpenses(): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/GetExpenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetExpenses(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param shiftId (optional) 
     * @return Success
     */
    getShiftExpenses(shiftId: number | undefined): Observable<TransactionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/GetShiftExpenses?";
        if (shiftId === null)
            throw new Error("The parameter 'shiftId' cannot be null.");
        else if (shiftId !== undefined)
            url_ += "shiftId=" + encodeURIComponent("" + shiftId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetShiftExpenses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetShiftExpenses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto[]>;
        }));
    }

    protected processGetShiftExpenses(response: HttpResponseBase): Observable<TransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(TransactionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto>(null as any);
    }

    /**
     * @param billId (optional) 
     * @param note (optional) 
     * @param lastModifierUserId (optional) 
     * @param lastModificationTime (optional) 
     * @param isDeleted (optional) 
     * @param isInput (optional) 
     * @param paymentMethod_Id (optional) 
     * @return Success
     */
    getAll(billId: number | undefined, paidValue: number, changeValue: number, shiftId: number, paymentMethodId: number, note: string | undefined, creatorUserId: number, creationTime: moment.Moment, lastModifierUserId: number | undefined, lastModificationTime: moment.Moment | undefined, isDeleted: boolean | undefined, isInput: boolean | undefined, paymentMethod_Name: string, paymentMethod_Id: number | undefined): Observable<TransactionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/GetAll?";
        if (billId === null)
            throw new Error("The parameter 'billId' cannot be null.");
        else if (billId !== undefined)
            url_ += "BillId=" + encodeURIComponent("" + billId) + "&";
        if (paidValue === undefined || paidValue === null)
            throw new Error("The parameter 'paidValue' must be defined and cannot be null.");
        else
            url_ += "PaidValue=" + encodeURIComponent("" + paidValue) + "&";
        if (changeValue === undefined || changeValue === null)
            throw new Error("The parameter 'changeValue' must be defined and cannot be null.");
        else
            url_ += "ChangeValue=" + encodeURIComponent("" + changeValue) + "&";
        if (shiftId === undefined || shiftId === null)
            throw new Error("The parameter 'shiftId' must be defined and cannot be null.");
        else
            url_ += "ShiftId=" + encodeURIComponent("" + shiftId) + "&";
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined and cannot be null.");
        else
            url_ += "PaymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        if (note === null)
            throw new Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "Note=" + encodeURIComponent("" + note) + "&";
        if (creatorUserId === undefined || creatorUserId === null)
            throw new Error("The parameter 'creatorUserId' must be defined and cannot be null.");
        else
            url_ += "CreatorUserId=" + encodeURIComponent("" + creatorUserId) + "&";
        if (creationTime === undefined || creationTime === null)
            throw new Error("The parameter 'creationTime' must be defined and cannot be null.");
        else
            url_ += "CreationTime=" + encodeURIComponent(creationTime ? "" + creationTime.toISOString() : "") + "&";
        if (lastModifierUserId === null)
            throw new Error("The parameter 'lastModifierUserId' cannot be null.");
        else if (lastModifierUserId !== undefined)
            url_ += "LastModifierUserId=" + encodeURIComponent("" + lastModifierUserId) + "&";
        if (lastModificationTime === null)
            throw new Error("The parameter 'lastModificationTime' cannot be null.");
        else if (lastModificationTime !== undefined)
            url_ += "LastModificationTime=" + encodeURIComponent(lastModificationTime ? "" + lastModificationTime.toISOString() : "") + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (isInput === null)
            throw new Error("The parameter 'isInput' cannot be null.");
        else if (isInput !== undefined)
            url_ += "IsInput=" + encodeURIComponent("" + isInput) + "&";
        if (paymentMethod_Name === undefined || paymentMethod_Name === null)
            throw new Error("The parameter 'paymentMethod_Name' must be defined and cannot be null.");
        else
            url_ += "PaymentMethod.Name=" + encodeURIComponent("" + paymentMethod_Name) + "&";
        if (paymentMethod_Id === null)
            throw new Error("The parameter 'paymentMethod_Id' cannot be null.");
        else if (paymentMethod_Id !== undefined)
            url_ += "PaymentMethod.Id=" + encodeURIComponent("" + paymentMethod_Id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TransactionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TransactionDto | undefined): Observable<TransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransactionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransactionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TransactionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UploadProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param base64Logo (optional) 
     * @param originalFileName (optional) 
     * @return Success
     */
    saveBase64(base64Logo: string | undefined, originalFileName: string | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Upload/SaveBase64?";
        if (base64Logo === null)
            throw new Error("The parameter 'base64Logo' cannot be null.");
        else if (base64Logo !== undefined)
            url_ += "base64Logo=" + encodeURIComponent("" + base64Logo) + "&";
        if (originalFileName === null)
            throw new Error("The parameter 'originalFileName' cannot be null.");
        else if (originalFileName !== undefined)
            url_ += "originalFileName=" + encodeURIComponent("" + originalFileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveBase64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveBase64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processSaveBase64(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class UserProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deActivate(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeActivate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getUserRole(userId: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserRole?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGetUserRole(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class VehiclesCustomerReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param carBrandId (optional) 
     * @return Success
     */
    getCustomersByBrand(carBrandId: number | undefined): Observable<VehiclesCustomerReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VehiclesCustomerReportService/GetCustomersByBrand?";
        if (carBrandId === null)
            throw new Error("The parameter 'carBrandId' cannot be null.");
        else if (carBrandId !== undefined)
            url_ += "carBrandId=" + encodeURIComponent("" + carBrandId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomersByBrand(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomersByBrand(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehiclesCustomerReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehiclesCustomerReportDto[]>;
        }));
    }

    protected processGetCustomersByBrand(response: HttpResponseBase): Observable<VehiclesCustomerReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VehiclesCustomerReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehiclesCustomerReportDto[]>(null as any);
    }
}

@Injectable()
export class VehicleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerName(): Observable<VehicleListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/GetCustomerName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomerName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomerName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleListResultDto>;
        }));
    }

    protected processGetCustomerName(response: HttpResponseBase): Observable<VehicleListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleListResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllVehicleTypes(): Observable<VehicleTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/GetAllVehicleTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVehicleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVehicleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleTypeDto[]>;
        }));
    }

    protected processGetAllVehicleTypes(response: HttpResponseBase): Observable<VehicleTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(VehicleTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleTypeDto[]>(null as any);
    }

    /**
     * @param vehicleId (optional) 
     * @return Success
     */
    getVehicleById(vehicleId: number | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/GetVehicleById?";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetVehicleById(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(null as any);
    }

    /**
     * @param licencePlate (optional) 
     * @return Success
     */
    getVehicleByLicencePlate(licencePlate: string | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/GetVehicleByLicencePlate?";
        if (licencePlate === null)
            throw new Error("The parameter 'licencePlate' cannot be null.");
        else if (licencePlate !== undefined)
            url_ += "licencePlate=" + encodeURIComponent("" + licencePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleByLicencePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleByLicencePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGetVehicleByLicencePlate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(null as any);
    }

    /**
     * @param licencePlate (optional) 
     * @return Success
     */
    isLicencePlateUnique(licencePlate: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/IsLicencePlateUnique?";
        if (licencePlate === null)
            throw new Error("The parameter 'licencePlate' cannot be null.");
        else if (licencePlate !== undefined)
            url_ += "licencePlate=" + encodeURIComponent("" + licencePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsLicencePlateUnique(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsLicencePlateUnique(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsLicencePlateUnique(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVehicleDto | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: VehicleDto | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<VehicleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleService/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WhatsProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param mobile (optional) 
     * @param language (optional) 
     * @param template (optional) 
     * @param body (optional) 
     * @return Success
     */
    sendMessage(mobile: string | undefined, language: string | undefined, template: string | undefined, body: WhatsappComponent[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Whats/SendMessage?";
        if (mobile === null)
            throw new Error("The parameter 'mobile' cannot be null.");
        else if (mobile !== undefined)
            url_ += "mobile=" + encodeURIComponent("" + mobile) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (template === null)
            throw new Error("The parameter 'template' cannot be null.");
        else if (template !== undefined)
            url_ += "template=" + encodeURIComponent("" + template) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendMessage(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WhatsappMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Whats/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsappMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsappMessageDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WhatsappMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhatsappMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsappMessageDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<WhatsappMessageDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Whats/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsappMessageDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsappMessageDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WhatsappMessageDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhatsappMessageDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsappMessageDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateWhatsappMessageDto | undefined): Observable<WhatsappMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Whats/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsappMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsappMessageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WhatsappMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhatsappMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsappMessageDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: WhatsappMessageDto | undefined): Observable<WhatsappMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Whats/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsappMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsappMessageDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WhatsappMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WhatsappMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsappMessageDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Whats/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AllPackageSubscriberDto implements IAllPackageSubscriberDto {
    subscriptionId: number;
    customerId: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    packageId: number;
    packageName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isActive: boolean;
    isExpired: boolean;
    initialCount: number;
    remainingCount: number;
    usedCount: number;

    constructor(data?: IAllPackageSubscriberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.packageId = _data["packageId"];
            this.packageName = _data["packageName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isExpired = _data["isExpired"];
            this.initialCount = _data["initialCount"];
            this.remainingCount = _data["remainingCount"];
            this.usedCount = _data["usedCount"];
        }
    }

    static fromJS(data: any): AllPackageSubscriberDto {
        data = typeof data === 'object' ? data : {};
        let result = new AllPackageSubscriberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["packageId"] = this.packageId;
        data["packageName"] = this.packageName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isExpired"] = this.isExpired;
        data["initialCount"] = this.initialCount;
        data["remainingCount"] = this.remainingCount;
        data["usedCount"] = this.usedCount;
        return data;
    }

    clone(): AllPackageSubscriberDto {
        const json = this.toJSON();
        let result = new AllPackageSubscriberDto();
        result.init(json);
        return result;
    }
}

export interface IAllPackageSubscriberDto {
    subscriptionId: number;
    customerId: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    packageId: number;
    packageName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isActive: boolean;
    isExpired: boolean;
    initialCount: number;
    remainingCount: number;
    usedCount: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)[key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class BillCreatorCommissionItemDto implements IBillCreatorCommissionItemDto {
    billId: number;
    serviceName: string | undefined;
    receptionCommission: number;
    billDate: moment.Moment;

    constructor(data?: IBillCreatorCommissionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billId = _data["billId"];
            this.serviceName = _data["serviceName"];
            this.receptionCommission = _data["receptionCommission"];
            this.billDate = _data["billDate"] ? moment(_data["billDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): BillCreatorCommissionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillCreatorCommissionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["serviceName"] = this.serviceName;
        data["receptionCommission"] = this.receptionCommission;
        data["billDate"] = this.billDate ? this.billDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): BillCreatorCommissionItemDto {
        const json = this.toJSON();
        let result = new BillCreatorCommissionItemDto();
        result.init(json);
        return result;
    }
}

export interface IBillCreatorCommissionItemDto {
    billId: number;
    serviceName: string | undefined;
    receptionCommission: number;
    billDate: moment.Moment;
}

export class BillDetailsDto implements IBillDetailsDto {
    id: number;
    billId: number;
    serviceId: number;
    price: number;
    executionTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    finished: boolean;
    revised: boolean;
    revisedBy: number | undefined;
    note: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    vehicleId: number;
    serviceName: string | undefined;
    vehicleBrandName: string | undefined;
    vehicleModelName: string | undefined;
    vehicleLicencePlate: string | undefined;
    serviceSteps: ServiceStepDto[] | undefined;
    billServiceAssignees: BillServiceAssigneeDto[] | undefined;

    constructor(data?: IBillDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billId = _data["billId"];
            this.serviceId = _data["serviceId"];
            this.price = _data["price"];
            this.executionTime = _data["executionTime"] ? moment(_data["executionTime"].toString()) : <any>undefined;
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.finished = _data["finished"];
            this.revised = _data["revised"];
            this.revisedBy = _data["revisedBy"];
            this.note = _data["note"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.vehicleId = _data["vehicleId"];
            this.serviceName = _data["serviceName"];
            this.vehicleBrandName = _data["vehicleBrandName"];
            this.vehicleModelName = _data["vehicleModelName"];
            this.vehicleLicencePlate = _data["vehicleLicencePlate"];
            if (Array.isArray(_data["serviceSteps"])) {
                this.serviceSteps = [] as any;
                for (let item of _data["serviceSteps"])
                    this.serviceSteps.push(ServiceStepDto.fromJS(item));
            }
            if (Array.isArray(_data["billServiceAssignees"])) {
                this.billServiceAssignees = [] as any;
                for (let item of _data["billServiceAssignees"])
                    this.billServiceAssignees.push(BillServiceAssigneeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billId"] = this.billId;
        data["serviceId"] = this.serviceId;
        data["price"] = this.price;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["finished"] = this.finished;
        data["revised"] = this.revised;
        data["revisedBy"] = this.revisedBy;
        data["note"] = this.note;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["vehicleId"] = this.vehicleId;
        data["serviceName"] = this.serviceName;
        data["vehicleBrandName"] = this.vehicleBrandName;
        data["vehicleModelName"] = this.vehicleModelName;
        data["vehicleLicencePlate"] = this.vehicleLicencePlate;
        if (Array.isArray(this.serviceSteps)) {
            data["serviceSteps"] = [];
            for (let item of this.serviceSteps)
                data["serviceSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.billServiceAssignees)) {
            data["billServiceAssignees"] = [];
            for (let item of this.billServiceAssignees)
                data["billServiceAssignees"].push(item.toJSON());
        }
        return data;
    }

    clone(): BillDetailsDto {
        const json = this.toJSON();
        let result = new BillDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IBillDetailsDto {
    id: number;
    billId: number;
    serviceId: number;
    price: number;
    executionTime: moment.Moment | undefined;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    finished: boolean;
    revised: boolean;
    revisedBy: number | undefined;
    note: string | undefined;
    description: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    vehicleId: number;
    serviceName: string | undefined;
    vehicleBrandName: string | undefined;
    vehicleModelName: string | undefined;
    vehicleLicencePlate: string | undefined;
    serviceSteps: ServiceStepDto[] | undefined;
    billServiceAssignees: BillServiceAssigneeDto[] | undefined;
}

export class BillDetailsDtoPagedResultDto implements IBillDetailsDtoPagedResultDto {
    items: BillDetailsDto[] | undefined;
    totalCount: number;

    constructor(data?: IBillDetailsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillDetailsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BillDetailsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDetailsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BillDetailsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BillDetailsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBillDetailsDtoPagedResultDto {
    items: BillDetailsDto[] | undefined;
    totalCount: number;
}

export class BillDetailsEntity implements IBillDetailsEntity {
    id: number;
    billId: number;
    vehicleId: number;
    serviceId: number;
    price: number;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    revised: boolean;
    finished: boolean;
    revisedBy: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    note: string | undefined;
    description: string | undefined;
    offerId: number | undefined;
    packageSubscriptionId: number | undefined;
    supervisorEmployeeId: number | undefined;
    bill: BillEntity;
    offer: OfferEntity;
    packageSubscription: PackageSubscriptionEntity;
    vehicle: VehicleEntity;
    service: ServiceEntity;
    supervisorEmployee: EmployeeEntity;
    billServiceAssignees: BillServiceAssigneeEntity[] | undefined;

    constructor(data?: IBillDetailsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billId = _data["billId"];
            this.vehicleId = _data["vehicleId"];
            this.serviceId = _data["serviceId"];
            this.price = _data["price"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.revised = _data["revised"];
            this.finished = _data["finished"];
            this.revisedBy = _data["revisedBy"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.note = _data["note"];
            this.description = _data["description"];
            this.offerId = _data["offerId"];
            this.packageSubscriptionId = _data["packageSubscriptionId"];
            this.supervisorEmployeeId = _data["supervisorEmployeeId"];
            this.bill = _data["bill"] ? BillEntity.fromJS(_data["bill"]) : <any>undefined;
            this.offer = _data["offer"] ? OfferEntity.fromJS(_data["offer"]) : <any>undefined;
            this.packageSubscription = _data["packageSubscription"] ? PackageSubscriptionEntity.fromJS(_data["packageSubscription"]) : <any>undefined;
            this.vehicle = _data["vehicle"] ? VehicleEntity.fromJS(_data["vehicle"]) : <any>undefined;
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
            this.supervisorEmployee = _data["supervisorEmployee"] ? EmployeeEntity.fromJS(_data["supervisorEmployee"]) : <any>undefined;
            if (Array.isArray(_data["billServiceAssignees"])) {
                this.billServiceAssignees = [] as any;
                for (let item of _data["billServiceAssignees"])
                    this.billServiceAssignees.push(BillServiceAssigneeEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillDetailsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BillDetailsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billId"] = this.billId;
        data["vehicleId"] = this.vehicleId;
        data["serviceId"] = this.serviceId;
        data["price"] = this.price;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["revised"] = this.revised;
        data["finished"] = this.finished;
        data["revisedBy"] = this.revisedBy;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["note"] = this.note;
        data["description"] = this.description;
        data["offerId"] = this.offerId;
        data["packageSubscriptionId"] = this.packageSubscriptionId;
        data["supervisorEmployeeId"] = this.supervisorEmployeeId;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["offer"] = this.offer ? this.offer.toJSON() : <any>undefined;
        data["packageSubscription"] = this.packageSubscription ? this.packageSubscription.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["supervisorEmployee"] = this.supervisorEmployee ? this.supervisorEmployee.toJSON() : <any>undefined;
        if (Array.isArray(this.billServiceAssignees)) {
            data["billServiceAssignees"] = [];
            for (let item of this.billServiceAssignees)
                data["billServiceAssignees"].push(item.toJSON());
        }
        return data;
    }

    clone(): BillDetailsEntity {
        const json = this.toJSON();
        let result = new BillDetailsEntity();
        result.init(json);
        return result;
    }
}

export interface IBillDetailsEntity {
    id: number;
    billId: number;
    vehicleId: number;
    serviceId: number;
    price: number;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    revised: boolean;
    finished: boolean;
    revisedBy: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    note: string | undefined;
    description: string | undefined;
    offerId: number | undefined;
    packageSubscriptionId: number | undefined;
    supervisorEmployeeId: number | undefined;
    bill: BillEntity;
    offer: OfferEntity;
    packageSubscription: PackageSubscriptionEntity;
    vehicle: VehicleEntity;
    service: ServiceEntity;
    supervisorEmployee: EmployeeEntity;
    billServiceAssignees: BillServiceAssigneeEntity[] | undefined;
}

export class BillDto implements IBillDto {
    id: number;
    total: number;
    taxValue: number | undefined;
    paidValue: number;
    changeValue: number;
    currencyId: number;
    paymentMethodId: number;
    paymentMethodName: string | undefined;
    finished: boolean;
    finishedOn: moment.Moment | undefined;
    delivered: boolean;
    note: string | undefined;
    discount: number;
    deliveredOn: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number;
    shiftId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    vehiclePlates: string | undefined;
    customer: CustomerStatsDto;
    user: UserDto;
    billDetails: BillDetailsDto[] | undefined;
    packageSubscriptionId: number | undefined;
    readonly isSubscriptionBill: boolean;

    constructor(data?: IBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.total = _data["total"];
            this.taxValue = _data["taxValue"];
            this.paidValue = _data["paidValue"];
            this.changeValue = _data["changeValue"];
            this.currencyId = _data["currencyId"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.paymentMethodName = _data["paymentMethodName"];
            this.finished = _data["finished"];
            this.finishedOn = _data["finishedOn"] ? moment(_data["finishedOn"].toString()) : <any>undefined;
            this.delivered = _data["delivered"];
            this.note = _data["note"];
            this.discount = _data["discount"];
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.shiftId = _data["shiftId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.vehiclePlates = _data["vehiclePlates"];
            this.customer = _data["customer"] ? CustomerStatsDto.fromJS(_data["customer"]) : <any>undefined;
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["billDetails"])) {
                this.billDetails = [] as any;
                for (let item of _data["billDetails"])
                    this.billDetails.push(BillDetailsDto.fromJS(item));
            }
            this.packageSubscriptionId = _data["packageSubscriptionId"];
            (<any>this).isSubscriptionBill = _data["isSubscriptionBill"];
        }
    }

    static fromJS(data: any): BillDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["total"] = this.total;
        data["taxValue"] = this.taxValue;
        data["paidValue"] = this.paidValue;
        data["changeValue"] = this.changeValue;
        data["currencyId"] = this.currencyId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["paymentMethodName"] = this.paymentMethodName;
        data["finished"] = this.finished;
        data["finishedOn"] = this.finishedOn ? this.finishedOn.toISOString() : <any>undefined;
        data["delivered"] = this.delivered;
        data["note"] = this.note;
        data["discount"] = this.discount;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["shiftId"] = this.shiftId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["vehiclePlates"] = this.vehiclePlates;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.billDetails)) {
            data["billDetails"] = [];
            for (let item of this.billDetails)
                data["billDetails"].push(item.toJSON());
        }
        data["packageSubscriptionId"] = this.packageSubscriptionId;
        data["isSubscriptionBill"] = this.isSubscriptionBill;
        return data;
    }

    clone(): BillDto {
        const json = this.toJSON();
        let result = new BillDto();
        result.init(json);
        return result;
    }
}

export interface IBillDto {
    id: number;
    total: number;
    taxValue: number | undefined;
    paidValue: number;
    changeValue: number;
    currencyId: number;
    paymentMethodId: number;
    paymentMethodName: string | undefined;
    finished: boolean;
    finishedOn: moment.Moment | undefined;
    delivered: boolean;
    note: string | undefined;
    discount: number;
    deliveredOn: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number;
    shiftId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    vehiclePlates: string | undefined;
    customer: CustomerStatsDto;
    user: UserDto;
    billDetails: BillDetailsDto[] | undefined;
    packageSubscriptionId: number | undefined;
    isSubscriptionBill: boolean;
}

export class BillDtoPagedResultDto implements IBillDtoPagedResultDto {
    items: BillDto[] | undefined;
    totalCount: number;

    constructor(data?: IBillDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(BillDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BillDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BillDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BillDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBillDtoPagedResultDto {
    items: BillDto[] | undefined;
    totalCount: number;
}

export class BillEntity implements IBillEntity {
    id: number;
    customerId: number;
    total: number;
    taxValue: number | undefined;
    paidValue: number;
    changeValue: number;
    discount: number;
    currencyId: number;
    paymentMethodId: number;
    shiftId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    finished: boolean;
    closedByAccountant: boolean;
    finishedOn: moment.Moment | undefined;
    delivered: boolean;
    note: string | undefined;
    deliveredOn: moment.Moment | undefined;
    referredByReferralId: number | undefined;
    packageSubscriptionId: number | undefined;
    customer: CustomerEntity;
    referredByReferral: ReferralEntity;
    packageSubscription: PackageSubscriptionEntity;
    user: User;
    currency: CurrencyEntity;
    paymentMethod: PaymentMethodEntity;
    shift: ShiftEntity;
    billDetails: BillDetailsEntity[] | undefined;
    transactios: TransactionEntity[] | undefined;

    constructor(data?: IBillEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.total = _data["total"];
            this.taxValue = _data["taxValue"];
            this.paidValue = _data["paidValue"];
            this.changeValue = _data["changeValue"];
            this.discount = _data["discount"];
            this.currencyId = _data["currencyId"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.shiftId = _data["shiftId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.finished = _data["finished"];
            this.closedByAccountant = _data["closedByAccountant"];
            this.finishedOn = _data["finishedOn"] ? moment(_data["finishedOn"].toString()) : <any>undefined;
            this.delivered = _data["delivered"];
            this.note = _data["note"];
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : <any>undefined;
            this.referredByReferralId = _data["referredByReferralId"];
            this.packageSubscriptionId = _data["packageSubscriptionId"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.referredByReferral = _data["referredByReferral"] ? ReferralEntity.fromJS(_data["referredByReferral"]) : <any>undefined;
            this.packageSubscription = _data["packageSubscription"] ? PackageSubscriptionEntity.fromJS(_data["packageSubscription"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.currency = _data["currency"] ? CurrencyEntity.fromJS(_data["currency"]) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodEntity.fromJS(_data["paymentMethod"]) : <any>undefined;
            this.shift = _data["shift"] ? ShiftEntity.fromJS(_data["shift"]) : <any>undefined;
            if (Array.isArray(_data["billDetails"])) {
                this.billDetails = [] as any;
                for (let item of _data["billDetails"])
                    this.billDetails.push(BillDetailsEntity.fromJS(item));
            }
            if (Array.isArray(_data["transactios"])) {
                this.transactios = [] as any;
                for (let item of _data["transactios"])
                    this.transactios.push(TransactionEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BillEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["total"] = this.total;
        data["taxValue"] = this.taxValue;
        data["paidValue"] = this.paidValue;
        data["changeValue"] = this.changeValue;
        data["discount"] = this.discount;
        data["currencyId"] = this.currencyId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["shiftId"] = this.shiftId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["finished"] = this.finished;
        data["closedByAccountant"] = this.closedByAccountant;
        data["finishedOn"] = this.finishedOn ? this.finishedOn.toISOString() : <any>undefined;
        data["delivered"] = this.delivered;
        data["note"] = this.note;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        data["referredByReferralId"] = this.referredByReferralId;
        data["packageSubscriptionId"] = this.packageSubscriptionId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["referredByReferral"] = this.referredByReferral ? this.referredByReferral.toJSON() : <any>undefined;
        data["packageSubscription"] = this.packageSubscription ? this.packageSubscription.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["currency"] = this.currency ? this.currency.toJSON() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        if (Array.isArray(this.billDetails)) {
            data["billDetails"] = [];
            for (let item of this.billDetails)
                data["billDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.transactios)) {
            data["transactios"] = [];
            for (let item of this.transactios)
                data["transactios"].push(item.toJSON());
        }
        return data;
    }

    clone(): BillEntity {
        const json = this.toJSON();
        let result = new BillEntity();
        result.init(json);
        return result;
    }
}

export interface IBillEntity {
    id: number;
    customerId: number;
    total: number;
    taxValue: number | undefined;
    paidValue: number;
    changeValue: number;
    discount: number;
    currencyId: number;
    paymentMethodId: number;
    shiftId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    finished: boolean;
    closedByAccountant: boolean;
    finishedOn: moment.Moment | undefined;
    delivered: boolean;
    note: string | undefined;
    deliveredOn: moment.Moment | undefined;
    referredByReferralId: number | undefined;
    packageSubscriptionId: number | undefined;
    customer: CustomerEntity;
    referredByReferral: ReferralEntity;
    packageSubscription: PackageSubscriptionEntity;
    user: User;
    currency: CurrencyEntity;
    paymentMethod: PaymentMethodEntity;
    shift: ShiftEntity;
    billDetails: BillDetailsEntity[] | undefined;
    transactios: TransactionEntity[] | undefined;
}

export class BillServiceAssigneeDto implements IBillServiceAssigneeDto {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    serviceId: number | undefined;
    billDetailId: number | undefined;
    orderServiceStepId: number | undefined;

    constructor(data?: IBillServiceAssigneeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.serviceId = _data["serviceId"];
            this.billDetailId = _data["billDetailId"];
            this.orderServiceStepId = _data["orderServiceStepId"];
        }
    }

    static fromJS(data: any): BillServiceAssigneeDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillServiceAssigneeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["serviceId"] = this.serviceId;
        data["billDetailId"] = this.billDetailId;
        data["orderServiceStepId"] = this.orderServiceStepId;
        return data;
    }

    clone(): BillServiceAssigneeDto {
        const json = this.toJSON();
        let result = new BillServiceAssigneeDto();
        result.init(json);
        return result;
    }
}

export interface IBillServiceAssigneeDto {
    id: number;
    employeeId: number;
    employeeName: string | undefined;
    serviceId: number | undefined;
    billDetailId: number | undefined;
    orderServiceStepId: number | undefined;
}

export class BillServiceAssigneeEntity implements IBillServiceAssigneeEntity {
    id: number;
    employeeId: number;
    serviceId: number | undefined;
    billDetailId: number | undefined;
    orderServiceStepId: number | undefined;
    billDetail: BillDetailsEntity;
    employee: EmployeeEntity;
    orderServiceStep: OrderServiceStepsEntity;

    constructor(data?: IBillServiceAssigneeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.serviceId = _data["serviceId"];
            this.billDetailId = _data["billDetailId"];
            this.orderServiceStepId = _data["orderServiceStepId"];
            this.billDetail = _data["billDetail"] ? BillDetailsEntity.fromJS(_data["billDetail"]) : <any>undefined;
            this.employee = _data["employee"] ? EmployeeEntity.fromJS(_data["employee"]) : <any>undefined;
            this.orderServiceStep = _data["orderServiceStep"] ? OrderServiceStepsEntity.fromJS(_data["orderServiceStep"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BillServiceAssigneeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new BillServiceAssigneeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["serviceId"] = this.serviceId;
        data["billDetailId"] = this.billDetailId;
        data["orderServiceStepId"] = this.orderServiceStepId;
        data["billDetail"] = this.billDetail ? this.billDetail.toJSON() : <any>undefined;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["orderServiceStep"] = this.orderServiceStep ? this.orderServiceStep.toJSON() : <any>undefined;
        return data;
    }

    clone(): BillServiceAssigneeEntity {
        const json = this.toJSON();
        let result = new BillServiceAssigneeEntity();
        result.init(json);
        return result;
    }
}

export interface IBillServiceAssigneeEntity {
    id: number;
    employeeId: number;
    serviceId: number | undefined;
    billDetailId: number | undefined;
    orderServiceStepId: number | undefined;
    billDetail: BillDetailsEntity;
    employee: EmployeeEntity;
    orderServiceStep: OrderServiceStepsEntity;
}

export class BillsInfoDto implements IBillsInfoDto {
    totalBillsCount: number;
    totalSales: number;
    totalPaid: number;
    totalUncollected: number;
    discountsTotal: number;
    taxTotal: number;
    paymentMethodTotals: { [key: string]: number; } | undefined;

    constructor(data?: IBillsInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalBillsCount = _data["totalBillsCount"];
            this.totalSales = _data["totalSales"];
            this.totalPaid = _data["totalPaid"];
            this.totalUncollected = _data["totalUncollected"];
            this.discountsTotal = _data["discountsTotal"];
            this.taxTotal = _data["taxTotal"];
            if (_data["paymentMethodTotals"]) {
                this.paymentMethodTotals = {} as any;
                for (let key in _data["paymentMethodTotals"]) {
                    if (_data["paymentMethodTotals"].hasOwnProperty(key))
                        (<any>this.paymentMethodTotals)[key] = _data["paymentMethodTotals"][key];
                }
            }
        }
    }

    static fromJS(data: any): BillsInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BillsInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalBillsCount"] = this.totalBillsCount;
        data["totalSales"] = this.totalSales;
        data["totalPaid"] = this.totalPaid;
        data["totalUncollected"] = this.totalUncollected;
        data["discountsTotal"] = this.discountsTotal;
        data["taxTotal"] = this.taxTotal;
        if (this.paymentMethodTotals) {
            data["paymentMethodTotals"] = {};
            for (let key in this.paymentMethodTotals) {
                if (this.paymentMethodTotals.hasOwnProperty(key))
                    (<any>data["paymentMethodTotals"])[key] = (<any>this.paymentMethodTotals)[key];
            }
        }
        return data;
    }

    clone(): BillsInfoDto {
        const json = this.toJSON();
        let result = new BillsInfoDto();
        result.init(json);
        return result;
    }
}

export interface IBillsInfoDto {
    totalBillsCount: number;
    totalSales: number;
    totalPaid: number;
    totalUncollected: number;
    discountsTotal: number;
    taxTotal: number;
    paymentMethodTotals: { [key: string]: number; } | undefined;
}

export class BillStep implements IBillStep {
    stepName: string | undefined;
    expectedTime: number | undefined;
    commission: number | undefined;
    orderServiceStep: OrderServiceStepsEntity;
    assignedEmployees: EmployeeNameDto[] | undefined;
    selectedEmployeeIds: number[] | undefined;

    constructor(data?: IBillStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stepName = _data["stepName"];
            this.expectedTime = _data["expectedTime"];
            this.commission = _data["commission"];
            this.orderServiceStep = _data["orderServiceStep"] ? OrderServiceStepsEntity.fromJS(_data["orderServiceStep"]) : <any>undefined;
            if (Array.isArray(_data["assignedEmployees"])) {
                this.assignedEmployees = [] as any;
                for (let item of _data["assignedEmployees"])
                    this.assignedEmployees.push(EmployeeNameDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedEmployeeIds"])) {
                this.selectedEmployeeIds = [] as any;
                for (let item of _data["selectedEmployeeIds"])
                    this.selectedEmployeeIds.push(item);
            }
        }
    }

    static fromJS(data: any): BillStep {
        data = typeof data === 'object' ? data : {};
        let result = new BillStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stepName"] = this.stepName;
        data["expectedTime"] = this.expectedTime;
        data["commission"] = this.commission;
        data["orderServiceStep"] = this.orderServiceStep ? this.orderServiceStep.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedEmployees)) {
            data["assignedEmployees"] = [];
            for (let item of this.assignedEmployees)
                data["assignedEmployees"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedEmployeeIds)) {
            data["selectedEmployeeIds"] = [];
            for (let item of this.selectedEmployeeIds)
                data["selectedEmployeeIds"].push(item);
        }
        return data;
    }

    clone(): BillStep {
        const json = this.toJSON();
        let result = new BillStep();
        result.init(json);
        return result;
    }
}

export interface IBillStep {
    stepName: string | undefined;
    expectedTime: number | undefined;
    commission: number | undefined;
    orderServiceStep: OrderServiceStepsEntity;
    assignedEmployees: EmployeeNameDto[] | undefined;
    selectedEmployeeIds: number[] | undefined;
}

export class CarBrandDto implements ICarBrandDto {
    id: number;
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    carModels: CarModelDto[] | undefined;

    constructor(data?: ICarBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["carModels"])) {
                this.carModels = [] as any;
                for (let item of _data["carModels"])
                    this.carModels.push(CarModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.carModels)) {
            data["carModels"] = [];
            for (let item of this.carModels)
                data["carModels"].push(item.toJSON());
        }
        return data;
    }

    clone(): CarBrandDto {
        const json = this.toJSON();
        let result = new CarBrandDto();
        result.init(json);
        return result;
    }
}

export interface ICarBrandDto {
    id: number;
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    carModels: CarModelDto[] | undefined;
}

export class CarBrandDtoPagedResultDto implements ICarBrandDtoPagedResultDto {
    items: CarBrandDto[] | undefined;
    totalCount: number;

    constructor(data?: ICarBrandDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CarBrandDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CarBrandDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBrandDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CarBrandDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CarBrandDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICarBrandDtoPagedResultDto {
    items: CarBrandDto[] | undefined;
    totalCount: number;
}

export class CarBrandEntity implements ICarBrandEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICarBrandEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CarBrandEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CarBrandEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CarBrandEntity {
        const json = this.toJSON();
        let result = new CarBrandEntity();
        result.init(json);
        return result;
    }
}

export interface ICarBrandEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CarBrandReportItemDto implements ICarBrandReportItemDto {
    rank: number;
    carBrandId: number;
    carBrandName: string | undefined;
    count: number;
    percentage: number;

    constructor(data?: ICarBrandReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.carBrandId = _data["carBrandId"];
            this.carBrandName = _data["carBrandName"];
            this.count = _data["count"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): CarBrandReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBrandReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["carBrandId"] = this.carBrandId;
        data["carBrandName"] = this.carBrandName;
        data["count"] = this.count;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): CarBrandReportItemDto {
        const json = this.toJSON();
        let result = new CarBrandReportItemDto();
        result.init(json);
        return result;
    }
}

export interface ICarBrandReportItemDto {
    rank: number;
    carBrandId: number;
    carBrandName: string | undefined;
    count: number;
    percentage: number;
}

export class CarBrandReportResultDto implements ICarBrandReportResultDto {
    totalNewCustomers: number;
    totalBrands: number;
    brandBreakdown: CarBrandReportItemDto[] | undefined;

    constructor(data?: ICarBrandReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalNewCustomers = _data["totalNewCustomers"];
            this.totalBrands = _data["totalBrands"];
            if (Array.isArray(_data["brandBreakdown"])) {
                this.brandBreakdown = [] as any;
                for (let item of _data["brandBreakdown"])
                    this.brandBreakdown.push(CarBrandReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CarBrandReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarBrandReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalNewCustomers"] = this.totalNewCustomers;
        data["totalBrands"] = this.totalBrands;
        if (Array.isArray(this.brandBreakdown)) {
            data["brandBreakdown"] = [];
            for (let item of this.brandBreakdown)
                data["brandBreakdown"].push(item.toJSON());
        }
        return data;
    }

    clone(): CarBrandReportResultDto {
        const json = this.toJSON();
        let result = new CarBrandReportResultDto();
        result.init(json);
        return result;
    }
}

export interface ICarBrandReportResultDto {
    totalNewCustomers: number;
    totalBrands: number;
    brandBreakdown: CarBrandReportItemDto[] | undefined;
}

export class CarModelDto implements ICarModelDto {
    id: number;
    carBrandId: number;
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    carBrand: CarBrandEntity;

    constructor(data?: ICarModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.carBrandId = _data["carBrandId"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.carBrand = _data["carBrand"] ? CarBrandEntity.fromJS(_data["carBrand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CarModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["carBrandId"] = this.carBrandId;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["carBrand"] = this.carBrand ? this.carBrand.toJSON() : <any>undefined;
        return data;
    }

    clone(): CarModelDto {
        const json = this.toJSON();
        let result = new CarModelDto();
        result.init(json);
        return result;
    }
}

export interface ICarModelDto {
    id: number;
    carBrandId: number;
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    carBrand: CarBrandEntity;
}

export class CarModelDtoPagedResultDto implements ICarModelDtoPagedResultDto {
    items: CarModelDto[] | undefined;
    totalCount: number;

    constructor(data?: ICarModelDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CarModelDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CarModelDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CarModelDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CarModelDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICarModelDtoPagedResultDto {
    items: CarModelDto[] | undefined;
    totalCount: number;
}

export class CarModelEntity implements ICarModelEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    carBrandId: number;
    carBrand: CarBrandEntity;

    constructor(data?: ICarModelEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.carBrandId = _data["carBrandId"];
            this.carBrand = _data["carBrand"] ? CarBrandEntity.fromJS(_data["carBrand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CarModelEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CarModelEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["carBrandId"] = this.carBrandId;
        data["carBrand"] = this.carBrand ? this.carBrand.toJSON() : <any>undefined;
        return data;
    }

    clone(): CarModelEntity {
        const json = this.toJSON();
        let result = new CarModelEntity();
        result.init(json);
        return result;
    }
}

export interface ICarModelEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    carBrandId: number;
    carBrand: CarBrandEntity;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CommissionCalculationDto implements ICommissionCalculationDto {
    employeeCommissionDtos: EmployeeCommissionDto[] | undefined;
    totalEmployees: number;

    constructor(data?: ICommissionCalculationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employeeCommissionDtos"])) {
                this.employeeCommissionDtos = [] as any;
                for (let item of _data["employeeCommissionDtos"])
                    this.employeeCommissionDtos.push(EmployeeCommissionDto.fromJS(item));
            }
            this.totalEmployees = _data["totalEmployees"];
        }
    }

    static fromJS(data: any): CommissionCalculationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionCalculationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employeeCommissionDtos)) {
            data["employeeCommissionDtos"] = [];
            for (let item of this.employeeCommissionDtos)
                data["employeeCommissionDtos"].push(item.toJSON());
        }
        data["totalEmployees"] = this.totalEmployees;
        return data;
    }

    clone(): CommissionCalculationDto {
        const json = this.toJSON();
        let result = new CommissionCalculationDto();
        result.init(json);
        return result;
    }
}

export interface ICommissionCalculationDto {
    employeeCommissionDtos: EmployeeCommissionDto[] | undefined;
    totalEmployees: number;
}

export class CreateBillDetailsDto implements ICreateBillDetailsDto {
    vehicleId: number;
    serviceId: number;
    price: number;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    executedBy: number;
    finished: boolean;
    revised: boolean;
    revisedBy: number | undefined;
    note: string | undefined;
    description: string | undefined;

    constructor(data?: ICreateBillDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.serviceId = _data["serviceId"];
            this.price = _data["price"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.executedBy = _data["executedBy"];
            this.finished = _data["finished"];
            this.revised = _data["revised"];
            this.revisedBy = _data["revisedBy"];
            this.note = _data["note"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateBillDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBillDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["serviceId"] = this.serviceId;
        data["price"] = this.price;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["executedBy"] = this.executedBy;
        data["finished"] = this.finished;
        data["revised"] = this.revised;
        data["revisedBy"] = this.revisedBy;
        data["note"] = this.note;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateBillDetailsDto {
        const json = this.toJSON();
        let result = new CreateBillDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBillDetailsDto {
    vehicleId: number;
    serviceId: number;
    price: number;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    executedBy: number;
    finished: boolean;
    revised: boolean;
    revisedBy: number | undefined;
    note: string | undefined;
    description: string | undefined;
}

export class CreateBillDto implements ICreateBillDto {
    customerId: number;
    total: number;
    taxValue: number;
    paidValue: number;
    changeValue: number;
    currencyId: number;
    paymentMethodId: number;
    finished: boolean;
    finishedOn: moment.Moment | undefined;
    delivered: boolean;
    note: string | undefined;
    deliveredOn: moment.Moment | undefined;
    creatorUserId: number;
    referredByReferralId: number | undefined;
    isFree: boolean;
    billDetails: CreateBillDetailsDto[] | undefined;

    constructor(data?: ICreateBillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.total = _data["total"];
            this.taxValue = _data["taxValue"];
            this.paidValue = _data["paidValue"];
            this.changeValue = _data["changeValue"];
            this.currencyId = _data["currencyId"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.finished = _data["finished"];
            this.finishedOn = _data["finishedOn"] ? moment(_data["finishedOn"].toString()) : <any>undefined;
            this.delivered = _data["delivered"];
            this.note = _data["note"];
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.referredByReferralId = _data["referredByReferralId"];
            this.isFree = _data["isFree"];
            if (Array.isArray(_data["billDetails"])) {
                this.billDetails = [] as any;
                for (let item of _data["billDetails"])
                    this.billDetails.push(CreateBillDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateBillDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["total"] = this.total;
        data["taxValue"] = this.taxValue;
        data["paidValue"] = this.paidValue;
        data["changeValue"] = this.changeValue;
        data["currencyId"] = this.currencyId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["finished"] = this.finished;
        data["finishedOn"] = this.finishedOn ? this.finishedOn.toISOString() : <any>undefined;
        data["delivered"] = this.delivered;
        data["note"] = this.note;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["referredByReferralId"] = this.referredByReferralId;
        data["isFree"] = this.isFree;
        if (Array.isArray(this.billDetails)) {
            data["billDetails"] = [];
            for (let item of this.billDetails)
                data["billDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateBillDto {
        const json = this.toJSON();
        let result = new CreateBillDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBillDto {
    customerId: number;
    total: number;
    taxValue: number;
    paidValue: number;
    changeValue: number;
    currencyId: number;
    paymentMethodId: number;
    finished: boolean;
    finishedOn: moment.Moment | undefined;
    delivered: boolean;
    note: string | undefined;
    deliveredOn: moment.Moment | undefined;
    creatorUserId: number;
    referredByReferralId: number | undefined;
    isFree: boolean;
    billDetails: CreateBillDetailsDto[] | undefined;
}

export class CreateCarBrandDto implements ICreateCarBrandDto {
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICreateCarBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateCarBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCarBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CreateCarBrandDto {
        const json = this.toJSON();
        let result = new CreateCarBrandDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCarBrandDto {
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CreateCarModelDto implements ICreateCarModelDto {
    carBrandId: number;
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICreateCarModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carBrandId = _data["carBrandId"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateCarModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCarModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carBrandId"] = this.carBrandId;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CreateCarModelDto {
        const json = this.toJSON();
        let result = new CreateCarModelDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCarModelDto {
    carBrandId: number;
    name: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CreateCustomerDto implements ICreateCustomerDto {
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    phoneNumbers: CreateCustomerPhonesDto[] | undefined;
    vehicles: CreateVehicleDto[] | undefined;

    constructor(data?: ICreateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.howDoYouKnowUsID = _data["howDoYouKnowUsID"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(CreateCustomerPhonesDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(CreateVehicleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["howDoYouKnowUsID"] = this.howDoYouKnowUsID;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateCustomerDto {
        const json = this.toJSON();
        let result = new CreateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerDto {
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    phoneNumbers: CreateCustomerPhonesDto[] | undefined;
    vehicles: CreateVehicleDto[] | undefined;
}

export class CreateCustomerPhonesDto implements ICreateCustomerPhonesDto {
    phoneNumber: string;
    isWhatsApp: boolean;

    constructor(data?: ICreateCustomerPhonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.isWhatsApp = _data["isWhatsApp"];
        }
    }

    static fromJS(data: any): CreateCustomerPhonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerPhonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["isWhatsApp"] = this.isWhatsApp;
        return data;
    }

    clone(): CreateCustomerPhonesDto {
        const json = this.toJSON();
        let result = new CreateCustomerPhonesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerPhonesDto {
    phoneNumber: string;
    isWhatsApp: boolean;
}

export class CreateEmployeeDto implements ICreateEmployeeDto {
    name: string;
    surname: string;
    email: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    nationalityId: number | undefined;
    dateOfBirth: moment.Moment | undefined;
    idNumber: string | undefined;
    idExpirationDate: moment.Moment | undefined;
    dateOfJoiningCompany: moment.Moment | undefined;
    username: string | undefined;
    salaryAmount: number | undefined;
    accommodationAllowanceAmount: number | undefined;
    transportationAllowanceAmount: number | undefined;
    password: string | undefined;
    isHasUser: boolean;
    isActive: boolean;
    isDeleted: boolean;
    hasCommission: boolean;
    createEmployeeJobDtos: CreateEmployeeJobDto[] | undefined;
    mainJobId: number | undefined;
    secondaryJobIds: number[] | undefined;

    constructor(data?: ICreateEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.nationalityId = _data["nationalityId"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.idNumber = _data["idNumber"];
            this.idExpirationDate = _data["idExpirationDate"] ? moment(_data["idExpirationDate"].toString()) : <any>undefined;
            this.dateOfJoiningCompany = _data["dateOfJoiningCompany"] ? moment(_data["dateOfJoiningCompany"].toString()) : <any>undefined;
            this.username = _data["username"];
            this.salaryAmount = _data["salaryAmount"];
            this.accommodationAllowanceAmount = _data["accommodationAllowanceAmount"];
            this.transportationAllowanceAmount = _data["transportationAllowanceAmount"];
            this.password = _data["password"];
            this.isHasUser = _data["isHasUser"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.hasCommission = _data["hasCommission"];
            if (Array.isArray(_data["createEmployeeJobDtos"])) {
                this.createEmployeeJobDtos = [] as any;
                for (let item of _data["createEmployeeJobDtos"])
                    this.createEmployeeJobDtos.push(CreateEmployeeJobDto.fromJS(item));
            }
            this.mainJobId = _data["mainJobId"];
            if (Array.isArray(_data["secondaryJobIds"])) {
                this.secondaryJobIds = [] as any;
                for (let item of _data["secondaryJobIds"])
                    this.secondaryJobIds.push(item);
            }
        }
    }

    static fromJS(data: any): CreateEmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["nationalityId"] = this.nationalityId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["idNumber"] = this.idNumber;
        data["idExpirationDate"] = this.idExpirationDate ? this.idExpirationDate.toISOString() : <any>undefined;
        data["dateOfJoiningCompany"] = this.dateOfJoiningCompany ? this.dateOfJoiningCompany.toISOString() : <any>undefined;
        data["username"] = this.username;
        data["salaryAmount"] = this.salaryAmount;
        data["accommodationAllowanceAmount"] = this.accommodationAllowanceAmount;
        data["transportationAllowanceAmount"] = this.transportationAllowanceAmount;
        data["password"] = this.password;
        data["isHasUser"] = this.isHasUser;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["hasCommission"] = this.hasCommission;
        if (Array.isArray(this.createEmployeeJobDtos)) {
            data["createEmployeeJobDtos"] = [];
            for (let item of this.createEmployeeJobDtos)
                data["createEmployeeJobDtos"].push(item.toJSON());
        }
        data["mainJobId"] = this.mainJobId;
        if (Array.isArray(this.secondaryJobIds)) {
            data["secondaryJobIds"] = [];
            for (let item of this.secondaryJobIds)
                data["secondaryJobIds"].push(item);
        }
        return data;
    }

    clone(): CreateEmployeeDto {
        const json = this.toJSON();
        let result = new CreateEmployeeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeDto {
    name: string;
    surname: string;
    email: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    nationalityId: number | undefined;
    dateOfBirth: moment.Moment | undefined;
    idNumber: string | undefined;
    idExpirationDate: moment.Moment | undefined;
    dateOfJoiningCompany: moment.Moment | undefined;
    username: string | undefined;
    salaryAmount: number | undefined;
    accommodationAllowanceAmount: number | undefined;
    transportationAllowanceAmount: number | undefined;
    password: string | undefined;
    isHasUser: boolean;
    isActive: boolean;
    isDeleted: boolean;
    hasCommission: boolean;
    createEmployeeJobDtos: CreateEmployeeJobDto[] | undefined;
    mainJobId: number | undefined;
    secondaryJobIds: number[] | undefined;
}

export class CreateEmployeeJobDto implements ICreateEmployeeJobDto {
    employeeId: number | undefined;
    jobId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isMain: boolean;

    constructor(data?: ICreateEmployeeJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.jobId = _data["jobId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isMain = _data["isMain"];
        }
    }

    static fromJS(data: any): CreateEmployeeJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["jobId"] = this.jobId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isMain"] = this.isMain;
        return data;
    }

    clone(): CreateEmployeeJobDto {
        const json = this.toJSON();
        let result = new CreateEmployeeJobDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmployeeJobDto {
    employeeId: number | undefined;
    jobId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isMain: boolean;
}

export class CreateExpenseTransactionDto implements ICreateExpenseTransactionDto {
    paidValue: number;
    note: string | undefined;

    constructor(data?: ICreateExpenseTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paidValue = _data["paidValue"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateExpenseTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExpenseTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paidValue"] = this.paidValue;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateExpenseTransactionDto {
        const json = this.toJSON();
        let result = new CreateExpenseTransactionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateExpenseTransactionDto {
    paidValue: number;
    note: string | undefined;
}

export class CreateGroupDto implements ICreateGroupDto {
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;

    constructor(data?: ICreateGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateGroupDto {
        const json = this.toJSON();
        let result = new CreateGroupDto();
        result.init(json);
        return result;
    }
}

export interface ICreateGroupDto {
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
}

export class CreateJobDto implements ICreateJobDto {
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;

    constructor(data?: ICreateJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateJobDto {
        const json = this.toJSON();
        let result = new CreateJobDto();
        result.init(json);
        return result;
    }
}

export interface ICreateJobDto {
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
}

export class CreateNationalityDto implements ICreateNationalityDto {
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isActive: boolean;

    constructor(data?: ICreateNationalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateNationalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNationalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateNationalityDto {
        const json = this.toJSON();
        let result = new CreateNationalityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateNationalityDto {
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isActive: boolean;
}

export class CreateOfferDto implements ICreateOfferDto {
    id: number;
    groupId: number;
    serviceId: number;
    vehicleTypeId: number;
    carBrandId: number;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    offerType: OfferType;
    weekDays: WeekDays;
    price: number;
    allowed: number;
    isActive: boolean;

    constructor(data?: ICreateOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.serviceId = _data["serviceId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.carBrandId = _data["carBrandId"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
            this.offerType = _data["offerType"];
            this.weekDays = _data["weekDays"];
            this.price = _data["price"];
            this.allowed = _data["allowed"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateOfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["serviceId"] = this.serviceId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["carBrandId"] = this.carBrandId;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["offerType"] = this.offerType;
        data["weekDays"] = this.weekDays;
        data["price"] = this.price;
        data["allowed"] = this.allowed;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateOfferDto {
        const json = this.toJSON();
        let result = new CreateOfferDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOfferDto {
    id: number;
    groupId: number;
    serviceId: number;
    vehicleTypeId: number;
    carBrandId: number;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    offerType: OfferType;
    weekDays: WeekDays;
    price: number;
    allowed: number;
    isActive: boolean;
}

export class CreatePackageDetailsDto implements ICreatePackageDetailsDto {
    packageId: number;
    serviceId: number;
    serviceCount: number;

    constructor(data?: ICreatePackageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.serviceId = _data["serviceId"];
            this.serviceCount = _data["serviceCount"];
        }
    }

    static fromJS(data: any): CreatePackageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["serviceId"] = this.serviceId;
        data["serviceCount"] = this.serviceCount;
        return data;
    }

    clone(): CreatePackageDetailsDto {
        const json = this.toJSON();
        let result = new CreatePackageDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageDetailsDto {
    packageId: number;
    serviceId: number;
    serviceCount: number;
}

export class CreatePackageDto implements ICreatePackageDto {
    name: string;
    duration: PackageDuration;
    carBrandId: number | undefined;
    isAvailableForAllBrands: boolean;
    groupId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    numberOfCars: number | undefined;
    maxSubscribers: number;
    actualUsage: number;
    price: number;
    salesCommissionAmount: number | undefined;
    totalCount: number;
    lastModificationTime: moment.Moment | undefined;
    isTotalCountBased: boolean;
    isDeleted: boolean;
    isActive: boolean;
    isWelcomePackage: boolean;
    packageTypeId: number | undefined;
    vehicleTypeId: number | undefined;
    serviceDetails: CreatePackageDetailsDto[] | undefined;

    constructor(data?: ICreatePackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.duration = _data["duration"];
            this.carBrandId = _data["carBrandId"];
            this.isAvailableForAllBrands = _data["isAvailableForAllBrands"];
            this.groupId = _data["groupId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.numberOfCars = _data["numberOfCars"];
            this.maxSubscribers = _data["maxSubscribers"];
            this.actualUsage = _data["actualUsage"];
            this.price = _data["price"];
            this.salesCommissionAmount = _data["salesCommissionAmount"];
            this.totalCount = _data["totalCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isTotalCountBased = _data["isTotalCountBased"];
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
            this.isWelcomePackage = _data["isWelcomePackage"];
            this.packageTypeId = _data["packageTypeId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            if (Array.isArray(_data["serviceDetails"])) {
                this.serviceDetails = [] as any;
                for (let item of _data["serviceDetails"])
                    this.serviceDetails.push(CreatePackageDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["duration"] = this.duration;
        data["carBrandId"] = this.carBrandId;
        data["isAvailableForAllBrands"] = this.isAvailableForAllBrands;
        data["groupId"] = this.groupId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["numberOfCars"] = this.numberOfCars;
        data["maxSubscribers"] = this.maxSubscribers;
        data["actualUsage"] = this.actualUsage;
        data["price"] = this.price;
        data["salesCommissionAmount"] = this.salesCommissionAmount;
        data["totalCount"] = this.totalCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isTotalCountBased"] = this.isTotalCountBased;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        data["isWelcomePackage"] = this.isWelcomePackage;
        data["packageTypeId"] = this.packageTypeId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        if (Array.isArray(this.serviceDetails)) {
            data["serviceDetails"] = [];
            for (let item of this.serviceDetails)
                data["serviceDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreatePackageDto {
        const json = this.toJSON();
        let result = new CreatePackageDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageDto {
    name: string;
    duration: PackageDuration;
    carBrandId: number | undefined;
    isAvailableForAllBrands: boolean;
    groupId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    numberOfCars: number | undefined;
    maxSubscribers: number;
    actualUsage: number;
    price: number;
    salesCommissionAmount: number | undefined;
    totalCount: number;
    lastModificationTime: moment.Moment | undefined;
    isTotalCountBased: boolean;
    isDeleted: boolean;
    isActive: boolean;
    isWelcomePackage: boolean;
    packageTypeId: number | undefined;
    vehicleTypeId: number | undefined;
    serviceDetails: CreatePackageDetailsDto[] | undefined;
}

export class CreatePackageSubscriptionDto implements ICreatePackageSubscriptionDto {
    id: number;
    packageId: number;
    customerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICreatePackageSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.customerId = _data["customerId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.remainingCount = _data["remainingCount"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreatePackageSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["customerId"] = this.customerId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["remainingCount"] = this.remainingCount;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CreatePackageSubscriptionDto {
        const json = this.toJSON();
        let result = new CreatePackageSubscriptionDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageSubscriptionDto {
    id: number;
    packageId: number;
    customerId: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CreatePackageTypeDto implements ICreatePackageTypeDto {
    name: string;
    availableDays: WeekDays;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    isActive: boolean;

    constructor(data?: ICreatePackageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.availableDays = _data["availableDays"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreatePackageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePackageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["availableDays"] = this.availableDays;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreatePackageTypeDto {
        const json = this.toJSON();
        let result = new CreatePackageTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePackageTypeDto {
    name: string;
    availableDays: WeekDays;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    isActive: boolean;
}

export class CreateReferralDto implements ICreateReferralDto {
    name: string;
    phoneNumber: string | undefined;
    address: string | undefined;
    contactPerson: string | undefined;
    isActive: boolean;
    maxUsagesPerCustomer: number;
    specialPackageTypeId: number | undefined;

    constructor(data?: ICreateReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.isActive = _data["isActive"];
            this.maxUsagesPerCustomer = _data["maxUsagesPerCustomer"];
            this.specialPackageTypeId = _data["specialPackageTypeId"];
        }
    }

    static fromJS(data: any): CreateReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["isActive"] = this.isActive;
        data["maxUsagesPerCustomer"] = this.maxUsagesPerCustomer;
        data["specialPackageTypeId"] = this.specialPackageTypeId;
        return data;
    }

    clone(): CreateReferralDto {
        const json = this.toJSON();
        let result = new CreateReferralDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReferralDto {
    name: string;
    phoneNumber: string | undefined;
    address: string | undefined;
    contactPerson: string | undefined;
    isActive: boolean;
    maxUsagesPerCustomer: number;
    specialPackageTypeId: number | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateServiceCheckListDto implements ICreateServiceCheckListDto {
    title: string;
    description: string | undefined;
    ordering: number;
    serviceId: number;
    service: ServiceEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICreateServiceCheckListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.ordering = _data["ordering"];
            this.serviceId = _data["serviceId"];
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateServiceCheckListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceCheckListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["ordering"] = this.ordering;
        data["serviceId"] = this.serviceId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CreateServiceCheckListDto {
        const json = this.toJSON();
        let result = new CreateServiceCheckListDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceCheckListDto {
    title: string;
    description: string | undefined;
    ordering: number;
    serviceId: number;
    service: ServiceEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CreateServiceDto implements ICreateServiceDto {
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isGrouped: boolean | undefined;
    groupId: number | undefined;
    supervisorCommissionAmount: number | undefined;
    receptionCommissionAmount: number | undefined;
    serviceSteps: CreateServiceStepDto[] | undefined;

    constructor(data?: ICreateServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isGrouped = _data["isGrouped"];
            this.groupId = _data["groupId"];
            this.supervisorCommissionAmount = _data["supervisorCommissionAmount"];
            this.receptionCommissionAmount = _data["receptionCommissionAmount"];
            if (Array.isArray(_data["serviceSteps"])) {
                this.serviceSteps = [] as any;
                for (let item of _data["serviceSteps"])
                    this.serviceSteps.push(CreateServiceStepDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isGrouped"] = this.isGrouped;
        data["groupId"] = this.groupId;
        data["supervisorCommissionAmount"] = this.supervisorCommissionAmount;
        data["receptionCommissionAmount"] = this.receptionCommissionAmount;
        if (Array.isArray(this.serviceSteps)) {
            data["serviceSteps"] = [];
            for (let item of this.serviceSteps)
                data["serviceSteps"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateServiceDto {
        const json = this.toJSON();
        let result = new CreateServiceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceDto {
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isGrouped: boolean | undefined;
    groupId: number | undefined;
    supervisorCommissionAmount: number | undefined;
    receptionCommissionAmount: number | undefined;
    serviceSteps: CreateServiceStepDto[] | undefined;
}

export class CreateServicePriceDto implements ICreateServicePriceDto {
    serviceId: number;
    price: number;
    vehicleTypeId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICreateServicePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.price = _data["price"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateServicePriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServicePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["price"] = this.price;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CreateServicePriceDto {
        const json = this.toJSON();
        let result = new CreateServicePriceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServicePriceDto {
    serviceId: number;
    price: number;
    vehicleTypeId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CreateServiceStepDto implements ICreateServiceStepDto {
    name: string;
    description: string | undefined;
    expectedTime: number | undefined;
    serviceId: number | undefined;
    order: number | undefined;
    commission: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICreateServiceStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.expectedTime = _data["expectedTime"];
            this.serviceId = _data["serviceId"];
            this.order = _data["order"];
            this.commission = _data["commission"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateServiceStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["expectedTime"] = this.expectedTime;
        data["serviceId"] = this.serviceId;
        data["order"] = this.order;
        data["commission"] = this.commission;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CreateServiceStepDto {
        const json = this.toJSON();
        let result = new CreateServiceStepDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceStepDto {
    name: string;
    description: string | undefined;
    expectedTime: number | undefined;
    serviceId: number | undefined;
    order: number | undefined;
    commission: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateUpdateSpecialPackageTypeDto implements ICreateUpdateSpecialPackageTypeDto {
    id: number;
    name: string;
    isActive: boolean;

    constructor(data?: ICreateUpdateSpecialPackageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateUpdateSpecialPackageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateSpecialPackageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateUpdateSpecialPackageTypeDto {
        const json = this.toJSON();
        let result = new CreateUpdateSpecialPackageTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateSpecialPackageTypeDto {
    id: number;
    name: string;
    isActive: boolean;
}

export class CreateUserDto implements ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["password"] = this.password;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    roleNames: string[] | undefined;
    password: string;
}

export class CreateVehicleDto implements ICreateVehicleDto {
    customerId: number;
    yearOfManufacture: string | undefined;
    licencePlate: string;
    emirate: EmiratesEnum;
    color: string | undefined;
    vehicleTypeID: number;
    carBrandId: number;
    carModelId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICreateVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.yearOfManufacture = _data["yearOfManufacture"];
            this.licencePlate = _data["licencePlate"];
            this.emirate = _data["emirate"];
            this.color = _data["color"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.carBrandId = _data["carBrandId"];
            this.carModelId = _data["carModelId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["yearOfManufacture"] = this.yearOfManufacture;
        data["licencePlate"] = this.licencePlate;
        data["emirate"] = this.emirate;
        data["color"] = this.color;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["carBrandId"] = this.carBrandId;
        data["carModelId"] = this.carModelId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CreateVehicleDto {
        const json = this.toJSON();
        let result = new CreateVehicleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleDto {
    customerId: number;
    yearOfManufacture: string | undefined;
    licencePlate: string;
    emirate: EmiratesEnum;
    color: string | undefined;
    vehicleTypeID: number;
    carBrandId: number;
    carModelId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CreateWhatsappMessageDto implements ICreateWhatsappMessageDto {
    title: string | undefined;
    message: string | undefined;

    constructor(data?: ICreateWhatsappMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateWhatsappMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWhatsappMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["message"] = this.message;
        return data;
    }

    clone(): CreateWhatsappMessageDto {
        const json = this.toJSON();
        let result = new CreateWhatsappMessageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWhatsappMessageDto {
    title: string | undefined;
    message: string | undefined;
}

export class CurrencyDto implements ICurrencyDto {
    id: number;
    name: string;
    symbol: string | undefined;

    constructor(data?: ICurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
        }
    }

    static fromJS(data: any): CurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        return data;
    }

    clone(): CurrencyDto {
        const json = this.toJSON();
        let result = new CurrencyDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyDto {
    id: number;
    name: string;
    symbol: string | undefined;
}

export class CurrencyDtoPagedResultDto implements ICurrencyDtoPagedResultDto {
    items: CurrencyDto[] | undefined;
    totalCount: number;

    constructor(data?: ICurrencyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CurrencyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CurrencyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CurrencyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CurrencyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyDtoPagedResultDto {
    items: CurrencyDto[] | undefined;
    totalCount: number;
}

export class CurrencyEntity implements ICurrencyEntity {
    id: number;
    name: string;
    symbol: string | undefined;

    constructor(data?: ICurrencyEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.symbol = _data["symbol"];
        }
    }

    static fromJS(data: any): CurrencyEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["symbol"] = this.symbol;
        return data;
    }

    clone(): CurrencyEntity {
        const json = this.toJSON();
        let result = new CurrencyEntity();
        result.init(json);
        return result;
    }
}

export interface ICurrencyEntity {
    id: number;
    name: string;
    symbol: string | undefined;
}

export class CustomerBillsReportItemDto implements ICustomerBillsReportItemDto {
    rank: number;
    customerId: number;
    customerName: string | undefined;
    billCount: number;
    totalValue: number;
    percentage: number;

    constructor(data?: ICustomerBillsReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.billCount = _data["billCount"];
            this.totalValue = _data["totalValue"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): CustomerBillsReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBillsReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["billCount"] = this.billCount;
        data["totalValue"] = this.totalValue;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): CustomerBillsReportItemDto {
        const json = this.toJSON();
        let result = new CustomerBillsReportItemDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerBillsReportItemDto {
    rank: number;
    customerId: number;
    customerName: string | undefined;
    billCount: number;
    totalValue: number;
    percentage: number;
}

export class CustomerBillsReportResultDto implements ICustomerBillsReportResultDto {
    totalCustomers: number;
    totalBills: number;
    totalValue: number;
    customerBreakdown: CustomerBillsReportItemDto[] | undefined;

    constructor(data?: ICustomerBillsReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCustomers = _data["totalCustomers"];
            this.totalBills = _data["totalBills"];
            this.totalValue = _data["totalValue"];
            if (Array.isArray(_data["customerBreakdown"])) {
                this.customerBreakdown = [] as any;
                for (let item of _data["customerBreakdown"])
                    this.customerBreakdown.push(CustomerBillsReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerBillsReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerBillsReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCustomers"] = this.totalCustomers;
        data["totalBills"] = this.totalBills;
        data["totalValue"] = this.totalValue;
        if (Array.isArray(this.customerBreakdown)) {
            data["customerBreakdown"] = [];
            for (let item of this.customerBreakdown)
                data["customerBreakdown"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerBillsReportResultDto {
        const json = this.toJSON();
        let result = new CustomerBillsReportResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerBillsReportResultDto {
    totalCustomers: number;
    totalBills: number;
    totalValue: number;
    customerBreakdown: CustomerBillsReportItemDto[] | undefined;
}

export class CustomerDetailsDto implements ICustomerDetailsDto {
    id: number;
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    phoneNumbers: CustomerPhonesEntity[] | undefined;
    vehicles: VehicleEntity[] | undefined;
    subscripedPackages: PackageSubscriptionEntity[] | undefined;
    allBills: BillEntity[] | undefined;

    constructor(data?: ICustomerDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.howDoYouKnowUsID = _data["howDoYouKnowUsID"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(CustomerPhonesEntity.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleEntity.fromJS(item));
            }
            if (Array.isArray(_data["subscripedPackages"])) {
                this.subscripedPackages = [] as any;
                for (let item of _data["subscripedPackages"])
                    this.subscripedPackages.push(PackageSubscriptionEntity.fromJS(item));
            }
            if (Array.isArray(_data["allBills"])) {
                this.allBills = [] as any;
                for (let item of _data["allBills"])
                    this.allBills.push(BillEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["howDoYouKnowUsID"] = this.howDoYouKnowUsID;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.subscripedPackages)) {
            data["subscripedPackages"] = [];
            for (let item of this.subscripedPackages)
                data["subscripedPackages"].push(item.toJSON());
        }
        if (Array.isArray(this.allBills)) {
            data["allBills"] = [];
            for (let item of this.allBills)
                data["allBills"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerDetailsDto {
        const json = this.toJSON();
        let result = new CustomerDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDetailsDto {
    id: number;
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    phoneNumbers: CustomerPhonesEntity[] | undefined;
    vehicles: VehicleEntity[] | undefined;
    subscripedPackages: PackageSubscriptionEntity[] | undefined;
    allBills: BillEntity[] | undefined;
}

export class CustomerEntity implements ICustomerEntity {
    id: number;
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    phoneNumbers: CustomerPhonesEntity[] | undefined;
    vehicles: VehicleEntity[] | undefined;

    constructor(data?: ICustomerEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.howDoYouKnowUsID = _data["howDoYouKnowUsID"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(CustomerPhonesEntity.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["howDoYouKnowUsID"] = this.howDoYouKnowUsID;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        return data;
    }

    clone(): CustomerEntity {
        const json = this.toJSON();
        let result = new CustomerEntity();
        result.init(json);
        return result;
    }
}

export interface ICustomerEntity {
    id: number;
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    phoneNumbers: CustomerPhonesEntity[] | undefined;
    vehicles: VehicleEntity[] | undefined;
}

export class CustomerPhonesDto implements ICustomerPhonesDto {
    id: number;
    customerId: number;
    phoneNumber: string;
    isWhatsApp: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICustomerPhonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.phoneNumber = _data["phoneNumber"];
            this.isWhatsApp = _data["isWhatsApp"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CustomerPhonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPhonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["phoneNumber"] = this.phoneNumber;
        data["isWhatsApp"] = this.isWhatsApp;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CustomerPhonesDto {
        const json = this.toJSON();
        let result = new CustomerPhonesDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerPhonesDto {
    id: number;
    customerId: number;
    phoneNumber: string;
    isWhatsApp: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CustomerPhonesDtoPagedResultDto implements ICustomerPhonesDtoPagedResultDto {
    items: CustomerPhonesDto[] | undefined;
    totalCount: number;

    constructor(data?: ICustomerPhonesDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerPhonesDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomerPhonesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPhonesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomerPhonesDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerPhonesDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerPhonesDtoPagedResultDto {
    items: CustomerPhonesDto[] | undefined;
    totalCount: number;
}

export class CustomerPhonesEntity implements ICustomerPhonesEntity {
    id: number;
    customerId: number;
    phoneNumber: string;
    isWhatsApp: boolean;
    customer: CustomerEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICustomerPhonesEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.phoneNumber = _data["phoneNumber"];
            this.isWhatsApp = _data["isWhatsApp"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CustomerPhonesEntity {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerPhonesEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["phoneNumber"] = this.phoneNumber;
        data["isWhatsApp"] = this.isWhatsApp;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CustomerPhonesEntity {
        const json = this.toJSON();
        let result = new CustomerPhonesEntity();
        result.init(json);
        return result;
    }
}

export interface ICustomerPhonesEntity {
    id: number;
    customerId: number;
    phoneNumber: string;
    isWhatsApp: boolean;
    customer: CustomerEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CustomersStatsDto implements ICustomersStatsDto {
    totalCount: number;
    newCustomers: number;

    constructor(data?: ICustomersStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.newCustomers = _data["newCustomers"];
        }
    }

    static fromJS(data: any): CustomersStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["newCustomers"] = this.newCustomers;
        return data;
    }

    clone(): CustomersStatsDto {
        const json = this.toJSON();
        let result = new CustomersStatsDto();
        result.init(json);
        return result;
    }
}

export interface ICustomersStatsDto {
    totalCount: number;
    newCustomers: number;
}

export class CustomerStatsDto implements ICustomerStatsDto {
    id: number;
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    phoneNumbers: CustomerPhonesDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ICustomerStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.howDoYouKnowUsID = _data["howDoYouKnowUsID"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers.push(CustomerPhonesDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleDto.fromJS(item));
            }
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CustomerStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["howDoYouKnowUsID"] = this.howDoYouKnowUsID;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): CustomerStatsDto {
        const json = this.toJSON();
        let result = new CustomerStatsDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerStatsDto {
    id: number;
    name: string;
    address: string | undefined;
    howDoYouKnowUsID: HowDoYouKnowUsEnum;
    phoneNumbers: CustomerPhonesDto[] | undefined;
    vehicles: VehicleDto[] | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class CustomerStatsDtoPagedResultDto implements ICustomerStatsDtoPagedResultDto {
    items: CustomerStatsDto[] | undefined;
    totalCount: number;

    constructor(data?: ICustomerStatsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(CustomerStatsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomerStatsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerStatsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomerStatsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerStatsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerStatsDtoPagedResultDto {
    items: CustomerStatsDto[] | undefined;
    totalCount: number;
}

export class DashboardDto implements IDashboardDto {
    customers: CustomersStatsDto;
    employees: EmployeesStatsDto;
    yearlySales: YearlySalesStatsDto;
    serviceSales: ServiceSalesDto[] | undefined;
    packageSubscriptions: PackageSubscrptionDetailsDto[] | undefined;
    billsInfoDetails: BillsInfoDto[] | undefined;
    vehicles: NewVehiclesDto[] | undefined;
    vehicleBrandSales: VehicleSalesPerBrandDto[] | undefined;
    vehicleTypes: VehicleTypesDto[] | undefined;
    targetInfo: TargetInfoDto;

    constructor(data?: IDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customers = _data["customers"] ? CustomersStatsDto.fromJS(_data["customers"]) : <any>undefined;
            this.employees = _data["employees"] ? EmployeesStatsDto.fromJS(_data["employees"]) : <any>undefined;
            this.yearlySales = _data["yearlySales"] ? YearlySalesStatsDto.fromJS(_data["yearlySales"]) : <any>undefined;
            if (Array.isArray(_data["serviceSales"])) {
                this.serviceSales = [] as any;
                for (let item of _data["serviceSales"])
                    this.serviceSales.push(ServiceSalesDto.fromJS(item));
            }
            if (Array.isArray(_data["packageSubscriptions"])) {
                this.packageSubscriptions = [] as any;
                for (let item of _data["packageSubscriptions"])
                    this.packageSubscriptions.push(PackageSubscrptionDetailsDto.fromJS(item));
            }
            if (Array.isArray(_data["billsInfoDetails"])) {
                this.billsInfoDetails = [] as any;
                for (let item of _data["billsInfoDetails"])
                    this.billsInfoDetails.push(BillsInfoDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(NewVehiclesDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicleBrandSales"])) {
                this.vehicleBrandSales = [] as any;
                for (let item of _data["vehicleBrandSales"])
                    this.vehicleBrandSales.push(VehicleSalesPerBrandDto.fromJS(item));
            }
            if (Array.isArray(_data["vehicleTypes"])) {
                this.vehicleTypes = [] as any;
                for (let item of _data["vehicleTypes"])
                    this.vehicleTypes.push(VehicleTypesDto.fromJS(item));
            }
            this.targetInfo = _data["targetInfo"] ? TargetInfoDto.fromJS(_data["targetInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customers"] = this.customers ? this.customers.toJSON() : <any>undefined;
        data["employees"] = this.employees ? this.employees.toJSON() : <any>undefined;
        data["yearlySales"] = this.yearlySales ? this.yearlySales.toJSON() : <any>undefined;
        if (Array.isArray(this.serviceSales)) {
            data["serviceSales"] = [];
            for (let item of this.serviceSales)
                data["serviceSales"].push(item.toJSON());
        }
        if (Array.isArray(this.packageSubscriptions)) {
            data["packageSubscriptions"] = [];
            for (let item of this.packageSubscriptions)
                data["packageSubscriptions"].push(item.toJSON());
        }
        if (Array.isArray(this.billsInfoDetails)) {
            data["billsInfoDetails"] = [];
            for (let item of this.billsInfoDetails)
                data["billsInfoDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleBrandSales)) {
            data["vehicleBrandSales"] = [];
            for (let item of this.vehicleBrandSales)
                data["vehicleBrandSales"].push(item.toJSON());
        }
        if (Array.isArray(this.vehicleTypes)) {
            data["vehicleTypes"] = [];
            for (let item of this.vehicleTypes)
                data["vehicleTypes"].push(item.toJSON());
        }
        data["targetInfo"] = this.targetInfo ? this.targetInfo.toJSON() : <any>undefined;
        return data;
    }

    clone(): DashboardDto {
        const json = this.toJSON();
        let result = new DashboardDto();
        result.init(json);
        return result;
    }
}

export interface IDashboardDto {
    customers: CustomersStatsDto;
    employees: EmployeesStatsDto;
    yearlySales: YearlySalesStatsDto;
    serviceSales: ServiceSalesDto[] | undefined;
    packageSubscriptions: PackageSubscrptionDetailsDto[] | undefined;
    billsInfoDetails: BillsInfoDto[] | undefined;
    vehicles: NewVehiclesDto[] | undefined;
    vehicleBrandSales: VehicleSalesPerBrandDto[] | undefined;
    vehicleTypes: VehicleTypesDto[] | undefined;
    targetInfo: TargetInfoDto;
}

export enum EmiratesEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class EmployeeCommissionDetailDto implements IEmployeeCommissionDetailDto {
    employeeId: number;
    employeeName: string | undefined;
    totalCommission: number;
    steps: StepCommissionItemDto[] | undefined;
    billsCreated: BillCreatorCommissionItemDto[] | undefined;
    packagesSold: PackageSaleCommissionItemDto[] | undefined;
    billsSupervised: SupervisorCommissionItemDto[] | undefined;

    constructor(data?: IEmployeeCommissionDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.totalCommission = _data["totalCommission"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps.push(StepCommissionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["billsCreated"])) {
                this.billsCreated = [] as any;
                for (let item of _data["billsCreated"])
                    this.billsCreated.push(BillCreatorCommissionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["packagesSold"])) {
                this.packagesSold = [] as any;
                for (let item of _data["packagesSold"])
                    this.packagesSold.push(PackageSaleCommissionItemDto.fromJS(item));
            }
            if (Array.isArray(_data["billsSupervised"])) {
                this.billsSupervised = [] as any;
                for (let item of _data["billsSupervised"])
                    this.billsSupervised.push(SupervisorCommissionItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeCommissionDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCommissionDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["totalCommission"] = this.totalCommission;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.billsCreated)) {
            data["billsCreated"] = [];
            for (let item of this.billsCreated)
                data["billsCreated"].push(item.toJSON());
        }
        if (Array.isArray(this.packagesSold)) {
            data["packagesSold"] = [];
            for (let item of this.packagesSold)
                data["packagesSold"].push(item.toJSON());
        }
        if (Array.isArray(this.billsSupervised)) {
            data["billsSupervised"] = [];
            for (let item of this.billsSupervised)
                data["billsSupervised"].push(item.toJSON());
        }
        return data;
    }

    clone(): EmployeeCommissionDetailDto {
        const json = this.toJSON();
        let result = new EmployeeCommissionDetailDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeCommissionDetailDto {
    employeeId: number;
    employeeName: string | undefined;
    totalCommission: number;
    steps: StepCommissionItemDto[] | undefined;
    billsCreated: BillCreatorCommissionItemDto[] | undefined;
    packagesSold: PackageSaleCommissionItemDto[] | undefined;
    billsSupervised: SupervisorCommissionItemDto[] | undefined;
}

export class EmployeeCommissionDto implements IEmployeeCommissionDto {
    employeeId: number;
    employeeName: string | undefined;
    totalCommission: number;
    totalAssignedServices: number;

    constructor(data?: IEmployeeCommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.totalCommission = _data["totalCommission"];
            this.totalAssignedServices = _data["totalAssignedServices"];
        }
    }

    static fromJS(data: any): EmployeeCommissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["totalCommission"] = this.totalCommission;
        data["totalAssignedServices"] = this.totalAssignedServices;
        return data;
    }

    clone(): EmployeeCommissionDto {
        const json = this.toJSON();
        let result = new EmployeeCommissionDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeCommissionDto {
    employeeId: number;
    employeeName: string | undefined;
    totalCommission: number;
    totalAssignedServices: number;
}

export class EmployeeDto implements IEmployeeDto {
    id: number;
    name: string;
    surname: string;
    email: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    nationalityId: number | undefined;
    dateOfBirth: moment.Moment | undefined;
    idNumber: string | undefined;
    idExpirationDate: moment.Moment | undefined;
    dateOfJoiningCompany: moment.Moment | undefined;
    username: string | undefined;
    salaryAmount: number | undefined;
    accommodationAllowanceAmount: number | undefined;
    transportationAllowanceAmount: number | undefined;
    password: string | undefined;
    isHasUser: boolean;
    isActive: boolean;
    isDeleted: boolean;
    hasCommission: boolean;
    employeeJobDtos: EmployeeJobDto[] | undefined;
    createEmployeeJobDtos: CreateEmployeeJobDto[] | undefined;
    mainJobId: number | undefined;
    secondaryJobIds: number[] | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.nationalityId = _data["nationalityId"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.idNumber = _data["idNumber"];
            this.idExpirationDate = _data["idExpirationDate"] ? moment(_data["idExpirationDate"].toString()) : <any>undefined;
            this.dateOfJoiningCompany = _data["dateOfJoiningCompany"] ? moment(_data["dateOfJoiningCompany"].toString()) : <any>undefined;
            this.username = _data["username"];
            this.salaryAmount = _data["salaryAmount"];
            this.accommodationAllowanceAmount = _data["accommodationAllowanceAmount"];
            this.transportationAllowanceAmount = _data["transportationAllowanceAmount"];
            this.password = _data["password"];
            this.isHasUser = _data["isHasUser"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.hasCommission = _data["hasCommission"];
            if (Array.isArray(_data["employeeJobDtos"])) {
                this.employeeJobDtos = [] as any;
                for (let item of _data["employeeJobDtos"])
                    this.employeeJobDtos.push(EmployeeJobDto.fromJS(item));
            }
            if (Array.isArray(_data["createEmployeeJobDtos"])) {
                this.createEmployeeJobDtos = [] as any;
                for (let item of _data["createEmployeeJobDtos"])
                    this.createEmployeeJobDtos.push(CreateEmployeeJobDto.fromJS(item));
            }
            this.mainJobId = _data["mainJobId"];
            if (Array.isArray(_data["secondaryJobIds"])) {
                this.secondaryJobIds = [] as any;
                for (let item of _data["secondaryJobIds"])
                    this.secondaryJobIds.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["nationalityId"] = this.nationalityId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["idNumber"] = this.idNumber;
        data["idExpirationDate"] = this.idExpirationDate ? this.idExpirationDate.toISOString() : <any>undefined;
        data["dateOfJoiningCompany"] = this.dateOfJoiningCompany ? this.dateOfJoiningCompany.toISOString() : <any>undefined;
        data["username"] = this.username;
        data["salaryAmount"] = this.salaryAmount;
        data["accommodationAllowanceAmount"] = this.accommodationAllowanceAmount;
        data["transportationAllowanceAmount"] = this.transportationAllowanceAmount;
        data["password"] = this.password;
        data["isHasUser"] = this.isHasUser;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["hasCommission"] = this.hasCommission;
        if (Array.isArray(this.employeeJobDtos)) {
            data["employeeJobDtos"] = [];
            for (let item of this.employeeJobDtos)
                data["employeeJobDtos"].push(item.toJSON());
        }
        if (Array.isArray(this.createEmployeeJobDtos)) {
            data["createEmployeeJobDtos"] = [];
            for (let item of this.createEmployeeJobDtos)
                data["createEmployeeJobDtos"].push(item.toJSON());
        }
        data["mainJobId"] = this.mainJobId;
        if (Array.isArray(this.secondaryJobIds)) {
            data["secondaryJobIds"] = [];
            for (let item of this.secondaryJobIds)
                data["secondaryJobIds"].push(item);
        }
        return data;
    }

    clone(): EmployeeDto {
        const json = this.toJSON();
        let result = new EmployeeDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeDto {
    id: number;
    name: string;
    surname: string;
    email: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    nationalityId: number | undefined;
    dateOfBirth: moment.Moment | undefined;
    idNumber: string | undefined;
    idExpirationDate: moment.Moment | undefined;
    dateOfJoiningCompany: moment.Moment | undefined;
    username: string | undefined;
    salaryAmount: number | undefined;
    accommodationAllowanceAmount: number | undefined;
    transportationAllowanceAmount: number | undefined;
    password: string | undefined;
    isHasUser: boolean;
    isActive: boolean;
    isDeleted: boolean;
    hasCommission: boolean;
    employeeJobDtos: EmployeeJobDto[] | undefined;
    createEmployeeJobDtos: CreateEmployeeJobDto[] | undefined;
    mainJobId: number | undefined;
    secondaryJobIds: number[] | undefined;
}

export class EmployeeDtoPagedResultDto implements IEmployeeDtoPagedResultDto {
    items: EmployeeDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeDtoPagedResultDto {
    items: EmployeeDto[] | undefined;
    totalCount: number;
}

export class EmployeeEntity implements IEmployeeEntity {
    id: number;
    name: string;
    surname: string;
    email: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    nationalityId: number | undefined;
    dateOfBirth: moment.Moment | undefined;
    idNumber: string | undefined;
    idExpirationDate: moment.Moment | undefined;
    dateOfJoiningCompany: moment.Moment | undefined;
    username: string | undefined;
    salaryAmount: number | undefined;
    accommodationAllowanceAmount: number | undefined;
    transportationAllowanceAmount: number | undefined;
    isHasUser: boolean;
    isActive: boolean;
    hasCommission: boolean;
    isDeleted: boolean;

    constructor(data?: IEmployeeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.email = _data["email"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.nationalityId = _data["nationalityId"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.idNumber = _data["idNumber"];
            this.idExpirationDate = _data["idExpirationDate"] ? moment(_data["idExpirationDate"].toString()) : <any>undefined;
            this.dateOfJoiningCompany = _data["dateOfJoiningCompany"] ? moment(_data["dateOfJoiningCompany"].toString()) : <any>undefined;
            this.username = _data["username"];
            this.salaryAmount = _data["salaryAmount"];
            this.accommodationAllowanceAmount = _data["accommodationAllowanceAmount"];
            this.transportationAllowanceAmount = _data["transportationAllowanceAmount"];
            this.isHasUser = _data["isHasUser"];
            this.isActive = _data["isActive"];
            this.hasCommission = _data["hasCommission"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): EmployeeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["email"] = this.email;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["nationalityId"] = this.nationalityId;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
        data["idNumber"] = this.idNumber;
        data["idExpirationDate"] = this.idExpirationDate ? this.idExpirationDate.toISOString() : <any>undefined;
        data["dateOfJoiningCompany"] = this.dateOfJoiningCompany ? this.dateOfJoiningCompany.toISOString() : <any>undefined;
        data["username"] = this.username;
        data["salaryAmount"] = this.salaryAmount;
        data["accommodationAllowanceAmount"] = this.accommodationAllowanceAmount;
        data["transportationAllowanceAmount"] = this.transportationAllowanceAmount;
        data["isHasUser"] = this.isHasUser;
        data["isActive"] = this.isActive;
        data["hasCommission"] = this.hasCommission;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): EmployeeEntity {
        const json = this.toJSON();
        let result = new EmployeeEntity();
        result.init(json);
        return result;
    }
}

export interface IEmployeeEntity {
    id: number;
    name: string;
    surname: string;
    email: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    nationalityId: number | undefined;
    dateOfBirth: moment.Moment | undefined;
    idNumber: string | undefined;
    idExpirationDate: moment.Moment | undefined;
    dateOfJoiningCompany: moment.Moment | undefined;
    username: string | undefined;
    salaryAmount: number | undefined;
    accommodationAllowanceAmount: number | undefined;
    transportationAllowanceAmount: number | undefined;
    isHasUser: boolean;
    isActive: boolean;
    hasCommission: boolean;
    isDeleted: boolean;
}

export class EmployeeJobDto implements IEmployeeJobDto {
    id: number;
    employeeId: number | undefined;
    jobId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isMain: boolean;

    constructor(data?: IEmployeeJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.jobId = _data["jobId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isMain = _data["isMain"];
        }
    }

    static fromJS(data: any): EmployeeJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["jobId"] = this.jobId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isMain"] = this.isMain;
        return data;
    }

    clone(): EmployeeJobDto {
        const json = this.toJSON();
        let result = new EmployeeJobDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeJobDto {
    id: number;
    employeeId: number | undefined;
    jobId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isMain: boolean;
}

export class EmployeeJobDtoPagedResultDto implements IEmployeeJobDtoPagedResultDto {
    items: EmployeeJobDto[] | undefined;
    totalCount: number;

    constructor(data?: IEmployeeJobDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(EmployeeJobDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EmployeeJobDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeJobDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EmployeeJobDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EmployeeJobDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeJobDtoPagedResultDto {
    items: EmployeeJobDto[] | undefined;
    totalCount: number;
}

export class EmployeeNameDto implements IEmployeeNameDto {
    id: number;
    name: string | undefined;

    constructor(data?: IEmployeeNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmployeeNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): EmployeeNameDto {
        const json = this.toJSON();
        let result = new EmployeeNameDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeeNameDto {
    id: number;
    name: string | undefined;
}

export class EmployeesStatsDto implements IEmployeesStatsDto {
    totalCount: number;
    newEmployees: number;

    constructor(data?: IEmployeesStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            this.newEmployees = _data["newEmployees"];
        }
    }

    static fromJS(data: any): EmployeesStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeesStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        data["newEmployees"] = this.newEmployees;
        return data;
    }

    clone(): EmployeesStatsDto {
        const json = this.toJSON();
        let result = new EmployeesStatsDto();
        result.init(json);
        return result;
    }
}

export interface IEmployeesStatsDto {
    totalCount: number;
    newEmployees: number;
}

export class EndShiftResultDto implements IEndShiftResultDto {
    shiftId: number;
    startTime: moment.Moment;
    endTime: moment.Moment;
    hoursWorked: number;
    totalBills: number;
    totalIncome: number;
    totalExpenses: number;

    constructor(data?: IEndShiftResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftId = _data["shiftId"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.hoursWorked = _data["hoursWorked"];
            this.totalBills = _data["totalBills"];
            this.totalIncome = _data["totalIncome"];
            this.totalExpenses = _data["totalExpenses"];
        }
    }

    static fromJS(data: any): EndShiftResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EndShiftResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftId"] = this.shiftId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["hoursWorked"] = this.hoursWorked;
        data["totalBills"] = this.totalBills;
        data["totalIncome"] = this.totalIncome;
        data["totalExpenses"] = this.totalExpenses;
        return data;
    }

    clone(): EndShiftResultDto {
        const json = this.toJSON();
        let result = new EndShiftResultDto();
        result.init(json);
        return result;
    }
}

export interface IEndShiftResultDto {
    shiftId: number;
    startTime: moment.Moment;
    endTime: moment.Moment;
    hoursWorked: number;
    totalBills: number;
    totalIncome: number;
    totalExpenses: number;
}

export class ExecutBillsDto implements IExecutBillsDto {
    orderId: number;
    vehicleId: number;
    customerName: string | undefined;
    customer: CustomerStatsDto;
    billServices: ExecuteServices[] | undefined;
    billCreationTime: moment.Moment | undefined;
    isSubscriptionBill: boolean;
    packageName: string | undefined;
    total: number;

    constructor(data?: IExecutBillsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.vehicleId = _data["vehicleId"];
            this.customerName = _data["customerName"];
            this.customer = _data["customer"] ? CustomerStatsDto.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["billServices"])) {
                this.billServices = [] as any;
                for (let item of _data["billServices"])
                    this.billServices.push(ExecuteServices.fromJS(item));
            }
            this.billCreationTime = _data["billCreationTime"] ? moment(_data["billCreationTime"].toString()) : <any>undefined;
            this.isSubscriptionBill = _data["isSubscriptionBill"];
            this.packageName = _data["packageName"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ExecutBillsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutBillsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["vehicleId"] = this.vehicleId;
        data["customerName"] = this.customerName;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.billServices)) {
            data["billServices"] = [];
            for (let item of this.billServices)
                data["billServices"].push(item.toJSON());
        }
        data["billCreationTime"] = this.billCreationTime ? this.billCreationTime.toISOString() : <any>undefined;
        data["isSubscriptionBill"] = this.isSubscriptionBill;
        data["packageName"] = this.packageName;
        data["total"] = this.total;
        return data;
    }

    clone(): ExecutBillsDto {
        const json = this.toJSON();
        let result = new ExecutBillsDto();
        result.init(json);
        return result;
    }
}

export interface IExecutBillsDto {
    orderId: number;
    vehicleId: number;
    customerName: string | undefined;
    customer: CustomerStatsDto;
    billServices: ExecuteServices[] | undefined;
    billCreationTime: moment.Moment | undefined;
    isSubscriptionBill: boolean;
    packageName: string | undefined;
    total: number;
}

export class ExecuteServices implements IExecuteServices {
    serviceName: string | undefined;
    serviceId: number;
    serviceNote: string | undefined;
    vehicle: VehicleDto;
    billSteps: BillStep[] | undefined;
    billDetailsId: number;
    supervisorEmployeeId: number | undefined;
    supervisorName: string | undefined;

    constructor(data?: IExecuteServices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceName = _data["serviceName"];
            this.serviceId = _data["serviceId"];
            this.serviceNote = _data["serviceNote"];
            this.vehicle = _data["vehicle"] ? VehicleDto.fromJS(_data["vehicle"]) : <any>undefined;
            if (Array.isArray(_data["billSteps"])) {
                this.billSteps = [] as any;
                for (let item of _data["billSteps"])
                    this.billSteps.push(BillStep.fromJS(item));
            }
            this.billDetailsId = _data["billDetailsId"];
            this.supervisorEmployeeId = _data["supervisorEmployeeId"];
            this.supervisorName = _data["supervisorName"];
        }
    }

    static fromJS(data: any): ExecuteServices {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteServices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceName"] = this.serviceName;
        data["serviceId"] = this.serviceId;
        data["serviceNote"] = this.serviceNote;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        if (Array.isArray(this.billSteps)) {
            data["billSteps"] = [];
            for (let item of this.billSteps)
                data["billSteps"].push(item.toJSON());
        }
        data["billDetailsId"] = this.billDetailsId;
        data["supervisorEmployeeId"] = this.supervisorEmployeeId;
        data["supervisorName"] = this.supervisorName;
        return data;
    }

    clone(): ExecuteServices {
        const json = this.toJSON();
        let result = new ExecuteServices();
        result.init(json);
        return result;
    }
}

export interface IExecuteServices {
    serviceName: string | undefined;
    serviceId: number;
    serviceNote: string | undefined;
    vehicle: VehicleDto;
    billSteps: BillStep[] | undefined;
    billDetailsId: number;
    supervisorEmployeeId: number | undefined;
    supervisorName: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GroupDto implements IGroupDto {
    id: number;
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
    services: ServiceDto[] | undefined;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services.push(ServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        return data;
    }

    clone(): GroupDto {
        const json = this.toJSON();
        let result = new GroupDto();
        result.init(json);
        return result;
    }
}

export interface IGroupDto {
    id: number;
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
    services: ServiceDto[] | undefined;
}

export class GroupDtoPagedResultDto implements IGroupDtoPagedResultDto {
    items: GroupDto[] | undefined;
    totalCount: number;

    constructor(data?: IGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(GroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGroupDtoPagedResultDto {
    items: GroupDto[] | undefined;
    totalCount: number;
}

export class GroupEntity implements IGroupEntity {
    id: number;
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
    services: ServiceEntity[] | undefined;
    targets: TargetSettingsEntity[] | undefined;

    constructor(data?: IGroupEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services.push(ServiceEntity.fromJS(item));
            }
            if (Array.isArray(_data["targets"])) {
                this.targets = [] as any;
                for (let item of _data["targets"])
                    this.targets.push(TargetSettingsEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupEntity {
        data = typeof data === 'object' ? data : {};
        let result = new GroupEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.targets)) {
            data["targets"] = [];
            for (let item of this.targets)
                data["targets"].push(item.toJSON());
        }
        return data;
    }

    clone(): GroupEntity {
        const json = this.toJSON();
        let result = new GroupEntity();
        result.init(json);
        return result;
    }
}

export interface IGroupEntity {
    id: number;
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
    services: ServiceEntity[] | undefined;
    targets: TargetSettingsEntity[] | undefined;
}

export enum HowDoYouKnowUsEnum {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
}

export class Int32StringKeyValuePair implements IInt32StringKeyValuePair {
    key: number;
    value: string | undefined;

    constructor(data?: IInt32StringKeyValuePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Int32StringKeyValuePair {
        data = typeof data === 'object' ? data : {};
        let result = new Int32StringKeyValuePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }

    clone(): Int32StringKeyValuePair {
        const json = this.toJSON();
        let result = new Int32StringKeyValuePair();
        result.init(json);
        return result;
    }
}

export interface IInt32StringKeyValuePair {
    key: number;
    value: string | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class JobDto implements IJobDto {
    id: number;
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;

    constructor(data?: IJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): JobDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): JobDto {
        const json = this.toJSON();
        let result = new JobDto();
        result.init(json);
        return result;
    }
}

export interface IJobDto {
    id: number;
    name: string;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
}

export class JobDtoPagedResultDto implements IJobDtoPagedResultDto {
    items: JobDto[] | undefined;
    totalCount: number;

    constructor(data?: IJobDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(JobDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): JobDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): JobDtoPagedResultDto {
        const json = this.toJSON();
        let result = new JobDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IJobDtoPagedResultDto {
    items: JobDto[] | undefined;
    totalCount: number;
}

export class NationalityDto implements INationalityDto {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isActive: boolean;

    constructor(data?: INationalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): NationalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new NationalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): NationalityDto {
        const json = this.toJSON();
        let result = new NationalityDto();
        result.init(json);
        return result;
    }
}

export interface INationalityDto {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isActive: boolean;
}

export class NationalityDtoPagedResultDto implements INationalityDtoPagedResultDto {
    items: NationalityDto[] | undefined;
    totalCount: number;

    constructor(data?: INationalityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(NationalityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NationalityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NationalityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NationalityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NationalityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INationalityDtoPagedResultDto {
    items: NationalityDto[] | undefined;
    totalCount: number;
}

export class NewVehiclesDto implements INewVehiclesDto {
    totalVehiclesCount: number;
    newVehiclesCount: number;

    constructor(data?: INewVehiclesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalVehiclesCount = _data["totalVehiclesCount"];
            this.newVehiclesCount = _data["newVehiclesCount"];
        }
    }

    static fromJS(data: any): NewVehiclesDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewVehiclesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalVehiclesCount"] = this.totalVehiclesCount;
        data["newVehiclesCount"] = this.newVehiclesCount;
        return data;
    }

    clone(): NewVehiclesDto {
        const json = this.toJSON();
        let result = new NewVehiclesDto();
        result.init(json);
        return result;
    }
}

export interface INewVehiclesDto {
    totalVehiclesCount: number;
    newVehiclesCount: number;
}

export class OfferDto implements IOfferDto {
    id: number;
    groupId: number;
    serviceId: number;
    serviceName: string | undefined;
    vehicleTypeId: number;
    vehicleTypeName: string | undefined;
    carBrandId: number;
    carBrandName: string | undefined;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    offerType: number;
    readonly offerTypeName: string | undefined;
    weekDays: WeekDays;
    price: number;
    allowed: number;
    actual: number;
    isActive: boolean;
    group: GroupDto;
    service: ServiceDto;
    vehicleType: VehicleTypeDto;
    carBrand: CarBrandDto;

    constructor(data?: IOfferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.carBrandId = _data["carBrandId"];
            this.carBrandName = _data["carBrandName"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
            this.offerType = _data["offerType"];
            (<any>this).offerTypeName = _data["offerTypeName"];
            this.weekDays = _data["weekDays"];
            this.price = _data["price"];
            this.allowed = _data["allowed"];
            this.actual = _data["actual"];
            this.isActive = _data["isActive"];
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : <any>undefined;
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"] ? VehicleTypeDto.fromJS(_data["vehicleType"]) : <any>undefined;
            this.carBrand = _data["carBrand"] ? CarBrandDto.fromJS(_data["carBrand"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OfferDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["carBrandId"] = this.carBrandId;
        data["carBrandName"] = this.carBrandName;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["offerType"] = this.offerType;
        data["offerTypeName"] = this.offerTypeName;
        data["weekDays"] = this.weekDays;
        data["price"] = this.price;
        data["allowed"] = this.allowed;
        data["actual"] = this.actual;
        data["isActive"] = this.isActive;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : <any>undefined;
        data["carBrand"] = this.carBrand ? this.carBrand.toJSON() : <any>undefined;
        return data;
    }

    clone(): OfferDto {
        const json = this.toJSON();
        let result = new OfferDto();
        result.init(json);
        return result;
    }
}

export interface IOfferDto {
    id: number;
    groupId: number;
    serviceId: number;
    serviceName: string | undefined;
    vehicleTypeId: number;
    vehicleTypeName: string | undefined;
    carBrandId: number;
    carBrandName: string | undefined;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    offerType: number;
    offerTypeName: string | undefined;
    weekDays: WeekDays;
    price: number;
    allowed: number;
    actual: number;
    isActive: boolean;
    group: GroupDto;
    service: ServiceDto;
    vehicleType: VehicleTypeDto;
    carBrand: CarBrandDto;
}

export class OfferDtoPagedResultDto implements IOfferDtoPagedResultDto {
    items: OfferDto[] | undefined;
    totalCount: number;

    constructor(data?: IOfferDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(OfferDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OfferDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OfferDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OfferDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OfferDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOfferDtoPagedResultDto {
    items: OfferDto[] | undefined;
    totalCount: number;
}

export class OfferEntity implements IOfferEntity {
    id: number;
    groupId: number;
    group: GroupEntity;
    serviceId: number;
    service: ServiceEntity;
    vehicleTypeId: number;
    vehicleType: VehicleTypeEntity;
    carBrandId: number;
    carBrand: CarBrandEntity;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: TimeSpan;
    timeTo: TimeSpan;
    weekDays: WeekDays;
    price: number;
    allowed: number;
    actual: number;
    isActive: boolean;
    offerType: OfferType;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: IOfferEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.group = _data["group"] ? GroupEntity.fromJS(_data["group"]) : <any>undefined;
            this.serviceId = _data["serviceId"];
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleType = _data["vehicleType"] ? VehicleTypeEntity.fromJS(_data["vehicleType"]) : <any>undefined;
            this.carBrandId = _data["carBrandId"];
            this.carBrand = _data["carBrand"] ? CarBrandEntity.fromJS(_data["carBrand"]) : <any>undefined;
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : <any>undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : <any>undefined;
            this.timeFrom = _data["timeFrom"] ? TimeSpan.fromJS(_data["timeFrom"]) : <any>undefined;
            this.timeTo = _data["timeTo"] ? TimeSpan.fromJS(_data["timeTo"]) : <any>undefined;
            this.weekDays = _data["weekDays"];
            this.price = _data["price"];
            this.allowed = _data["allowed"];
            this.actual = _data["actual"];
            this.isActive = _data["isActive"];
            this.offerType = _data["offerType"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OfferEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OfferEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["serviceId"] = this.serviceId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : <any>undefined;
        data["carBrandId"] = this.carBrandId;
        data["carBrand"] = this.carBrand ? this.carBrand.toJSON() : <any>undefined;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : <any>undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : <any>undefined;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toJSON() : <any>undefined;
        data["timeTo"] = this.timeTo ? this.timeTo.toJSON() : <any>undefined;
        data["weekDays"] = this.weekDays;
        data["price"] = this.price;
        data["allowed"] = this.allowed;
        data["actual"] = this.actual;
        data["isActive"] = this.isActive;
        data["offerType"] = this.offerType;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): OfferEntity {
        const json = this.toJSON();
        let result = new OfferEntity();
        result.init(json);
        return result;
    }
}

export interface IOfferEntity {
    id: number;
    groupId: number;
    group: GroupEntity;
    serviceId: number;
    service: ServiceEntity;
    vehicleTypeId: number;
    vehicleType: VehicleTypeEntity;
    carBrandId: number;
    carBrand: CarBrandEntity;
    dateFrom: moment.Moment | undefined;
    dateTo: moment.Moment | undefined;
    timeFrom: TimeSpan;
    timeTo: TimeSpan;
    weekDays: WeekDays;
    price: number;
    allowed: number;
    actual: number;
    isActive: boolean;
    offerType: OfferType;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class OffersReportItemDto implements IOffersReportItemDto {
    rank: number;
    id: number;
    serviceName: string | undefined;
    vehicleTypeName: string | undefined;
    carBrandName: string | undefined;
    groupName: string | undefined;
    offerPrice: number;
    uniqueCustomers: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    firstUse: string | undefined;
    lastUse: string | undefined;
    usageCount: number;
    totalValue: number;
    percentage: number;

    constructor(data?: IOffersReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.id = _data["id"];
            this.serviceName = _data["serviceName"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.carBrandName = _data["carBrandName"];
            this.groupName = _data["groupName"];
            this.offerPrice = _data["offerPrice"];
            this.uniqueCustomers = _data["uniqueCustomers"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.firstUse = _data["firstUse"];
            this.lastUse = _data["lastUse"];
            this.usageCount = _data["usageCount"];
            this.totalValue = _data["totalValue"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): OffersReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffersReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["id"] = this.id;
        data["serviceName"] = this.serviceName;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["carBrandName"] = this.carBrandName;
        data["groupName"] = this.groupName;
        data["offerPrice"] = this.offerPrice;
        data["uniqueCustomers"] = this.uniqueCustomers;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["firstUse"] = this.firstUse;
        data["lastUse"] = this.lastUse;
        data["usageCount"] = this.usageCount;
        data["totalValue"] = this.totalValue;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): OffersReportItemDto {
        const json = this.toJSON();
        let result = new OffersReportItemDto();
        result.init(json);
        return result;
    }
}

export interface IOffersReportItemDto {
    rank: number;
    id: number;
    serviceName: string | undefined;
    vehicleTypeName: string | undefined;
    carBrandName: string | undefined;
    groupName: string | undefined;
    offerPrice: number;
    uniqueCustomers: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    firstUse: string | undefined;
    lastUse: string | undefined;
    usageCount: number;
    totalValue: number;
    percentage: number;
}

export class OffersReportResultDto implements IOffersReportResultDto {
    isFilteredByOffer: boolean;
    offerName: string | undefined;
    totalOffers: number;
    totalUsages: number;
    totalCustomers: number;
    totalValue: number;
    breakdown: OffersReportItemDto[] | undefined;

    constructor(data?: IOffersReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFilteredByOffer = _data["isFilteredByOffer"];
            this.offerName = _data["offerName"];
            this.totalOffers = _data["totalOffers"];
            this.totalUsages = _data["totalUsages"];
            this.totalCustomers = _data["totalCustomers"];
            this.totalValue = _data["totalValue"];
            if (Array.isArray(_data["breakdown"])) {
                this.breakdown = [] as any;
                for (let item of _data["breakdown"])
                    this.breakdown.push(OffersReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OffersReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffersReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFilteredByOffer"] = this.isFilteredByOffer;
        data["offerName"] = this.offerName;
        data["totalOffers"] = this.totalOffers;
        data["totalUsages"] = this.totalUsages;
        data["totalCustomers"] = this.totalCustomers;
        data["totalValue"] = this.totalValue;
        if (Array.isArray(this.breakdown)) {
            data["breakdown"] = [];
            for (let item of this.breakdown)
                data["breakdown"].push(item.toJSON());
        }
        return data;
    }

    clone(): OffersReportResultDto {
        const json = this.toJSON();
        let result = new OffersReportResultDto();
        result.init(json);
        return result;
    }
}

export interface IOffersReportResultDto {
    isFilteredByOffer: boolean;
    offerName: string | undefined;
    totalOffers: number;
    totalUsages: number;
    totalCustomers: number;
    totalValue: number;
    breakdown: OffersReportItemDto[] | undefined;
}

export enum OfferType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class OrderServicesChecklistDto implements IOrderServicesChecklistDto {
    id: number;
    isChecked: boolean;
    checkedAt: moment.Moment | undefined;
    checkedBy: number | undefined;
    billDetailsId: number;
    serviceId: number;
    servicesChecklistId: number;
    isDeleted: boolean;
    serviceCheckList: ServiceCheckListEntity;

    constructor(data?: IOrderServicesChecklistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isChecked = _data["isChecked"];
            this.checkedAt = _data["checkedAt"] ? moment(_data["checkedAt"].toString()) : <any>undefined;
            this.checkedBy = _data["checkedBy"];
            this.billDetailsId = _data["billDetailsId"];
            this.serviceId = _data["serviceId"];
            this.servicesChecklistId = _data["servicesChecklistId"];
            this.isDeleted = _data["isDeleted"];
            this.serviceCheckList = _data["serviceCheckList"] ? ServiceCheckListEntity.fromJS(_data["serviceCheckList"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderServicesChecklistDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderServicesChecklistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isChecked"] = this.isChecked;
        data["checkedAt"] = this.checkedAt ? this.checkedAt.toISOString() : <any>undefined;
        data["checkedBy"] = this.checkedBy;
        data["billDetailsId"] = this.billDetailsId;
        data["serviceId"] = this.serviceId;
        data["servicesChecklistId"] = this.servicesChecklistId;
        data["isDeleted"] = this.isDeleted;
        data["serviceCheckList"] = this.serviceCheckList ? this.serviceCheckList.toJSON() : <any>undefined;
        return data;
    }

    clone(): OrderServicesChecklistDto {
        const json = this.toJSON();
        let result = new OrderServicesChecklistDto();
        result.init(json);
        return result;
    }
}

export interface IOrderServicesChecklistDto {
    id: number;
    isChecked: boolean;
    checkedAt: moment.Moment | undefined;
    checkedBy: number | undefined;
    billDetailsId: number;
    serviceId: number;
    servicesChecklistId: number;
    isDeleted: boolean;
    serviceCheckList: ServiceCheckListEntity;
}

export class OrderServiceStepsEntity implements IOrderServiceStepsEntity {
    id: number;
    billDetailsId: number;
    serviceId: number;
    stepId: number;
    executedBy: number | undefined;
    status: StepStatus;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    reExecuted: boolean;
    isDeleted: boolean;

    constructor(data?: IOrderServiceStepsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billDetailsId = _data["billDetailsId"];
            this.serviceId = _data["serviceId"];
            this.stepId = _data["stepId"];
            this.executedBy = _data["executedBy"];
            this.status = _data["status"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.reExecuted = _data["reExecuted"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): OrderServiceStepsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new OrderServiceStepsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billDetailsId"] = this.billDetailsId;
        data["serviceId"] = this.serviceId;
        data["stepId"] = this.stepId;
        data["executedBy"] = this.executedBy;
        data["status"] = this.status;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["reExecuted"] = this.reExecuted;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): OrderServiceStepsEntity {
        const json = this.toJSON();
        let result = new OrderServiceStepsEntity();
        result.init(json);
        return result;
    }
}

export interface IOrderServiceStepsEntity {
    id: number;
    billDetailsId: number;
    serviceId: number;
    stepId: number;
    executedBy: number | undefined;
    status: StepStatus;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    reExecuted: boolean;
    isDeleted: boolean;
}

export class PackageDetailsDto implements IPackageDetailsDto {
    id: number;
    packageId: number;
    serviceId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceCount: number;
    packageName: string | undefined;
    serviceName: string | undefined;
    service: ServiceDto;

    constructor(data?: IPackageDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.serviceId = _data["serviceId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.serviceCount = _data["serviceCount"];
            this.packageName = _data["packageName"];
            this.serviceName = _data["serviceName"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PackageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["serviceId"] = this.serviceId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["serviceCount"] = this.serviceCount;
        data["packageName"] = this.packageName;
        data["serviceName"] = this.serviceName;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): PackageDetailsDto {
        const json = this.toJSON();
        let result = new PackageDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDetailsDto {
    id: number;
    packageId: number;
    serviceId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceCount: number;
    packageName: string | undefined;
    serviceName: string | undefined;
    service: ServiceDto;
}

export class PackageDetailsDtoPagedResultDto implements IPackageDetailsDtoPagedResultDto {
    items: PackageDetailsDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageDetailsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageDetailsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageDetailsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDetailsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageDetailsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageDetailsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDetailsDtoPagedResultDto {
    items: PackageDetailsDto[] | undefined;
    totalCount: number;
}

export class PackageDetailsEntity implements IPackageDetailsEntity {
    id: number;
    packageId: number;
    serviceId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceCount: number;
    package: PackageEntity;
    service: ServiceEntity;

    constructor(data?: IPackageDetailsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.serviceId = _data["serviceId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.serviceCount = _data["serviceCount"];
            this.package = _data["package"] ? PackageEntity.fromJS(_data["package"]) : <any>undefined;
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PackageDetailsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDetailsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["serviceId"] = this.serviceId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["serviceCount"] = this.serviceCount;
        data["package"] = this.package ? this.package.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): PackageDetailsEntity {
        const json = this.toJSON();
        let result = new PackageDetailsEntity();
        result.init(json);
        return result;
    }
}

export interface IPackageDetailsEntity {
    id: number;
    packageId: number;
    serviceId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceCount: number;
    package: PackageEntity;
    service: ServiceEntity;
}

export class PackageDto implements IPackageDto {
    id: number;
    name: string;
    duration: PackageDuration;
    readonly durationName: string | undefined;
    carBrandId: number | undefined;
    isAvailableForAllBrands: boolean;
    groupId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    numberOfCars: number | undefined;
    maxSubscribers: number;
    actualUsage: number;
    price: number;
    salesCommissionAmount: number | undefined;
    totalCount: number;
    lastModificationTime: moment.Moment | undefined;
    isTotalCountBased: boolean;
    isDeleted: boolean;
    isActive: boolean;
    isWelcomePackage: boolean;
    packageTypeId: number | undefined;
    carBrand: CarBrandDto;
    group: GroupDto;
    packageType: PackageTypeDto;
    vehicleTypeId: number | undefined;
    vehicleType: VehicleTypeDto;
    packageDetails: PackageDetailsDto[] | undefined;

    constructor(data?: IPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.duration = _data["duration"];
            (<any>this).durationName = _data["durationName"];
            this.carBrandId = _data["carBrandId"];
            this.isAvailableForAllBrands = _data["isAvailableForAllBrands"];
            this.groupId = _data["groupId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.numberOfCars = _data["numberOfCars"];
            this.maxSubscribers = _data["maxSubscribers"];
            this.actualUsage = _data["actualUsage"];
            this.price = _data["price"];
            this.salesCommissionAmount = _data["salesCommissionAmount"];
            this.totalCount = _data["totalCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isTotalCountBased = _data["isTotalCountBased"];
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
            this.isWelcomePackage = _data["isWelcomePackage"];
            this.packageTypeId = _data["packageTypeId"];
            this.carBrand = _data["carBrand"] ? CarBrandDto.fromJS(_data["carBrand"]) : <any>undefined;
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : <any>undefined;
            this.packageType = _data["packageType"] ? PackageTypeDto.fromJS(_data["packageType"]) : <any>undefined;
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleType = _data["vehicleType"] ? VehicleTypeDto.fromJS(_data["vehicleType"]) : <any>undefined;
            if (Array.isArray(_data["packageDetails"])) {
                this.packageDetails = [] as any;
                for (let item of _data["packageDetails"])
                    this.packageDetails.push(PackageDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["duration"] = this.duration;
        data["durationName"] = this.durationName;
        data["carBrandId"] = this.carBrandId;
        data["isAvailableForAllBrands"] = this.isAvailableForAllBrands;
        data["groupId"] = this.groupId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["numberOfCars"] = this.numberOfCars;
        data["maxSubscribers"] = this.maxSubscribers;
        data["actualUsage"] = this.actualUsage;
        data["price"] = this.price;
        data["salesCommissionAmount"] = this.salesCommissionAmount;
        data["totalCount"] = this.totalCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isTotalCountBased"] = this.isTotalCountBased;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        data["isWelcomePackage"] = this.isWelcomePackage;
        data["packageTypeId"] = this.packageTypeId;
        data["carBrand"] = this.carBrand ? this.carBrand.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["packageType"] = this.packageType ? this.packageType.toJSON() : <any>undefined;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : <any>undefined;
        if (Array.isArray(this.packageDetails)) {
            data["packageDetails"] = [];
            for (let item of this.packageDetails)
                data["packageDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): PackageDto {
        const json = this.toJSON();
        let result = new PackageDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDto {
    id: number;
    name: string;
    duration: PackageDuration;
    durationName: string | undefined;
    carBrandId: number | undefined;
    isAvailableForAllBrands: boolean;
    groupId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    numberOfCars: number | undefined;
    maxSubscribers: number;
    actualUsage: number;
    price: number;
    salesCommissionAmount: number | undefined;
    totalCount: number;
    lastModificationTime: moment.Moment | undefined;
    isTotalCountBased: boolean;
    isDeleted: boolean;
    isActive: boolean;
    isWelcomePackage: boolean;
    packageTypeId: number | undefined;
    carBrand: CarBrandDto;
    group: GroupDto;
    packageType: PackageTypeDto;
    vehicleTypeId: number | undefined;
    vehicleType: VehicleTypeDto;
    packageDetails: PackageDetailsDto[] | undefined;
}

export class PackageDtoPagedResultDto implements IPackageDtoPagedResultDto {
    items: PackageDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageDtoPagedResultDto {
    items: PackageDto[] | undefined;
    totalCount: number;
}

export enum PackageDuration {
    _1 = 1,
    _3 = 3,
    _6 = 6,
    _9 = 9,
    _12 = 12,
}

export class PackageEntity implements IPackageEntity {
    id: number;
    name: string;
    duration: PackageDuration;
    carBrandId: number | undefined;
    isAvailableForAllBrands: boolean;
    groupId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    numberOfCars: number | undefined;
    maxSubscribers: number;
    actualUsage: number;
    price: number;
    salesCommissionAmount: number | undefined;
    totalCount: number;
    lastModificationTime: moment.Moment | undefined;
    isTotalCountBased: boolean;
    isDeleted: boolean;
    packageTypeId: number | undefined;
    isActive: boolean;
    isWelcomePackage: boolean;
    carBrand: CarBrandEntity;
    vehicleTypeId: number | undefined;
    vehicleType: VehicleTypeEntity;
    packageType: PackageTypeEntity;
    group: GroupEntity;
    user: User;
    packageDetails: PackageDetailsEntity[] | undefined;

    constructor(data?: IPackageEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.duration = _data["duration"];
            this.carBrandId = _data["carBrandId"];
            this.isAvailableForAllBrands = _data["isAvailableForAllBrands"];
            this.groupId = _data["groupId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.numberOfCars = _data["numberOfCars"];
            this.maxSubscribers = _data["maxSubscribers"];
            this.actualUsage = _data["actualUsage"];
            this.price = _data["price"];
            this.salesCommissionAmount = _data["salesCommissionAmount"];
            this.totalCount = _data["totalCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isTotalCountBased = _data["isTotalCountBased"];
            this.isDeleted = _data["isDeleted"];
            this.packageTypeId = _data["packageTypeId"];
            this.isActive = _data["isActive"];
            this.isWelcomePackage = _data["isWelcomePackage"];
            this.carBrand = _data["carBrand"] ? CarBrandEntity.fromJS(_data["carBrand"]) : <any>undefined;
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleType = _data["vehicleType"] ? VehicleTypeEntity.fromJS(_data["vehicleType"]) : <any>undefined;
            this.packageType = _data["packageType"] ? PackageTypeEntity.fromJS(_data["packageType"]) : <any>undefined;
            this.group = _data["group"] ? GroupEntity.fromJS(_data["group"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["packageDetails"])) {
                this.packageDetails = [] as any;
                for (let item of _data["packageDetails"])
                    this.packageDetails.push(PackageDetailsEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PackageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["duration"] = this.duration;
        data["carBrandId"] = this.carBrandId;
        data["isAvailableForAllBrands"] = this.isAvailableForAllBrands;
        data["groupId"] = this.groupId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["numberOfCars"] = this.numberOfCars;
        data["maxSubscribers"] = this.maxSubscribers;
        data["actualUsage"] = this.actualUsage;
        data["price"] = this.price;
        data["salesCommissionAmount"] = this.salesCommissionAmount;
        data["totalCount"] = this.totalCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isTotalCountBased"] = this.isTotalCountBased;
        data["isDeleted"] = this.isDeleted;
        data["packageTypeId"] = this.packageTypeId;
        data["isActive"] = this.isActive;
        data["isWelcomePackage"] = this.isWelcomePackage;
        data["carBrand"] = this.carBrand ? this.carBrand.toJSON() : <any>undefined;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : <any>undefined;
        data["packageType"] = this.packageType ? this.packageType.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.packageDetails)) {
            data["packageDetails"] = [];
            for (let item of this.packageDetails)
                data["packageDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): PackageEntity {
        const json = this.toJSON();
        let result = new PackageEntity();
        result.init(json);
        return result;
    }
}

export interface IPackageEntity {
    id: number;
    name: string;
    duration: PackageDuration;
    carBrandId: number | undefined;
    isAvailableForAllBrands: boolean;
    groupId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    numberOfCars: number | undefined;
    maxSubscribers: number;
    actualUsage: number;
    price: number;
    salesCommissionAmount: number | undefined;
    totalCount: number;
    lastModificationTime: moment.Moment | undefined;
    isTotalCountBased: boolean;
    isDeleted: boolean;
    packageTypeId: number | undefined;
    isActive: boolean;
    isWelcomePackage: boolean;
    carBrand: CarBrandEntity;
    vehicleTypeId: number | undefined;
    vehicleType: VehicleTypeEntity;
    packageType: PackageTypeEntity;
    group: GroupEntity;
    user: User;
    packageDetails: PackageDetailsEntity[] | undefined;
}

export class PackageSaleCommissionItemDto implements IPackageSaleCommissionItemDto {
    subscriptionId: number;
    packageName: string | undefined;
    salesCommission: number;
    saleDate: moment.Moment;

    constructor(data?: IPackageSaleCommissionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.packageName = _data["packageName"];
            this.salesCommission = _data["salesCommission"];
            this.saleDate = _data["saleDate"] ? moment(_data["saleDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PackageSaleCommissionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSaleCommissionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["packageName"] = this.packageName;
        data["salesCommission"] = this.salesCommission;
        data["saleDate"] = this.saleDate ? this.saleDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): PackageSaleCommissionItemDto {
        const json = this.toJSON();
        let result = new PackageSaleCommissionItemDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSaleCommissionItemDto {
    subscriptionId: number;
    packageName: string | undefined;
    salesCommission: number;
    saleDate: moment.Moment;
}

export class PackageServiceColumnDto implements IPackageServiceColumnDto {
    serviceId: number;
    serviceName: string | undefined;
    initialCount: number;

    constructor(data?: IPackageServiceColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.initialCount = _data["initialCount"];
        }
    }

    static fromJS(data: any): PackageServiceColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageServiceColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["initialCount"] = this.initialCount;
        return data;
    }

    clone(): PackageServiceColumnDto {
        const json = this.toJSON();
        let result = new PackageServiceColumnDto();
        result.init(json);
        return result;
    }
}

export interface IPackageServiceColumnDto {
    serviceId: number;
    serviceName: string | undefined;
    initialCount: number;
}

export class PackageSubscriberDto implements IPackageSubscriberDto {
    subscriptionId: number;
    customerId: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isActive: boolean;
    isExpired: boolean;
    initialCount: number;
    remainingCount: number;
    usedCount: number;
    serviceUsages: PackageSubscriberServiceUsageDto[] | undefined;

    constructor(data?: IPackageSubscriberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isExpired = _data["isExpired"];
            this.initialCount = _data["initialCount"];
            this.remainingCount = _data["remainingCount"];
            this.usedCount = _data["usedCount"];
            if (Array.isArray(_data["serviceUsages"])) {
                this.serviceUsages = [] as any;
                for (let item of _data["serviceUsages"])
                    this.serviceUsages.push(PackageSubscriberServiceUsageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageSubscriberDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isExpired"] = this.isExpired;
        data["initialCount"] = this.initialCount;
        data["remainingCount"] = this.remainingCount;
        data["usedCount"] = this.usedCount;
        if (Array.isArray(this.serviceUsages)) {
            data["serviceUsages"] = [];
            for (let item of this.serviceUsages)
                data["serviceUsages"].push(item.toJSON());
        }
        return data;
    }

    clone(): PackageSubscriberDto {
        const json = this.toJSON();
        let result = new PackageSubscriberDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriberDto {
    subscriptionId: number;
    customerId: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    isActive: boolean;
    isExpired: boolean;
    initialCount: number;
    remainingCount: number;
    usedCount: number;
    serviceUsages: PackageSubscriberServiceUsageDto[] | undefined;
}

export class PackageSubscriberServiceUsageDto implements IPackageSubscriberServiceUsageDto {
    serviceId: number;
    serviceName: string | undefined;
    initialCount: number;
    remainingCount: number;
    usedCount: number;

    constructor(data?: IPackageSubscriberServiceUsageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.initialCount = _data["initialCount"];
            this.remainingCount = _data["remainingCount"];
            this.usedCount = _data["usedCount"];
        }
    }

    static fromJS(data: any): PackageSubscriberServiceUsageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriberServiceUsageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["initialCount"] = this.initialCount;
        data["remainingCount"] = this.remainingCount;
        data["usedCount"] = this.usedCount;
        return data;
    }

    clone(): PackageSubscriberServiceUsageDto {
        const json = this.toJSON();
        let result = new PackageSubscriberServiceUsageDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriberServiceUsageDto {
    serviceId: number;
    serviceName: string | undefined;
    initialCount: number;
    remainingCount: number;
    usedCount: number;
}

export class PackageSubscribersReportDto implements IPackageSubscribersReportDto {
    packageId: number;
    packageName: string | undefined;
    isTotalCountBased: boolean;
    totalCount: number;
    serviceColumns: PackageServiceColumnDto[] | undefined;
    subscribers: PackageSubscriberDto[] | undefined;

    constructor(data?: IPackageSubscribersReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.packageName = _data["packageName"];
            this.isTotalCountBased = _data["isTotalCountBased"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["serviceColumns"])) {
                this.serviceColumns = [] as any;
                for (let item of _data["serviceColumns"])
                    this.serviceColumns.push(PackageServiceColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["subscribers"])) {
                this.subscribers = [] as any;
                for (let item of _data["subscribers"])
                    this.subscribers.push(PackageSubscriberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageSubscribersReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscribersReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["packageName"] = this.packageName;
        data["isTotalCountBased"] = this.isTotalCountBased;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.serviceColumns)) {
            data["serviceColumns"] = [];
            for (let item of this.serviceColumns)
                data["serviceColumns"].push(item.toJSON());
        }
        if (Array.isArray(this.subscribers)) {
            data["subscribers"] = [];
            for (let item of this.subscribers)
                data["subscribers"].push(item.toJSON());
        }
        return data;
    }

    clone(): PackageSubscribersReportDto {
        const json = this.toJSON();
        let result = new PackageSubscribersReportDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscribersReportDto {
    packageId: number;
    packageName: string | undefined;
    isTotalCountBased: boolean;
    totalCount: number;
    serviceColumns: PackageServiceColumnDto[] | undefined;
    subscribers: PackageSubscriberDto[] | undefined;
}

export class PackageSubscriptionDetailsEntity implements IPackageSubscriptionDetailsEntity {
    id: number;
    packageSubscriptionId: number;
    serviceId: number;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    packageSubscription: PackageSubscriptionEntity;
    service: ServiceEntity;

    constructor(data?: IPackageSubscriptionDetailsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageSubscriptionId = _data["packageSubscriptionId"];
            this.serviceId = _data["serviceId"];
            this.remainingCount = _data["remainingCount"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.packageSubscription = _data["packageSubscription"] ? PackageSubscriptionEntity.fromJS(_data["packageSubscription"]) : <any>undefined;
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PackageSubscriptionDetailsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriptionDetailsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageSubscriptionId"] = this.packageSubscriptionId;
        data["serviceId"] = this.serviceId;
        data["remainingCount"] = this.remainingCount;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["packageSubscription"] = this.packageSubscription ? this.packageSubscription.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): PackageSubscriptionDetailsEntity {
        const json = this.toJSON();
        let result = new PackageSubscriptionDetailsEntity();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriptionDetailsEntity {
    id: number;
    packageSubscriptionId: number;
    serviceId: number;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    packageSubscription: PackageSubscriptionEntity;
    service: ServiceEntity;
}

export class PackageSubscriptionDto implements IPackageSubscriptionDto {
    id: number;
    packageId: number;
    customerId: number | undefined;
    referralId: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;

    constructor(data?: IPackageSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.customerId = _data["customerId"];
            this.referralId = _data["referralId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.remainingCount = _data["remainingCount"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PackageSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["customerId"] = this.customerId;
        data["referralId"] = this.referralId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["remainingCount"] = this.remainingCount;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): PackageSubscriptionDto {
        const json = this.toJSON();
        let result = new PackageSubscriptionDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriptionDto {
    id: number;
    packageId: number;
    customerId: number | undefined;
    referralId: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
}

export class PackageSubscriptionDtoPagedResultDto implements IPackageSubscriptionDtoPagedResultDto {
    items: PackageSubscriptionDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageSubscriptionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageSubscriptionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageSubscriptionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriptionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageSubscriptionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageSubscriptionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriptionDtoPagedResultDto {
    items: PackageSubscriptionDto[] | undefined;
    totalCount: number;
}

export class PackageSubscriptionEntity implements IPackageSubscriptionEntity {
    id: number;
    packageId: number;
    customerId: number | undefined;
    referralId: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
    salesEmployeeId: number | undefined;
    package: PackageEntity;
    customer: CustomerEntity;
    referral: ReferralEntity;
    salesEmployee: EmployeeEntity;
    subscriptionDetails: PackageSubscriptionDetailsEntity[] | undefined;

    constructor(data?: IPackageSubscriptionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.packageId = _data["packageId"];
            this.customerId = _data["customerId"];
            this.referralId = _data["referralId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.remainingCount = _data["remainingCount"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
            this.salesEmployeeId = _data["salesEmployeeId"];
            this.package = _data["package"] ? PackageEntity.fromJS(_data["package"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.referral = _data["referral"] ? ReferralEntity.fromJS(_data["referral"]) : <any>undefined;
            this.salesEmployee = _data["salesEmployee"] ? EmployeeEntity.fromJS(_data["salesEmployee"]) : <any>undefined;
            if (Array.isArray(_data["subscriptionDetails"])) {
                this.subscriptionDetails = [] as any;
                for (let item of _data["subscriptionDetails"])
                    this.subscriptionDetails.push(PackageSubscriptionDetailsEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageSubscriptionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriptionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["packageId"] = this.packageId;
        data["customerId"] = this.customerId;
        data["referralId"] = this.referralId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["remainingCount"] = this.remainingCount;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        data["salesEmployeeId"] = this.salesEmployeeId;
        data["package"] = this.package ? this.package.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["referral"] = this.referral ? this.referral.toJSON() : <any>undefined;
        data["salesEmployee"] = this.salesEmployee ? this.salesEmployee.toJSON() : <any>undefined;
        if (Array.isArray(this.subscriptionDetails)) {
            data["subscriptionDetails"] = [];
            for (let item of this.subscriptionDetails)
                data["subscriptionDetails"].push(item.toJSON());
        }
        return data;
    }

    clone(): PackageSubscriptionEntity {
        const json = this.toJSON();
        let result = new PackageSubscriptionEntity();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriptionEntity {
    id: number;
    packageId: number;
    customerId: number | undefined;
    referralId: number | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    remainingCount: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
    salesEmployeeId: number | undefined;
    package: PackageEntity;
    customer: CustomerEntity;
    referral: ReferralEntity;
    salesEmployee: EmployeeEntity;
    subscriptionDetails: PackageSubscriptionDetailsEntity[] | undefined;
}

export class PackageSubscriptionsReportItemDto implements IPackageSubscriptionsReportItemDto {
    rank: number;
    id: number;
    name: string | undefined;
    subscriptionCount: number;
    totalValue: number;
    percentage: number;
    phoneNumber: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;

    constructor(data?: IPackageSubscriptionsReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.subscriptionCount = _data["subscriptionCount"];
            this.totalValue = _data["totalValue"];
            this.percentage = _data["percentage"];
            this.phoneNumber = _data["phoneNumber"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): PackageSubscriptionsReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriptionsReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["id"] = this.id;
        data["name"] = this.name;
        data["subscriptionCount"] = this.subscriptionCount;
        data["totalValue"] = this.totalValue;
        data["percentage"] = this.percentage;
        data["phoneNumber"] = this.phoneNumber;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }

    clone(): PackageSubscriptionsReportItemDto {
        const json = this.toJSON();
        let result = new PackageSubscriptionsReportItemDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriptionsReportItemDto {
    rank: number;
    id: number;
    name: string | undefined;
    subscriptionCount: number;
    totalValue: number;
    percentage: number;
    phoneNumber: string | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
}

export class PackageSubscriptionsReportResultDto implements IPackageSubscriptionsReportResultDto {
    isFilteredByPackage: boolean;
    packageName: string | undefined;
    totalPackages: number;
    totalSubscriptions: number;
    totalValue: number;
    breakdown: PackageSubscriptionsReportItemDto[] | undefined;

    constructor(data?: IPackageSubscriptionsReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFilteredByPackage = _data["isFilteredByPackage"];
            this.packageName = _data["packageName"];
            this.totalPackages = _data["totalPackages"];
            this.totalSubscriptions = _data["totalSubscriptions"];
            this.totalValue = _data["totalValue"];
            if (Array.isArray(_data["breakdown"])) {
                this.breakdown = [] as any;
                for (let item of _data["breakdown"])
                    this.breakdown.push(PackageSubscriptionsReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PackageSubscriptionsReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscriptionsReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFilteredByPackage"] = this.isFilteredByPackage;
        data["packageName"] = this.packageName;
        data["totalPackages"] = this.totalPackages;
        data["totalSubscriptions"] = this.totalSubscriptions;
        data["totalValue"] = this.totalValue;
        if (Array.isArray(this.breakdown)) {
            data["breakdown"] = [];
            for (let item of this.breakdown)
                data["breakdown"].push(item.toJSON());
        }
        return data;
    }

    clone(): PackageSubscriptionsReportResultDto {
        const json = this.toJSON();
        let result = new PackageSubscriptionsReportResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscriptionsReportResultDto {
    isFilteredByPackage: boolean;
    packageName: string | undefined;
    totalPackages: number;
    totalSubscriptions: number;
    totalValue: number;
    breakdown: PackageSubscriptionsReportItemDto[] | undefined;
}

export class PackageSubscrptionDetailsDto implements IPackageSubscrptionDetailsDto {
    packageId: number;
    packageName: string | undefined;
    subscribersCount: number;
    remainingSubscriptions: number;
    totalRevenue: number;

    constructor(data?: IPackageSubscrptionDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.packageName = _data["packageName"];
            this.subscribersCount = _data["subscribersCount"];
            this.remainingSubscriptions = _data["remainingSubscriptions"];
            this.totalRevenue = _data["totalRevenue"];
        }
    }

    static fromJS(data: any): PackageSubscrptionDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageSubscrptionDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["packageName"] = this.packageName;
        data["subscribersCount"] = this.subscribersCount;
        data["remainingSubscriptions"] = this.remainingSubscriptions;
        data["totalRevenue"] = this.totalRevenue;
        return data;
    }

    clone(): PackageSubscrptionDetailsDto {
        const json = this.toJSON();
        let result = new PackageSubscrptionDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IPackageSubscrptionDetailsDto {
    packageId: number;
    packageName: string | undefined;
    subscribersCount: number;
    remainingSubscriptions: number;
    totalRevenue: number;
}

export class PackageTypeDto implements IPackageTypeDto {
    id: number;
    name: string | undefined;
    availableDays: WeekDays;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    readonly availableDaysDisplay: string | undefined;
    readonly timeRangeDisplay: string | undefined;

    constructor(data?: IPackageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.availableDays = _data["availableDays"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            (<any>this).availableDaysDisplay = _data["availableDaysDisplay"];
            (<any>this).timeRangeDisplay = _data["timeRangeDisplay"];
        }
    }

    static fromJS(data: any): PackageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["availableDays"] = this.availableDays;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["availableDaysDisplay"] = this.availableDaysDisplay;
        data["timeRangeDisplay"] = this.timeRangeDisplay;
        return data;
    }

    clone(): PackageTypeDto {
        const json = this.toJSON();
        let result = new PackageTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTypeDto {
    id: number;
    name: string | undefined;
    availableDays: WeekDays;
    timeFrom: string | undefined;
    timeTo: string | undefined;
    isActive: boolean;
    isDeleted: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    availableDaysDisplay: string | undefined;
    timeRangeDisplay: string | undefined;
}

export class PackageTypeDtoPagedResultDto implements IPackageTypeDtoPagedResultDto {
    items: PackageTypeDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageTypeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageTypeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageTypeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTypeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageTypeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageTypeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageTypeDtoPagedResultDto {
    items: PackageTypeDto[] | undefined;
    totalCount: number;
}

export class PackageTypeEntity implements IPackageTypeEntity {
    id: number;
    name: string;
    availableDays: WeekDays;
    timeFrom: TimeSpan;
    timeTo: TimeSpan;
    isActive: boolean;
    isDeleted: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IPackageTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.availableDays = _data["availableDays"];
            this.timeFrom = _data["timeFrom"] ? TimeSpan.fromJS(_data["timeFrom"]) : <any>undefined;
            this.timeTo = _data["timeTo"] ? TimeSpan.fromJS(_data["timeTo"]) : <any>undefined;
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PackageTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PackageTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["availableDays"] = this.availableDays;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toJSON() : <any>undefined;
        data["timeTo"] = this.timeTo ? this.timeTo.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): PackageTypeEntity {
        const json = this.toJSON();
        let result = new PackageTypeEntity();
        result.init(json);
        return result;
    }
}

export interface IPackageTypeEntity {
    id: number;
    name: string;
    availableDays: WeekDays;
    timeFrom: TimeSpan;
    timeTo: TimeSpan;
    isActive: boolean;
    isDeleted: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class PackageWithSubscribersDto implements IPackageWithSubscribersDto {
    packageId: number;
    name: string | undefined;
    price: number;
    carBrand: string | undefined;
    groupName: string | undefined;
    target: number;
    subscriberCount: number;

    constructor(data?: IPackageWithSubscribersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.carBrand = _data["carBrand"];
            this.groupName = _data["groupName"];
            this.target = _data["target"];
            this.subscriberCount = _data["subscriberCount"];
        }
    }

    static fromJS(data: any): PackageWithSubscribersDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageWithSubscribersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["name"] = this.name;
        data["price"] = this.price;
        data["carBrand"] = this.carBrand;
        data["groupName"] = this.groupName;
        data["target"] = this.target;
        data["subscriberCount"] = this.subscriberCount;
        return data;
    }

    clone(): PackageWithSubscribersDto {
        const json = this.toJSON();
        let result = new PackageWithSubscribersDto();
        result.init(json);
        return result;
    }
}

export interface IPackageWithSubscribersDto {
    packageId: number;
    name: string | undefined;
    price: number;
    carBrand: string | undefined;
    groupName: string | undefined;
    target: number;
    subscriberCount: number;
}

export class PackageWithSubscribersDtoPagedResultDto implements IPackageWithSubscribersDtoPagedResultDto {
    items: PackageWithSubscribersDto[] | undefined;
    totalCount: number;

    constructor(data?: IPackageWithSubscribersDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PackageWithSubscribersDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PackageWithSubscribersDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PackageWithSubscribersDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PackageWithSubscribersDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PackageWithSubscribersDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPackageWithSubscribersDtoPagedResultDto {
    items: PackageWithSubscribersDto[] | undefined;
    totalCount: number;
}

export class PaymentMethodDto implements IPaymentMethodDto {
    id: number;
    name: string;

    constructor(data?: IPaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PaymentMethodDto {
        const json = this.toJSON();
        let result = new PaymentMethodDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodDto {
    id: number;
    name: string;
}

export class PaymentMethodDtoPagedResultDto implements IPaymentMethodDtoPagedResultDto {
    items: PaymentMethodDto[] | undefined;
    totalCount: number;

    constructor(data?: IPaymentMethodDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PaymentMethodDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PaymentMethodDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PaymentMethodDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PaymentMethodDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodDtoPagedResultDto {
    items: PaymentMethodDto[] | undefined;
    totalCount: number;
}

export class PaymentMethodEntity implements IPaymentMethodEntity {
    id: number;
    name: string;

    constructor(data?: IPaymentMethodEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PaymentMethodEntity {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PaymentMethodEntity {
        const json = this.toJSON();
        let result = new PaymentMethodEntity();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodEntity {
    id: number;
    name: string;
}

export class PermissionDto implements IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PriceModel implements IPriceModel {
    mainPrice: number;
    appliedPrice: number;
    priceType: string | undefined;

    constructor(data?: IPriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mainPrice = _data["mainPrice"];
            this.appliedPrice = _data["appliedPrice"];
            this.priceType = _data["priceType"];
        }
    }

    static fromJS(data: any): PriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mainPrice"] = this.mainPrice;
        data["appliedPrice"] = this.appliedPrice;
        data["priceType"] = this.priceType;
        return data;
    }

    clone(): PriceModel {
        const json = this.toJSON();
        let result = new PriceModel();
        result.init(json);
        return result;
    }
}

export interface IPriceModel {
    mainPrice: number;
    appliedPrice: number;
    priceType: string | undefined;
}

export class ProfileSettingsDto implements IProfileSettingsDto {
    id: number;
    userId: number;
    profileImage: string | undefined;
    profileImageBase64: string | undefined;
    originalFileName: string | undefined;

    constructor(data?: IProfileSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.profileImage = _data["profileImage"];
            this.profileImageBase64 = _data["profileImageBase64"];
            this.originalFileName = _data["originalFileName"];
        }
    }

    static fromJS(data: any): ProfileSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["profileImage"] = this.profileImage;
        data["profileImageBase64"] = this.profileImageBase64;
        data["originalFileName"] = this.originalFileName;
        return data;
    }

    clone(): ProfileSettingsDto {
        const json = this.toJSON();
        let result = new ProfileSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IProfileSettingsDto {
    id: number;
    userId: number;
    profileImage: string | undefined;
    profileImageBase64: string | undefined;
    originalFileName: string | undefined;
}

export class ProfileSettingsDtoPagedResultDto implements IProfileSettingsDtoPagedResultDto {
    items: ProfileSettingsDto[] | undefined;
    totalCount: number;

    constructor(data?: IProfileSettingsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ProfileSettingsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProfileSettingsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSettingsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProfileSettingsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProfileSettingsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProfileSettingsDtoPagedResultDto {
    items: ProfileSettingsDto[] | undefined;
    totalCount: number;
}

export class ReceiptSettingsDto implements IReceiptSettingsDto {
    id: number;
    logo: string | undefined;
    originalFileName: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    policies: string | undefined;
    logoBase64: string | undefined;

    constructor(data?: IReceiptSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logo = _data["logo"];
            this.originalFileName = _data["originalFileName"];
            this.address = _data["address"];
            this.phoneNumber = _data["phoneNumber"];
            this.policies = _data["policies"];
            this.logoBase64 = _data["logoBase64"];
        }
    }

    static fromJS(data: any): ReceiptSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logo"] = this.logo;
        data["originalFileName"] = this.originalFileName;
        data["address"] = this.address;
        data["phoneNumber"] = this.phoneNumber;
        data["policies"] = this.policies;
        data["logoBase64"] = this.logoBase64;
        return data;
    }

    clone(): ReceiptSettingsDto {
        const json = this.toJSON();
        let result = new ReceiptSettingsDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptSettingsDto {
    id: number;
    logo: string | undefined;
    originalFileName: string | undefined;
    address: string | undefined;
    phoneNumber: string | undefined;
    policies: string | undefined;
    logoBase64: string | undefined;
}

export class ReceiptSettingsDtoPagedResultDto implements IReceiptSettingsDtoPagedResultDto {
    items: ReceiptSettingsDto[] | undefined;
    totalCount: number;

    constructor(data?: IReceiptSettingsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReceiptSettingsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReceiptSettingsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptSettingsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReceiptSettingsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReceiptSettingsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptSettingsDtoPagedResultDto {
    items: ReceiptSettingsDto[] | undefined;
    totalCount: number;
}

export class ReferralCustomerDto implements IReferralCustomerDto {
    id: number;
    name: string | undefined;
    phoneNumber: string | undefined;
    billCount: number;
    totalSpent: number;

    constructor(data?: IReferralCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.billCount = _data["billCount"];
            this.totalSpent = _data["totalSpent"];
        }
    }

    static fromJS(data: any): ReferralCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["billCount"] = this.billCount;
        data["totalSpent"] = this.totalSpent;
        return data;
    }

    clone(): ReferralCustomerDto {
        const json = this.toJSON();
        let result = new ReferralCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IReferralCustomerDto {
    id: number;
    name: string | undefined;
    phoneNumber: string | undefined;
    billCount: number;
    totalSpent: number;
}

export class ReferralDto implements IReferralDto {
    id: number;
    name: string | undefined;
    phoneNumber: string | undefined;
    address: string | undefined;
    contactPerson: string | undefined;
    isActive: boolean;
    maxUsagesPerCustomer: number;
    specialPackageTypeId: number | undefined;
    specialPackageTypeName: string | undefined;

    constructor(data?: IReferralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.isActive = _data["isActive"];
            this.maxUsagesPerCustomer = _data["maxUsagesPerCustomer"];
            this.specialPackageTypeId = _data["specialPackageTypeId"];
            this.specialPackageTypeName = _data["specialPackageTypeName"];
        }
    }

    static fromJS(data: any): ReferralDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["isActive"] = this.isActive;
        data["maxUsagesPerCustomer"] = this.maxUsagesPerCustomer;
        data["specialPackageTypeId"] = this.specialPackageTypeId;
        data["specialPackageTypeName"] = this.specialPackageTypeName;
        return data;
    }

    clone(): ReferralDto {
        const json = this.toJSON();
        let result = new ReferralDto();
        result.init(json);
        return result;
    }
}

export interface IReferralDto {
    id: number;
    name: string | undefined;
    phoneNumber: string | undefined;
    address: string | undefined;
    contactPerson: string | undefined;
    isActive: boolean;
    maxUsagesPerCustomer: number;
    specialPackageTypeId: number | undefined;
    specialPackageTypeName: string | undefined;
}

export class ReferralDtoPagedResultDto implements IReferralDtoPagedResultDto {
    items: ReferralDto[] | undefined;
    totalCount: number;

    constructor(data?: IReferralDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ReferralDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReferralDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReferralDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReferralDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReferralDtoPagedResultDto {
    items: ReferralDto[] | undefined;
    totalCount: number;
}

export class ReferralEntity implements IReferralEntity {
    id: number;
    name: string;
    phoneNumber: string | undefined;
    address: string | undefined;
    contactPerson: string | undefined;
    isActive: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    maxUsagesPerCustomer: number;
    specialPackageTypeId: number | undefined;
    specialPackageType: SpecialPackageTypeEntity;

    constructor(data?: IReferralEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.address = _data["address"];
            this.contactPerson = _data["contactPerson"];
            this.isActive = _data["isActive"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.maxUsagesPerCustomer = _data["maxUsagesPerCustomer"];
            this.specialPackageTypeId = _data["specialPackageTypeId"];
            this.specialPackageType = _data["specialPackageType"] ? SpecialPackageTypeEntity.fromJS(_data["specialPackageType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReferralEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["address"] = this.address;
        data["contactPerson"] = this.contactPerson;
        data["isActive"] = this.isActive;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["maxUsagesPerCustomer"] = this.maxUsagesPerCustomer;
        data["specialPackageTypeId"] = this.specialPackageTypeId;
        data["specialPackageType"] = this.specialPackageType ? this.specialPackageType.toJSON() : <any>undefined;
        return data;
    }

    clone(): ReferralEntity {
        const json = this.toJSON();
        let result = new ReferralEntity();
        result.init(json);
        return result;
    }
}

export interface IReferralEntity {
    id: number;
    name: string;
    phoneNumber: string | undefined;
    address: string | undefined;
    contactPerson: string | undefined;
    isActive: boolean;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    maxUsagesPerCustomer: number;
    specialPackageTypeId: number | undefined;
    specialPackageType: SpecialPackageTypeEntity;
}

export class ReferralsReportItemDto implements IReferralsReportItemDto {
    rank: number;
    id: number;
    referralName: string | undefined;
    referralTypeName: string | undefined;
    uniqueCustomers: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    billCount: number;
    totalValue: number;
    firstUse: string | undefined;
    lastUse: string | undefined;
    percentage: number;

    constructor(data?: IReferralsReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.id = _data["id"];
            this.referralName = _data["referralName"];
            this.referralTypeName = _data["referralTypeName"];
            this.uniqueCustomers = _data["uniqueCustomers"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.billCount = _data["billCount"];
            this.totalValue = _data["totalValue"];
            this.firstUse = _data["firstUse"];
            this.lastUse = _data["lastUse"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): ReferralsReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralsReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["id"] = this.id;
        data["referralName"] = this.referralName;
        data["referralTypeName"] = this.referralTypeName;
        data["uniqueCustomers"] = this.uniqueCustomers;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["billCount"] = this.billCount;
        data["totalValue"] = this.totalValue;
        data["firstUse"] = this.firstUse;
        data["lastUse"] = this.lastUse;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): ReferralsReportItemDto {
        const json = this.toJSON();
        let result = new ReferralsReportItemDto();
        result.init(json);
        return result;
    }
}

export interface IReferralsReportItemDto {
    rank: number;
    id: number;
    referralName: string | undefined;
    referralTypeName: string | undefined;
    uniqueCustomers: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    billCount: number;
    totalValue: number;
    firstUse: string | undefined;
    lastUse: string | undefined;
    percentage: number;
}

export class ReferralsReportResultDto implements IReferralsReportResultDto {
    isFilteredByReferral: boolean;
    referralName: string | undefined;
    totalReferrals: number;
    totalCustomers: number;
    totalBills: number;
    totalValue: number;
    breakdown: ReferralsReportItemDto[] | undefined;

    constructor(data?: IReferralsReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFilteredByReferral = _data["isFilteredByReferral"];
            this.referralName = _data["referralName"];
            this.totalReferrals = _data["totalReferrals"];
            this.totalCustomers = _data["totalCustomers"];
            this.totalBills = _data["totalBills"];
            this.totalValue = _data["totalValue"];
            if (Array.isArray(_data["breakdown"])) {
                this.breakdown = [] as any;
                for (let item of _data["breakdown"])
                    this.breakdown.push(ReferralsReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReferralsReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralsReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFilteredByReferral"] = this.isFilteredByReferral;
        data["referralName"] = this.referralName;
        data["totalReferrals"] = this.totalReferrals;
        data["totalCustomers"] = this.totalCustomers;
        data["totalBills"] = this.totalBills;
        data["totalValue"] = this.totalValue;
        if (Array.isArray(this.breakdown)) {
            data["breakdown"] = [];
            for (let item of this.breakdown)
                data["breakdown"].push(item.toJSON());
        }
        return data;
    }

    clone(): ReferralsReportResultDto {
        const json = this.toJSON();
        let result = new ReferralsReportResultDto();
        result.init(json);
        return result;
    }
}

export interface IReferralsReportResultDto {
    isFilteredByReferral: boolean;
    referralName: string | undefined;
    totalReferrals: number;
    totalCustomers: number;
    totalBills: number;
    totalValue: number;
    breakdown: ReferralsReportItemDto[] | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class ResetPasswordDto implements IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class RoleDto implements IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class ServiceCheckListDto implements IServiceCheckListDto {
    id: number;
    title: string;
    description: string | undefined;
    ordering: number;
    serviceId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceName: string | undefined;

    constructor(data?: IServiceCheckListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.ordering = _data["ordering"];
            this.serviceId = _data["serviceId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.serviceName = _data["serviceName"];
        }
    }

    static fromJS(data: any): ServiceCheckListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["ordering"] = this.ordering;
        data["serviceId"] = this.serviceId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["serviceName"] = this.serviceName;
        return data;
    }

    clone(): ServiceCheckListDto {
        const json = this.toJSON();
        let result = new ServiceCheckListDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckListDto {
    id: number;
    title: string;
    description: string | undefined;
    ordering: number;
    serviceId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceName: string | undefined;
}

export class ServiceCheckListDtoPagedResultDto implements IServiceCheckListDtoPagedResultDto {
    items: ServiceCheckListDto[] | undefined;
    totalCount: number;

    constructor(data?: IServiceCheckListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ServiceCheckListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceCheckListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceCheckListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceCheckListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckListDtoPagedResultDto {
    items: ServiceCheckListDto[] | undefined;
    totalCount: number;
}

export class ServiceCheckListEntity implements IServiceCheckListEntity {
    id: number;
    title: string;
    description: string | undefined;
    ordering: number;
    serviceId: number;
    service: ServiceEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: IServiceCheckListEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.ordering = _data["ordering"];
            this.serviceId = _data["serviceId"];
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ServiceCheckListEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckListEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["ordering"] = this.ordering;
        data["serviceId"] = this.serviceId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ServiceCheckListEntity {
        const json = this.toJSON();
        let result = new ServiceCheckListEntity();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckListEntity {
    id: number;
    title: string;
    description: string | undefined;
    ordering: number;
    serviceId: number;
    service: ServiceEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class ServiceCheckListListResultDto implements IServiceCheckListListResultDto {
    items: ServiceCheckListDto[] | undefined;
    totalCount: number;
    serviceList: ServiceDto[] | undefined;

    constructor(data?: IServiceCheckListListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ServiceCheckListDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["serviceList"])) {
                this.serviceList = [] as any;
                for (let item of _data["serviceList"])
                    this.serviceList.push(ServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceCheckListListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckListListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.serviceList)) {
            data["serviceList"] = [];
            for (let item of this.serviceList)
                data["serviceList"].push(item.toJSON());
        }
        return data;
    }

    clone(): ServiceCheckListListResultDto {
        const json = this.toJSON();
        let result = new ServiceCheckListListResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckListListResultDto {
    items: ServiceCheckListDto[] | undefined;
    totalCount: number;
    serviceList: ServiceDto[] | undefined;
}

export class ServiceDto implements IServiceDto {
    id: number;
    name: string;
    description: string | undefined;
    isGrouped: boolean | undefined;
    groupId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    supervisorCommissionAmount: number | undefined;
    receptionCommissionAmount: number | undefined;
    serviceSteps: ServiceStepDto[] | undefined;
    serviceCheckLists: ServiceCheckListDto[] | undefined;
    servicePrices: ServicePriceDto[] | undefined;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isGrouped = _data["isGrouped"];
            this.groupId = _data["groupId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.supervisorCommissionAmount = _data["supervisorCommissionAmount"];
            this.receptionCommissionAmount = _data["receptionCommissionAmount"];
            if (Array.isArray(_data["serviceSteps"])) {
                this.serviceSteps = [] as any;
                for (let item of _data["serviceSteps"])
                    this.serviceSteps.push(ServiceStepDto.fromJS(item));
            }
            if (Array.isArray(_data["serviceCheckLists"])) {
                this.serviceCheckLists = [] as any;
                for (let item of _data["serviceCheckLists"])
                    this.serviceCheckLists.push(ServiceCheckListDto.fromJS(item));
            }
            if (Array.isArray(_data["servicePrices"])) {
                this.servicePrices = [] as any;
                for (let item of _data["servicePrices"])
                    this.servicePrices.push(ServicePriceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isGrouped"] = this.isGrouped;
        data["groupId"] = this.groupId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["supervisorCommissionAmount"] = this.supervisorCommissionAmount;
        data["receptionCommissionAmount"] = this.receptionCommissionAmount;
        if (Array.isArray(this.serviceSteps)) {
            data["serviceSteps"] = [];
            for (let item of this.serviceSteps)
                data["serviceSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceCheckLists)) {
            data["serviceCheckLists"] = [];
            for (let item of this.serviceCheckLists)
                data["serviceCheckLists"].push(item.toJSON());
        }
        if (Array.isArray(this.servicePrices)) {
            data["servicePrices"] = [];
            for (let item of this.servicePrices)
                data["servicePrices"].push(item.toJSON());
        }
        return data;
    }

    clone(): ServiceDto {
        const json = this.toJSON();
        let result = new ServiceDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDto {
    id: number;
    name: string;
    description: string | undefined;
    isGrouped: boolean | undefined;
    groupId: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    supervisorCommissionAmount: number | undefined;
    receptionCommissionAmount: number | undefined;
    serviceSteps: ServiceStepDto[] | undefined;
    serviceCheckLists: ServiceCheckListDto[] | undefined;
    servicePrices: ServicePriceDto[] | undefined;
}

export class ServiceDtoPagedResultDto implements IServiceDtoPagedResultDto {
    items: ServiceDto[] | undefined;
    totalCount: number;

    constructor(data?: IServiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ServiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDtoPagedResultDto {
    items: ServiceDto[] | undefined;
    totalCount: number;
}

export class ServiceEntity implements IServiceEntity {
    id: number;
    name: string;
    description: string | undefined;
    isGrouped: boolean | undefined;
    groupId: number | undefined;
    group: GroupEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    supervisorCommissionAmount: number | undefined;
    receptionCommissionAmount: number | undefined;
    serviceSteps: ServiceStepEntity[] | undefined;
    serviceCheckLists: ServiceCheckListEntity[] | undefined;
    servicePrices: ServicePriceEntity[] | undefined;

    constructor(data?: IServiceEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isGrouped = _data["isGrouped"];
            this.groupId = _data["groupId"];
            this.group = _data["group"] ? GroupEntity.fromJS(_data["group"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.supervisorCommissionAmount = _data["supervisorCommissionAmount"];
            this.receptionCommissionAmount = _data["receptionCommissionAmount"];
            if (Array.isArray(_data["serviceSteps"])) {
                this.serviceSteps = [] as any;
                for (let item of _data["serviceSteps"])
                    this.serviceSteps.push(ServiceStepEntity.fromJS(item));
            }
            if (Array.isArray(_data["serviceCheckLists"])) {
                this.serviceCheckLists = [] as any;
                for (let item of _data["serviceCheckLists"])
                    this.serviceCheckLists.push(ServiceCheckListEntity.fromJS(item));
            }
            if (Array.isArray(_data["servicePrices"])) {
                this.servicePrices = [] as any;
                for (let item of _data["servicePrices"])
                    this.servicePrices.push(ServicePriceEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isGrouped"] = this.isGrouped;
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["supervisorCommissionAmount"] = this.supervisorCommissionAmount;
        data["receptionCommissionAmount"] = this.receptionCommissionAmount;
        if (Array.isArray(this.serviceSteps)) {
            data["serviceSteps"] = [];
            for (let item of this.serviceSteps)
                data["serviceSteps"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceCheckLists)) {
            data["serviceCheckLists"] = [];
            for (let item of this.serviceCheckLists)
                data["serviceCheckLists"].push(item.toJSON());
        }
        if (Array.isArray(this.servicePrices)) {
            data["servicePrices"] = [];
            for (let item of this.servicePrices)
                data["servicePrices"].push(item.toJSON());
        }
        return data;
    }

    clone(): ServiceEntity {
        const json = this.toJSON();
        let result = new ServiceEntity();
        result.init(json);
        return result;
    }
}

export interface IServiceEntity {
    id: number;
    name: string;
    description: string | undefined;
    isGrouped: boolean | undefined;
    groupId: number | undefined;
    group: GroupEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    supervisorCommissionAmount: number | undefined;
    receptionCommissionAmount: number | undefined;
    serviceSteps: ServiceStepEntity[] | undefined;
    serviceCheckLists: ServiceCheckListEntity[] | undefined;
    servicePrices: ServicePriceEntity[] | undefined;
}

export class ServicePriceDto implements IServicePriceDto {
    id: number;
    serviceId: number;
    price: number;
    vehicleTypeId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceName: string | undefined;
    vehicleTypeName: string | undefined;
    priceModel: PriceModel;

    constructor(data?: IServicePriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.price = _data["price"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.serviceName = _data["serviceName"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.priceModel = _data["priceModel"] ? PriceModel.fromJS(_data["priceModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServicePriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["price"] = this.price;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["serviceName"] = this.serviceName;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["priceModel"] = this.priceModel ? this.priceModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServicePriceDto {
        const json = this.toJSON();
        let result = new ServicePriceDto();
        result.init(json);
        return result;
    }
}

export interface IServicePriceDto {
    id: number;
    serviceId: number;
    price: number;
    vehicleTypeId: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    serviceName: string | undefined;
    vehicleTypeName: string | undefined;
    priceModel: PriceModel;
}

export class ServicePriceDtoPagedResultDto implements IServicePriceDtoPagedResultDto {
    items: ServicePriceDto[] | undefined;
    totalCount: number;

    constructor(data?: IServicePriceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ServicePriceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServicePriceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePriceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServicePriceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServicePriceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServicePriceDtoPagedResultDto {
    items: ServicePriceDto[] | undefined;
    totalCount: number;
}

export class ServicePriceEntity implements IServicePriceEntity {
    id: number;
    serviceId: number;
    price: number;
    vehicleTypeId: number;
    service: ServiceEntity;
    vehicleType: VehicleTypeEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: IServicePriceEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.price = _data["price"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
            this.vehicleType = _data["vehicleType"] ? VehicleTypeEntity.fromJS(_data["vehicleType"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ServicePriceEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePriceEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["price"] = this.price;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ServicePriceEntity {
        const json = this.toJSON();
        let result = new ServicePriceEntity();
        result.init(json);
        return result;
    }
}

export interface IServicePriceEntity {
    id: number;
    serviceId: number;
    price: number;
    vehicleTypeId: number;
    service: ServiceEntity;
    vehicleType: VehicleTypeEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class ServiceReportResultDto implements IServiceReportResultDto {
    serviceId: number;
    serviceName: string | undefined;
    totalServiceCount: number;
    totalCarsServed: number;
    vehicleTypeBreakdown: VehicleTypeServiceReportItemDto[] | undefined;

    constructor(data?: IServiceReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.totalServiceCount = _data["totalServiceCount"];
            this.totalCarsServed = _data["totalCarsServed"];
            if (Array.isArray(_data["vehicleTypeBreakdown"])) {
                this.vehicleTypeBreakdown = [] as any;
                for (let item of _data["vehicleTypeBreakdown"])
                    this.vehicleTypeBreakdown.push(VehicleTypeServiceReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["totalServiceCount"] = this.totalServiceCount;
        data["totalCarsServed"] = this.totalCarsServed;
        if (Array.isArray(this.vehicleTypeBreakdown)) {
            data["vehicleTypeBreakdown"] = [];
            for (let item of this.vehicleTypeBreakdown)
                data["vehicleTypeBreakdown"].push(item.toJSON());
        }
        return data;
    }

    clone(): ServiceReportResultDto {
        const json = this.toJSON();
        let result = new ServiceReportResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceReportResultDto {
    serviceId: number;
    serviceName: string | undefined;
    totalServiceCount: number;
    totalCarsServed: number;
    vehicleTypeBreakdown: VehicleTypeServiceReportItemDto[] | undefined;
}

export class ServiceSalesDto implements IServiceSalesDto {
    serviceId: number;
    serviceName: string | undefined;
    serviceTotalSales: number;

    constructor(data?: IServiceSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.serviceTotalSales = _data["serviceTotalSales"];
        }
    }

    static fromJS(data: any): ServiceSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["serviceTotalSales"] = this.serviceTotalSales;
        return data;
    }

    clone(): ServiceSalesDto {
        const json = this.toJSON();
        let result = new ServiceSalesDto();
        result.init(json);
        return result;
    }
}

export interface IServiceSalesDto {
    serviceId: number;
    serviceName: string | undefined;
    serviceTotalSales: number;
}

export class ServiceStepDto implements IServiceStepDto {
    id: number;
    name: string;
    description: string | undefined;
    expectedTime: number | undefined;
    serviceId: number | undefined;
    order: number | undefined;
    commission: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    actualTime: number | undefined;

    constructor(data?: IServiceStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.expectedTime = _data["expectedTime"];
            this.serviceId = _data["serviceId"];
            this.order = _data["order"];
            this.commission = _data["commission"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.actualTime = _data["actualTime"];
        }
    }

    static fromJS(data: any): ServiceStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["expectedTime"] = this.expectedTime;
        data["serviceId"] = this.serviceId;
        data["order"] = this.order;
        data["commission"] = this.commission;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["actualTime"] = this.actualTime;
        return data;
    }

    clone(): ServiceStepDto {
        const json = this.toJSON();
        let result = new ServiceStepDto();
        result.init(json);
        return result;
    }
}

export interface IServiceStepDto {
    id: number;
    name: string;
    description: string | undefined;
    expectedTime: number | undefined;
    serviceId: number | undefined;
    order: number | undefined;
    commission: number | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    startTime: moment.Moment | undefined;
    endTime: moment.Moment | undefined;
    actualTime: number | undefined;
}

export class ServiceStepDtoPagedResultDto implements IServiceStepDtoPagedResultDto {
    items: ServiceStepDto[] | undefined;
    totalCount: number;

    constructor(data?: IServiceStepDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ServiceStepDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceStepDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceStepDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceStepDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceStepDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceStepDtoPagedResultDto {
    items: ServiceStepDto[] | undefined;
    totalCount: number;
}

export class ServiceStepEntity implements IServiceStepEntity {
    id: number;
    name: string;
    description: string | undefined;
    expectedTime: number | undefined;
    serviceId: number | undefined;
    order: number | undefined;
    commission: number | undefined;
    service: ServiceEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: IServiceStepEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.expectedTime = _data["expectedTime"];
            this.serviceId = _data["serviceId"];
            this.order = _data["order"];
            this.commission = _data["commission"];
            this.service = _data["service"] ? ServiceEntity.fromJS(_data["service"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ServiceStepEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceStepEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["expectedTime"] = this.expectedTime;
        data["serviceId"] = this.serviceId;
        data["order"] = this.order;
        data["commission"] = this.commission;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): ServiceStepEntity {
        const json = this.toJSON();
        let result = new ServiceStepEntity();
        result.init(json);
        return result;
    }
}

export interface IServiceStepEntity {
    id: number;
    name: string;
    description: string | undefined;
    expectedTime: number | undefined;
    serviceId: number | undefined;
    order: number | undefined;
    commission: number | undefined;
    service: ServiceEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class ServiceUsageReportItemDto implements IServiceUsageReportItemDto {
    rank: number;
    id: number;
    name: string | undefined;
    phoneNumber: string | undefined;
    usageCount: number;
    customerCount: number;
    percentage: number;

    constructor(data?: IServiceUsageReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.usageCount = _data["usageCount"];
            this.customerCount = _data["customerCount"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): ServiceUsageReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUsageReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["id"] = this.id;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["usageCount"] = this.usageCount;
        data["customerCount"] = this.customerCount;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): ServiceUsageReportItemDto {
        const json = this.toJSON();
        let result = new ServiceUsageReportItemDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUsageReportItemDto {
    rank: number;
    id: number;
    name: string | undefined;
    phoneNumber: string | undefined;
    usageCount: number;
    customerCount: number;
    percentage: number;
}

export class ServiceUsageReportResultDto implements IServiceUsageReportResultDto {
    isFilteredByService: boolean;
    serviceName: string | undefined;
    totalServices: number;
    totalCustomers: number;
    totalUsageCount: number;
    breakdown: ServiceUsageReportItemDto[] | undefined;

    constructor(data?: IServiceUsageReportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFilteredByService = _data["isFilteredByService"];
            this.serviceName = _data["serviceName"];
            this.totalServices = _data["totalServices"];
            this.totalCustomers = _data["totalCustomers"];
            this.totalUsageCount = _data["totalUsageCount"];
            if (Array.isArray(_data["breakdown"])) {
                this.breakdown = [] as any;
                for (let item of _data["breakdown"])
                    this.breakdown.push(ServiceUsageReportItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceUsageReportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUsageReportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFilteredByService"] = this.isFilteredByService;
        data["serviceName"] = this.serviceName;
        data["totalServices"] = this.totalServices;
        data["totalCustomers"] = this.totalCustomers;
        data["totalUsageCount"] = this.totalUsageCount;
        if (Array.isArray(this.breakdown)) {
            data["breakdown"] = [];
            for (let item of this.breakdown)
                data["breakdown"].push(item.toJSON());
        }
        return data;
    }

    clone(): ServiceUsageReportResultDto {
        const json = this.toJSON();
        let result = new ServiceUsageReportResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUsageReportResultDto {
    isFilteredByService: boolean;
    serviceName: string | undefined;
    totalServices: number;
    totalCustomers: number;
    totalUsageCount: number;
    breakdown: ServiceUsageReportItemDto[] | undefined;
}

export class Setting implements ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export class ShiftDto implements IShiftDto {
    id: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    isActive: boolean;
    totalBills: number;
    totalIncome: number;
    totalExpenses: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    userFullName: string | undefined;
    hoursWorked: number | undefined;

    constructor(data?: IShiftDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.totalBills = _data["totalBills"];
            this.totalIncome = _data["totalIncome"];
            this.totalExpenses = _data["totalExpenses"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.userFullName = _data["userFullName"];
            this.hoursWorked = _data["hoursWorked"];
        }
    }

    static fromJS(data: any): ShiftDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["totalBills"] = this.totalBills;
        data["totalIncome"] = this.totalIncome;
        data["totalExpenses"] = this.totalExpenses;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["userFullName"] = this.userFullName;
        data["hoursWorked"] = this.hoursWorked;
        return data;
    }

    clone(): ShiftDto {
        const json = this.toJSON();
        let result = new ShiftDto();
        result.init(json);
        return result;
    }
}

export interface IShiftDto {
    id: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    isActive: boolean;
    totalBills: number;
    totalIncome: number;
    totalExpenses: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    userFullName: string | undefined;
    hoursWorked: number | undefined;
}

export class ShiftDtoPagedResultDto implements IShiftDtoPagedResultDto {
    items: ShiftDto[] | undefined;
    totalCount: number;

    constructor(data?: IShiftDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(ShiftDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ShiftDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ShiftDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ShiftDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IShiftDtoPagedResultDto {
    items: ShiftDto[] | undefined;
    totalCount: number;
}

export class ShiftEntity implements IShiftEntity {
    id: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    isActive: boolean;
    totalBills: number;
    totalIncome: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    user: User;
    bills: BillEntity[] | undefined;
    transactions: TransactionEntity[] | undefined;

    constructor(data?: IShiftEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.totalBills = _data["totalBills"];
            this.totalIncome = _data["totalIncome"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["bills"])) {
                this.bills = [] as any;
                for (let item of _data["bills"])
                    this.bills.push(BillEntity.fromJS(item));
            }
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions.push(TransactionEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShiftEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["totalBills"] = this.totalBills;
        data["totalIncome"] = this.totalIncome;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.bills)) {
            data["bills"] = [];
            for (let item of this.bills)
                data["bills"].push(item.toJSON());
        }
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data;
    }

    clone(): ShiftEntity {
        const json = this.toJSON();
        let result = new ShiftEntity();
        result.init(json);
        return result;
    }
}

export interface IShiftEntity {
    id: number;
    startTime: moment.Moment;
    endTime: moment.Moment | undefined;
    isActive: boolean;
    totalBills: number;
    totalIncome: number;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    user: User;
    bills: BillEntity[] | undefined;
    transactions: TransactionEntity[] | undefined;
}

export class SpecialPackageTypeDto implements ISpecialPackageTypeDto {
    id: number;
    name: string;
    isActive: boolean;

    constructor(data?: ISpecialPackageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SpecialPackageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialPackageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): SpecialPackageTypeDto {
        const json = this.toJSON();
        let result = new SpecialPackageTypeDto();
        result.init(json);
        return result;
    }
}

export interface ISpecialPackageTypeDto {
    id: number;
    name: string;
    isActive: boolean;
}

export class SpecialPackageTypeEntity implements ISpecialPackageTypeEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;

    constructor(data?: ISpecialPackageTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): SpecialPackageTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialPackageTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): SpecialPackageTypeEntity {
        const json = this.toJSON();
        let result = new SpecialPackageTypeEntity();
        result.init(json);
        return result;
    }
}

export interface ISpecialPackageTypeEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isActive: boolean;
}

export class StepCommissionItemDto implements IStepCommissionItemDto {
    billId: number;
    serviceName: string | undefined;
    stepName: string | undefined;
    commission: number;
    employeesOnStep: number;
    completedAt: moment.Moment;

    constructor(data?: IStepCommissionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billId = _data["billId"];
            this.serviceName = _data["serviceName"];
            this.stepName = _data["stepName"];
            this.commission = _data["commission"];
            this.employeesOnStep = _data["employeesOnStep"];
            this.completedAt = _data["completedAt"] ? moment(_data["completedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): StepCommissionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new StepCommissionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["serviceName"] = this.serviceName;
        data["stepName"] = this.stepName;
        data["commission"] = this.commission;
        data["employeesOnStep"] = this.employeesOnStep;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): StepCommissionItemDto {
        const json = this.toJSON();
        let result = new StepCommissionItemDto();
        result.init(json);
        return result;
    }
}

export interface IStepCommissionItemDto {
    billId: number;
    serviceName: string | undefined;
    stepName: string | undefined;
    commission: number;
    employeesOnStep: number;
    completedAt: moment.Moment;
}

export enum StepStatus {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class SubscriptionCustomersReportDto implements ISubscriptionCustomersReportDto {
    id: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    packageName: string | undefined;
    price: number;
    startDate: moment.Moment;
    endDate: moment.Moment;

    constructor(data?: ISubscriptionCustomersReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.packageName = _data["packageName"];
            this.price = _data["price"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SubscriptionCustomersReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionCustomersReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["packageName"] = this.packageName;
        data["price"] = this.price;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): SubscriptionCustomersReportDto {
        const json = this.toJSON();
        let result = new SubscriptionCustomersReportDto();
        result.init(json);
        return result;
    }
}

export interface ISubscriptionCustomersReportDto {
    id: number;
    customerName: string | undefined;
    phoneNumber: string | undefined;
    packageName: string | undefined;
    price: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
}

export class SupervisorCommissionItemDto implements ISupervisorCommissionItemDto {
    billId: number;
    serviceName: string | undefined;
    supervisorCommission: number;
    finishedAt: moment.Moment;

    constructor(data?: ISupervisorCommissionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billId = _data["billId"];
            this.serviceName = _data["serviceName"];
            this.supervisorCommission = _data["supervisorCommission"];
            this.finishedAt = _data["finishedAt"] ? moment(_data["finishedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SupervisorCommissionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupervisorCommissionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billId"] = this.billId;
        data["serviceName"] = this.serviceName;
        data["supervisorCommission"] = this.supervisorCommission;
        data["finishedAt"] = this.finishedAt ? this.finishedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): SupervisorCommissionItemDto {
        const json = this.toJSON();
        let result = new SupervisorCommissionItemDto();
        result.init(json);
        return result;
    }
}

export interface ISupervisorCommissionItemDto {
    billId: number;
    serviceName: string | undefined;
    supervisorCommission: number;
    finishedAt: moment.Moment;
}

export class TargetDto implements ITargetDto {
    id: number;
    groupId: number;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    readonly total: number;

    constructor(data?: ITargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.year = _data["year"];
            this.january = _data["january"];
            this.february = _data["february"];
            this.march = _data["march"];
            this.april = _data["april"];
            this.may = _data["may"];
            this.june = _data["june"];
            this.july = _data["july"];
            this.august = _data["august"];
            this.september = _data["september"];
            this.october = _data["october"];
            this.november = _data["november"];
            this.december = _data["december"];
            (<any>this).total = _data["total"];
        }
    }

    static fromJS(data: any): TargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["year"] = this.year;
        data["january"] = this.january;
        data["february"] = this.february;
        data["march"] = this.march;
        data["april"] = this.april;
        data["may"] = this.may;
        data["june"] = this.june;
        data["july"] = this.july;
        data["august"] = this.august;
        data["september"] = this.september;
        data["october"] = this.october;
        data["november"] = this.november;
        data["december"] = this.december;
        data["total"] = this.total;
        return data;
    }

    clone(): TargetDto {
        const json = this.toJSON();
        let result = new TargetDto();
        result.init(json);
        return result;
    }
}

export interface ITargetDto {
    id: number;
    groupId: number;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    total: number;
}

export class TargetDtoPagedResultDto implements ITargetDtoPagedResultDto {
    items: TargetDto[] | undefined;
    totalCount: number;

    constructor(data?: ITargetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TargetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TargetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TargetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TargetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITargetDtoPagedResultDto {
    items: TargetDto[] | undefined;
    totalCount: number;
}

export class TargetInfoDto implements ITargetInfoDto {
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    total: number;

    constructor(data?: ITargetInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.january = _data["january"];
            this.february = _data["february"];
            this.march = _data["march"];
            this.april = _data["april"];
            this.may = _data["may"];
            this.june = _data["june"];
            this.july = _data["july"];
            this.august = _data["august"];
            this.september = _data["september"];
            this.october = _data["october"];
            this.november = _data["november"];
            this.december = _data["december"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): TargetInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["january"] = this.january;
        data["february"] = this.february;
        data["march"] = this.march;
        data["april"] = this.april;
        data["may"] = this.may;
        data["june"] = this.june;
        data["july"] = this.july;
        data["august"] = this.august;
        data["september"] = this.september;
        data["october"] = this.october;
        data["november"] = this.november;
        data["december"] = this.december;
        data["total"] = this.total;
        return data;
    }

    clone(): TargetInfoDto {
        const json = this.toJSON();
        let result = new TargetInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITargetInfoDto {
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    total: number;
}

export class TargetSettingsDto implements ITargetSettingsDto {
    id: number;
    groupId: number;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    readonly total: number;

    constructor(data?: ITargetSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.year = _data["year"];
            this.january = _data["january"];
            this.february = _data["february"];
            this.march = _data["march"];
            this.april = _data["april"];
            this.may = _data["may"];
            this.june = _data["june"];
            this.july = _data["july"];
            this.august = _data["august"];
            this.september = _data["september"];
            this.october = _data["october"];
            this.november = _data["november"];
            this.december = _data["december"];
            (<any>this).total = _data["total"];
        }
    }

    static fromJS(data: any): TargetSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["year"] = this.year;
        data["january"] = this.january;
        data["february"] = this.february;
        data["march"] = this.march;
        data["april"] = this.april;
        data["may"] = this.may;
        data["june"] = this.june;
        data["july"] = this.july;
        data["august"] = this.august;
        data["september"] = this.september;
        data["october"] = this.october;
        data["november"] = this.november;
        data["december"] = this.december;
        data["total"] = this.total;
        return data;
    }

    clone(): TargetSettingsDto {
        const json = this.toJSON();
        let result = new TargetSettingsDto();
        result.init(json);
        return result;
    }
}

export interface ITargetSettingsDto {
    id: number;
    groupId: number;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    total: number;
}

export class TargetSettingsDtoPagedResultDto implements ITargetSettingsDtoPagedResultDto {
    items: TargetSettingsDto[] | undefined;
    totalCount: number;

    constructor(data?: ITargetSettingsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TargetSettingsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TargetSettingsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TargetSettingsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TargetSettingsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TargetSettingsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITargetSettingsDtoPagedResultDto {
    items: TargetSettingsDto[] | undefined;
    totalCount: number;
}

export class TargetSettingsEntity implements ITargetSettingsEntity {
    id: number;
    groupId: number;
    group: GroupEntity;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    readonly total: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ITargetSettingsEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupId = _data["groupId"];
            this.group = _data["group"] ? GroupEntity.fromJS(_data["group"]) : <any>undefined;
            this.year = _data["year"];
            this.january = _data["january"];
            this.february = _data["february"];
            this.march = _data["march"];
            this.april = _data["april"];
            this.may = _data["may"];
            this.june = _data["june"];
            this.july = _data["july"];
            this.august = _data["august"];
            this.september = _data["september"];
            this.october = _data["october"];
            this.november = _data["november"];
            this.december = _data["december"];
            (<any>this).total = _data["total"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TargetSettingsEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TargetSettingsEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["year"] = this.year;
        data["january"] = this.january;
        data["february"] = this.february;
        data["march"] = this.march;
        data["april"] = this.april;
        data["may"] = this.may;
        data["june"] = this.june;
        data["july"] = this.july;
        data["august"] = this.august;
        data["september"] = this.september;
        data["october"] = this.october;
        data["november"] = this.november;
        data["december"] = this.december;
        data["total"] = this.total;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): TargetSettingsEntity {
        const json = this.toJSON();
        let result = new TargetSettingsEntity();
        result.init(json);
        return result;
    }
}

export interface ITargetSettingsEntity {
    id: number;
    groupId: number;
    group: GroupEntity;
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    total: number;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TimeSpan implements ITimeSpan {
    ticks: number;
    days: number;
    hours: number;
    milliseconds: number;
    minutes: number;
    seconds: number;
    readonly totalDays: number;
    readonly totalHours: number;
    readonly totalMilliseconds: number;
    readonly totalMinutes: number;
    readonly totalSeconds: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            this.days = _data["days"];
            this.hours = _data["hours"];
            this.milliseconds = _data["milliseconds"];
            this.minutes = _data["minutes"];
            this.seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }

    clone(): TimeSpan {
        const json = this.toJSON();
        let result = new TimeSpan();
        result.init(json);
        return result;
    }
}

export interface ITimeSpan {
    ticks: number;
    days: number;
    hours: number;
    milliseconds: number;
    minutes: number;
    seconds: number;
    totalDays: number;
    totalHours: number;
    totalMilliseconds: number;
    totalMinutes: number;
    totalSeconds: number;
}

export class TransactionDto implements ITransactionDto {
    id: number;
    billId: number | undefined;
    paidValue: number;
    changeValue: number;
    shiftId: number | undefined;
    paymentMethodId: number;
    note: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isInput: boolean;
    paymentMethod: PaymentMethodEntity;
    user: User;

    constructor(data?: ITransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billId = _data["billId"];
            this.paidValue = _data["paidValue"];
            this.changeValue = _data["changeValue"];
            this.shiftId = _data["shiftId"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.note = _data["note"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.isInput = _data["isInput"];
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodEntity.fromJS(_data["paymentMethod"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billId"] = this.billId;
        data["paidValue"] = this.paidValue;
        data["changeValue"] = this.changeValue;
        data["shiftId"] = this.shiftId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["note"] = this.note;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["isInput"] = this.isInput;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): TransactionDto {
        const json = this.toJSON();
        let result = new TransactionDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDto {
    id: number;
    billId: number | undefined;
    paidValue: number;
    changeValue: number;
    shiftId: number | undefined;
    paymentMethodId: number;
    note: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    isInput: boolean;
    paymentMethod: PaymentMethodEntity;
    user: User;
}

export class TransactionDtoPagedResultDto implements ITransactionDtoPagedResultDto {
    items: TransactionDto[] | undefined;
    totalCount: number;

    constructor(data?: ITransactionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(TransactionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TransactionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TransactionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TransactionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionDtoPagedResultDto {
    items: TransactionDto[] | undefined;
    totalCount: number;
}

export class TransactionEntity implements ITransactionEntity {
    id: number;
    billId: number | undefined;
    paidValue: number;
    changeValue: number;
    shiftId: number | undefined;
    transactionItemId: number | undefined;
    paymentMethodId: number;
    isInput: boolean;
    note: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    bill: BillEntity;
    paymentMethod: PaymentMethodEntity;
    user: User;
    shift: ShiftEntity;
    transactionItem: TransactionItemEntity;

    constructor(data?: ITransactionEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.billId = _data["billId"];
            this.paidValue = _data["paidValue"];
            this.changeValue = _data["changeValue"];
            this.shiftId = _data["shiftId"];
            this.transactionItemId = _data["transactionItemId"];
            this.paymentMethodId = _data["paymentMethodId"];
            this.isInput = _data["isInput"];
            this.note = _data["note"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.bill = _data["bill"] ? BillEntity.fromJS(_data["bill"]) : <any>undefined;
            this.paymentMethod = _data["paymentMethod"] ? PaymentMethodEntity.fromJS(_data["paymentMethod"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.shift = _data["shift"] ? ShiftEntity.fromJS(_data["shift"]) : <any>undefined;
            this.transactionItem = _data["transactionItem"] ? TransactionItemEntity.fromJS(_data["transactionItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransactionEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["billId"] = this.billId;
        data["paidValue"] = this.paidValue;
        data["changeValue"] = this.changeValue;
        data["shiftId"] = this.shiftId;
        data["transactionItemId"] = this.transactionItemId;
        data["paymentMethodId"] = this.paymentMethodId;
        data["isInput"] = this.isInput;
        data["note"] = this.note;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["bill"] = this.bill ? this.bill.toJSON() : <any>undefined;
        data["paymentMethod"] = this.paymentMethod ? this.paymentMethod.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["transactionItem"] = this.transactionItem ? this.transactionItem.toJSON() : <any>undefined;
        return data;
    }

    clone(): TransactionEntity {
        const json = this.toJSON();
        let result = new TransactionEntity();
        result.init(json);
        return result;
    }
}

export interface ITransactionEntity {
    id: number;
    billId: number | undefined;
    paidValue: number;
    changeValue: number;
    shiftId: number | undefined;
    transactionItemId: number | undefined;
    paymentMethodId: number;
    isInput: boolean;
    note: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    bill: BillEntity;
    paymentMethod: PaymentMethodEntity;
    user: User;
    shift: ShiftEntity;
    transactionItem: TransactionItemEntity;
}

export class TransactionItemEntity implements ITransactionItemEntity {
    id: number;
    itemTitle: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: ITransactionItemEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemTitle = _data["itemTitle"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TransactionItemEntity {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionItemEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemTitle"] = this.itemTitle;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): TransactionItemEntity {
        const json = this.toJSON();
        let result = new TransactionItemEntity();
        result.init(json);
        return result;
    }
}

export interface ITransactionItemEntity {
    id: number;
    itemTitle: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class User implements IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : <any>undefined;
            this.authenticationSource = _data["authenticationSource"];
            this.userName = _data["userName"];
            this.tenantId = _data["tenantId"];
            this.emailAddress = _data["emailAddress"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            (<any>this).fullName = _data["fullName"];
            this.password = _data["password"];
            this.emailConfirmationCode = _data["emailConfirmationCode"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            this.accessFailedCount = _data["accessFailedCount"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.securityStamp = _data["securityStamp"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            if (Array.isArray(_data["logins"])) {
                this.logins = [] as any;
                for (let item of _data["logins"])
                    this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data["settings"])) {
                this.settings = [] as any;
                for (let item of _data["settings"])
                    this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.isActive = _data["isActive"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.normalizedEmailAddress = _data["normalizedEmailAddress"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            if (Array.isArray(_data["tokens"])) {
                this.tokens = [] as any;
                for (let item of _data["tokens"])
                    this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data["deleterUser"] ? User.fromJS(_data["deleterUser"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? User.fromJS(_data["creatorUser"]) : <any>undefined;
            this.lastModifierUser = _data["lastModifierUser"] ? User.fromJS(_data["lastModifierUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["userName"] = this.userName;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data["logins"] = [];
            for (let item of this.logins)
                data["logins"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data["settings"] = [];
            for (let item of this.settings)
                data["settings"].push(item.toJSON());
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["normalizedUserName"] = this.normalizedUserName;
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data["tokens"] = [];
            for (let item of this.tokens)
                data["tokens"].push(item.toJSON());
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        return data;
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    userName: string;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedUserName: string;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
}

export class UserClaim implements IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.claimType = _data["claimType"];
            this.claimValue = _data["claimValue"];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    }

    clone(): UserClaim {
        const json = this.toJSON();
        let result = new UserClaim();
        result.init(json);
        return result;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserDto implements IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.isActive = _data["isActive"];
            this.fullName = _data["fullName"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["isActive"] = this.isActive;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
    isActive: boolean;
    fullName: string | undefined;
    lastLoginTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    roleNames: string[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserLogin implements IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.providerKey = _data["providerKey"];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        return data;
    }

    clone(): UserLogin {
        const json = this.toJSON();
        let result = new UserLogin();
        result.init(json);
        return result;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.isGranted = _data["isGranted"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserPermissionSetting {
        const json = this.toJSON();
        let result = new UserPermissionSetting();
        result.init(json);
        return result;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        return data;
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserToken implements IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.loginProvider = _data["loginProvider"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserToken {
        const json = this.toJSON();
        let result = new UserToken();
        result.init(json);
        return result;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class VehicleDto implements IVehicleDto {
    id: number;
    customerId: number;
    yearOfManufacture: string | undefined;
    licencePlate: string;
    emirate: EmiratesEnum;
    color: string | undefined;
    carBrandId: number;
    carBrandName: string | undefined;
    carModelId: number | undefined;
    carModelName: string | undefined;
    vehicleTypeID: number;
    vehicleTypeName: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    customerName: string | undefined;
    customerPhone: string | undefined;
    packageName: string | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.yearOfManufacture = _data["yearOfManufacture"];
            this.licencePlate = _data["licencePlate"];
            this.emirate = _data["emirate"];
            this.color = _data["color"];
            this.carBrandId = _data["carBrandId"];
            this.carBrandName = _data["carBrandName"];
            this.carModelId = _data["carModelId"];
            this.carModelName = _data["carModelName"];
            this.vehicleTypeID = _data["vehicleTypeID"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.customerName = _data["customerName"];
            this.customerPhone = _data["customerPhone"];
            this.packageName = _data["packageName"];
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["yearOfManufacture"] = this.yearOfManufacture;
        data["licencePlate"] = this.licencePlate;
        data["emirate"] = this.emirate;
        data["color"] = this.color;
        data["carBrandId"] = this.carBrandId;
        data["carBrandName"] = this.carBrandName;
        data["carModelId"] = this.carModelId;
        data["carModelName"] = this.carModelName;
        data["vehicleTypeID"] = this.vehicleTypeID;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["customerName"] = this.customerName;
        data["customerPhone"] = this.customerPhone;
        data["packageName"] = this.packageName;
        return data;
    }

    clone(): VehicleDto {
        const json = this.toJSON();
        let result = new VehicleDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleDto {
    id: number;
    customerId: number;
    yearOfManufacture: string | undefined;
    licencePlate: string;
    emirate: EmiratesEnum;
    color: string | undefined;
    carBrandId: number;
    carBrandName: string | undefined;
    carModelId: number | undefined;
    carModelName: string | undefined;
    vehicleTypeID: number;
    vehicleTypeName: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    customerName: string | undefined;
    customerPhone: string | undefined;
    packageName: string | undefined;
}

export class VehicleDtoPagedResultDto implements IVehicleDtoPagedResultDto {
    items: VehicleDto[] | undefined;
    totalCount: number;

    constructor(data?: IVehicleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VehicleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VehicleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VehicleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VehicleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleDtoPagedResultDto {
    items: VehicleDto[] | undefined;
    totalCount: number;
}

export class VehicleEntity implements IVehicleEntity {
    id: number;
    customerId: number;
    customer: CustomerEntity;
    yearOfManufacture: string | undefined;
    licencePlate: string;
    emirate: EmiratesEnum;
    color: string | undefined;
    vehicleTypeId: number;
    vehicleType: VehicleTypeEntity;
    carBrandId: number;
    carBrand: CarBrandEntity;
    carModelId: number | undefined;
    carModel: CarModelEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;

    constructor(data?: IVehicleEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.customer = _data["customer"] ? CustomerEntity.fromJS(_data["customer"]) : <any>undefined;
            this.yearOfManufacture = _data["yearOfManufacture"];
            this.licencePlate = _data["licencePlate"];
            this.emirate = _data["emirate"];
            this.color = _data["color"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleType = _data["vehicleType"] ? VehicleTypeEntity.fromJS(_data["vehicleType"]) : <any>undefined;
            this.carBrandId = _data["carBrandId"];
            this.carBrand = _data["carBrand"] ? CarBrandEntity.fromJS(_data["carBrand"]) : <any>undefined;
            this.carModelId = _data["carModelId"];
            this.carModel = _data["carModel"] ? CarModelEntity.fromJS(_data["carModel"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): VehicleEntity {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["yearOfManufacture"] = this.yearOfManufacture;
        data["licencePlate"] = this.licencePlate;
        data["emirate"] = this.emirate;
        data["color"] = this.color;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : <any>undefined;
        data["carBrandId"] = this.carBrandId;
        data["carBrand"] = this.carBrand ? this.carBrand.toJSON() : <any>undefined;
        data["carModelId"] = this.carModelId;
        data["carModel"] = this.carModel ? this.carModel.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }

    clone(): VehicleEntity {
        const json = this.toJSON();
        let result = new VehicleEntity();
        result.init(json);
        return result;
    }
}

export interface IVehicleEntity {
    id: number;
    customerId: number;
    customer: CustomerEntity;
    yearOfManufacture: string | undefined;
    licencePlate: string;
    emirate: EmiratesEnum;
    color: string | undefined;
    vehicleTypeId: number;
    vehicleType: VehicleTypeEntity;
    carBrandId: number;
    carBrand: CarBrandEntity;
    carModelId: number | undefined;
    carModel: CarModelEntity;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
}

export class VehicleListResultDto implements IVehicleListResultDto {
    items: VehicleDto[] | undefined;
    totalCount: number;
    customerList: CustomerStatsDto[] | undefined;

    constructor(data?: IVehicleListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(VehicleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["customerList"])) {
                this.customerList = [] as any;
                for (let item of _data["customerList"])
                    this.customerList.push(CustomerStatsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.customerList)) {
            data["customerList"] = [];
            for (let item of this.customerList)
                data["customerList"].push(item.toJSON());
        }
        return data;
    }

    clone(): VehicleListResultDto {
        const json = this.toJSON();
        let result = new VehicleListResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleListResultDto {
    items: VehicleDto[] | undefined;
    totalCount: number;
    customerList: CustomerStatsDto[] | undefined;
}

export class VehicleSalesPerBrandDto implements IVehicleSalesPerBrandDto {
    vehicleBrandId: number;
    vehicleBrand: string | undefined;
    totalSales: number;

    constructor(data?: IVehicleSalesPerBrandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleBrandId = _data["vehicleBrandId"];
            this.vehicleBrand = _data["vehicleBrand"];
            this.totalSales = _data["totalSales"];
        }
    }

    static fromJS(data: any): VehicleSalesPerBrandDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleSalesPerBrandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleBrandId"] = this.vehicleBrandId;
        data["vehicleBrand"] = this.vehicleBrand;
        data["totalSales"] = this.totalSales;
        return data;
    }

    clone(): VehicleSalesPerBrandDto {
        const json = this.toJSON();
        let result = new VehicleSalesPerBrandDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleSalesPerBrandDto {
    vehicleBrandId: number;
    vehicleBrand: string | undefined;
    totalSales: number;
}

export class VehiclesCustomerReportDto implements IVehiclesCustomerReportDto {
    customerName: string | undefined;
    phoneNumber: string | undefined;
    carBrandAndModel: string | undefined;
    yearOfManufacture: string | undefined;
    color: string | undefined;
    vehicleType: string | undefined;
    emirate: string | undefined;
    licencePlate: string | undefined;

    constructor(data?: IVehiclesCustomerReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.phoneNumber = _data["phoneNumber"];
            this.carBrandAndModel = _data["carBrandAndModel"];
            this.yearOfManufacture = _data["yearOfManufacture"];
            this.color = _data["color"];
            this.vehicleType = _data["vehicleType"];
            this.emirate = _data["emirate"];
            this.licencePlate = _data["licencePlate"];
        }
    }

    static fromJS(data: any): VehiclesCustomerReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehiclesCustomerReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["phoneNumber"] = this.phoneNumber;
        data["carBrandAndModel"] = this.carBrandAndModel;
        data["yearOfManufacture"] = this.yearOfManufacture;
        data["color"] = this.color;
        data["vehicleType"] = this.vehicleType;
        data["emirate"] = this.emirate;
        data["licencePlate"] = this.licencePlate;
        return data;
    }

    clone(): VehiclesCustomerReportDto {
        const json = this.toJSON();
        let result = new VehiclesCustomerReportDto();
        result.init(json);
        return result;
    }
}

export interface IVehiclesCustomerReportDto {
    customerName: string | undefined;
    phoneNumber: string | undefined;
    carBrandAndModel: string | undefined;
    yearOfManufacture: string | undefined;
    color: string | undefined;
    vehicleType: string | undefined;
    emirate: string | undefined;
    licencePlate: string | undefined;
}

export class VehicleTypeDto implements IVehicleTypeDto {
    id: number;
    name: string | undefined;

    constructor(data?: IVehicleTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VehicleTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): VehicleTypeDto {
        const json = this.toJSON();
        let result = new VehicleTypeDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleTypeDto {
    id: number;
    name: string | undefined;
}

export class VehicleTypeEntity implements IVehicleTypeEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    vehicles: VehicleEntity[] | undefined;

    constructor(data?: IVehicleTypeEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["vehicles"])) {
                this.vehicles = [] as any;
                for (let item of _data["vehicles"])
                    this.vehicles.push(VehicleEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleTypeEntity {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.vehicles)) {
            data["vehicles"] = [];
            for (let item of this.vehicles)
                data["vehicles"].push(item.toJSON());
        }
        return data;
    }

    clone(): VehicleTypeEntity {
        const json = this.toJSON();
        let result = new VehicleTypeEntity();
        result.init(json);
        return result;
    }
}

export interface IVehicleTypeEntity {
    id: number;
    name: string;
    creatorUserId: number;
    creationTime: moment.Moment;
    lastModifierUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    isDeleted: boolean;
    vehicles: VehicleEntity[] | undefined;
}

export class VehicleTypesDto implements IVehicleTypesDto {
    vehicleTypeId: number;
    vehicleTypeName: string | undefined;
    vehicleCount: number;

    constructor(data?: IVehicleTypesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.vehicleCount = _data["vehicleCount"];
        }
    }

    static fromJS(data: any): VehicleTypesDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["vehicleCount"] = this.vehicleCount;
        return data;
    }

    clone(): VehicleTypesDto {
        const json = this.toJSON();
        let result = new VehicleTypesDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleTypesDto {
    vehicleTypeId: number;
    vehicleTypeName: string | undefined;
    vehicleCount: number;
}

export class VehicleTypeServiceReportItemDto implements IVehicleTypeServiceReportItemDto {
    rank: number;
    vehicleTypeId: number;
    vehicleTypeName: string | undefined;
    serviceCount: number;
    percentage: number;

    constructor(data?: IVehicleTypeServiceReportItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data["rank"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.serviceCount = _data["serviceCount"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): VehicleTypeServiceReportItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleTypeServiceReportItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rank"] = this.rank;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["serviceCount"] = this.serviceCount;
        data["percentage"] = this.percentage;
        return data;
    }

    clone(): VehicleTypeServiceReportItemDto {
        const json = this.toJSON();
        let result = new VehicleTypeServiceReportItemDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleTypeServiceReportItemDto {
    rank: number;
    vehicleTypeId: number;
    vehicleTypeName: string | undefined;
    serviceCount: number;
    percentage: number;
}

export enum WeekDays {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
}

export class WhatsappComponent implements IWhatsappComponent {
    type: string | undefined;
    parameters: WhatsappParameter[] | undefined;

    constructor(data?: IWhatsappComponent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters.push(WhatsappParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WhatsappComponent {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsappComponent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        return data;
    }

    clone(): WhatsappComponent {
        const json = this.toJSON();
        let result = new WhatsappComponent();
        result.init(json);
        return result;
    }
}

export interface IWhatsappComponent {
    type: string | undefined;
    parameters: WhatsappParameter[] | undefined;
}

export class WhatsappMessageDto implements IWhatsappMessageDto {
    id: number;
    title: string | undefined;
    message: string | undefined;

    constructor(data?: IWhatsappMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WhatsappMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsappMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["message"] = this.message;
        return data;
    }

    clone(): WhatsappMessageDto {
        const json = this.toJSON();
        let result = new WhatsappMessageDto();
        result.init(json);
        return result;
    }
}

export interface IWhatsappMessageDto {
    id: number;
    title: string | undefined;
    message: string | undefined;
}

export class WhatsappMessageDtoPagedResultDto implements IWhatsappMessageDtoPagedResultDto {
    items: WhatsappMessageDto[] | undefined;
    totalCount: number;

    constructor(data?: IWhatsappMessageDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items.push(WhatsappMessageDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WhatsappMessageDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsappMessageDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WhatsappMessageDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WhatsappMessageDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWhatsappMessageDtoPagedResultDto {
    items: WhatsappMessageDto[] | undefined;
    totalCount: number;
}

export class WhatsappParameter implements IWhatsappParameter {
    type: string | undefined;
    text: string | undefined;

    constructor(data?: IWhatsappParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): WhatsappParameter {
        data = typeof data === 'object' ? data : {};
        let result = new WhatsappParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["text"] = this.text;
        return data;
    }

    clone(): WhatsappParameter {
        const json = this.toJSON();
        let result = new WhatsappParameter();
        result.init(json);
        return result;
    }
}

export interface IWhatsappParameter {
    type: string | undefined;
    text: string | undefined;
}

export class YearlySalesStatsDto implements IYearlySalesStatsDto {
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    total: number;

    constructor(data?: IYearlySalesStatsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.january = _data["january"];
            this.february = _data["february"];
            this.march = _data["march"];
            this.april = _data["april"];
            this.may = _data["may"];
            this.june = _data["june"];
            this.july = _data["july"];
            this.august = _data["august"];
            this.september = _data["september"];
            this.october = _data["october"];
            this.november = _data["november"];
            this.december = _data["december"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): YearlySalesStatsDto {
        data = typeof data === 'object' ? data : {};
        let result = new YearlySalesStatsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["january"] = this.january;
        data["february"] = this.february;
        data["march"] = this.march;
        data["april"] = this.april;
        data["may"] = this.may;
        data["june"] = this.june;
        data["july"] = this.july;
        data["august"] = this.august;
        data["september"] = this.september;
        data["october"] = this.october;
        data["november"] = this.november;
        data["december"] = this.december;
        data["total"] = this.total;
        return data;
    }

    clone(): YearlySalesStatsDto {
        const json = this.toJSON();
        let result = new YearlySalesStatsDto();
        result.init(json);
        return result;
    }
}

export interface IYearlySalesStatsDto {
    year: number;
    january: number;
    february: number;
    march: number;
    april: number;
    may: number;
    june: number;
    july: number;
    august: number;
    september: number;
    october: number;
    november: number;
    december: number;
    total: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}